import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  date: any;
  geography: any;
  geometry: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: Scalars['String'];
  checkUserExists?: Maybe<Scalars['Boolean']>;
  createUser?: Maybe<Scalars['Boolean']>;
  /** delete data from the table: "change_email_otp" */
  delete_change_email_otp?: Maybe<Change_Email_Otp_Mutation_Response>;
  /** delete single row from the table: "change_email_otp" */
  delete_change_email_otp_by_pk?: Maybe<Change_Email_Otp>;
  /** delete data from the table: "comments" */
  delete_comments?: Maybe<Comments_Mutation_Response>;
  /** delete single row from the table: "comments" */
  delete_comments_by_pk?: Maybe<Comments>;
  /** delete data from the table: "districts" */
  delete_districts?: Maybe<Districts_Mutation_Response>;
  /** delete single row from the table: "districts" */
  delete_districts_by_pk?: Maybe<Districts>;
  /** delete data from the table: "expressions" */
  delete_expressions?: Maybe<Expressions_Mutation_Response>;
  /** delete single row from the table: "expressions" */
  delete_expressions_by_pk?: Maybe<Expressions>;
  /** delete data from the table: "file_upload_parameters" */
  delete_file_upload_parameters?: Maybe<File_Upload_Parameters_Mutation_Response>;
  /** delete single row from the table: "file_upload_parameters" */
  delete_file_upload_parameters_by_pk?: Maybe<File_Upload_Parameters>;
  /** delete data from the table: "file_upload_types" */
  delete_file_upload_types?: Maybe<File_Upload_Types_Mutation_Response>;
  /** delete single row from the table: "file_upload_types" */
  delete_file_upload_types_by_pk?: Maybe<File_Upload_Types>;
  /** delete data from the table: "investment_types" */
  delete_investment_types?: Maybe<Investment_Types_Mutation_Response>;
  /** delete single row from the table: "investment_types" */
  delete_investment_types_by_pk?: Maybe<Investment_Types>;
  /** delete data from the table: "invite_links" */
  delete_invite_links?: Maybe<Invite_Links_Mutation_Response>;
  /** delete single row from the table: "invite_links" */
  delete_invite_links_by_pk?: Maybe<Invite_Links>;
  /** delete data from the table: "kyc_status" */
  delete_kyc_status?: Maybe<Kyc_Status_Mutation_Response>;
  /** delete single row from the table: "kyc_status" */
  delete_kyc_status_by_pk?: Maybe<Kyc_Status>;
  /** delete data from the table: "likes" */
  delete_likes?: Maybe<Likes_Mutation_Response>;
  /** delete single row from the table: "likes" */
  delete_likes_by_pk?: Maybe<Likes>;
  /** delete data from the table: "otp_messages" */
  delete_otp_messages?: Maybe<Otp_Messages_Mutation_Response>;
  /** delete single row from the table: "otp_messages" */
  delete_otp_messages_by_pk?: Maybe<Otp_Messages>;
  /** delete data from the table: "project_assets" */
  delete_project_assets?: Maybe<Project_Assets_Mutation_Response>;
  /** delete single row from the table: "project_assets" */
  delete_project_assets_by_pk?: Maybe<Project_Assets>;
  /** delete data from the table: "project_escalations" */
  delete_project_escalations?: Maybe<Project_Escalations_Mutation_Response>;
  /** delete single row from the table: "project_escalations" */
  delete_project_escalations_by_pk?: Maybe<Project_Escalations>;
  /** delete data from the table: "project_images" */
  delete_project_images?: Maybe<Project_Images_Mutation_Response>;
  /** delete single row from the table: "project_images" */
  delete_project_images_by_pk?: Maybe<Project_Images>;
  /** delete data from the table: "project_members" */
  delete_project_members?: Maybe<Project_Members_Mutation_Response>;
  /** delete single row from the table: "project_members" */
  delete_project_members_by_pk?: Maybe<Project_Members>;
  /** delete data from the table: "project_promotions" */
  delete_project_promotions?: Maybe<Project_Promotions_Mutation_Response>;
  /** delete single row from the table: "project_promotions" */
  delete_project_promotions_by_pk?: Maybe<Project_Promotions>;
  /** delete data from the table: "project_question_answers" */
  delete_project_question_answers?: Maybe<Project_Question_Answers_Mutation_Response>;
  /** delete single row from the table: "project_question_answers" */
  delete_project_question_answers_by_pk?: Maybe<Project_Question_Answers>;
  /** delete data from the table: "project_severities" */
  delete_project_severities?: Maybe<Project_Severities_Mutation_Response>;
  /** delete single row from the table: "project_severities" */
  delete_project_severities_by_pk?: Maybe<Project_Severities>;
  /** delete data from the table: "project_timelines" */
  delete_project_timelines?: Maybe<Project_Timelines_Mutation_Response>;
  /** delete single row from the table: "project_timelines" */
  delete_project_timelines_by_pk?: Maybe<Project_Timelines>;
  /** delete data from the table: "projects" */
  delete_projects?: Maybe<Projects_Mutation_Response>;
  /** delete single row from the table: "projects" */
  delete_projects_by_pk?: Maybe<Projects>;
  /** delete data from the table: "regions" */
  delete_regions?: Maybe<Regions_Mutation_Response>;
  /** delete single row from the table: "regions" */
  delete_regions_by_pk?: Maybe<Regions>;
  /** delete data from the table: "suggest_project" */
  delete_suggest_project?: Maybe<Suggest_Project_Mutation_Response>;
  /** delete single row from the table: "suggest_project" */
  delete_suggest_project_by_pk?: Maybe<Suggest_Project>;
  /** delete data from the table: "suggest_project_images" */
  delete_suggest_project_images?: Maybe<Suggest_Project_Images_Mutation_Response>;
  /** delete single row from the table: "suggest_project_images" */
  delete_suggest_project_images_by_pk?: Maybe<Suggest_Project_Images>;
  /** delete data from the table: "user_assets" */
  delete_user_assets?: Maybe<User_Assets_Mutation_Response>;
  /** delete single row from the table: "user_assets" */
  delete_user_assets_by_pk?: Maybe<User_Assets>;
  /** delete data from the table: "user_roles" */
  delete_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** delete single row from the table: "user_roles" */
  delete_user_roles_by_pk?: Maybe<User_Roles>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  forgotPassword?: Maybe<Scalars['Boolean']>;
  generatePassword: Scalars['String'];
  getUploadURL?: Maybe<UploadFilePayload>;
  /** insert data into the table: "change_email_otp" */
  insert_change_email_otp?: Maybe<Change_Email_Otp_Mutation_Response>;
  /** insert a single row into the table: "change_email_otp" */
  insert_change_email_otp_one?: Maybe<Change_Email_Otp>;
  /** insert data into the table: "comments" */
  insert_comments?: Maybe<Comments_Mutation_Response>;
  /** insert a single row into the table: "comments" */
  insert_comments_one?: Maybe<Comments>;
  /** insert data into the table: "districts" */
  insert_districts?: Maybe<Districts_Mutation_Response>;
  /** insert a single row into the table: "districts" */
  insert_districts_one?: Maybe<Districts>;
  /** insert data into the table: "expressions" */
  insert_expressions?: Maybe<Expressions_Mutation_Response>;
  /** insert a single row into the table: "expressions" */
  insert_expressions_one?: Maybe<Expressions>;
  /** insert data into the table: "file_upload_parameters" */
  insert_file_upload_parameters?: Maybe<File_Upload_Parameters_Mutation_Response>;
  /** insert a single row into the table: "file_upload_parameters" */
  insert_file_upload_parameters_one?: Maybe<File_Upload_Parameters>;
  /** insert data into the table: "file_upload_types" */
  insert_file_upload_types?: Maybe<File_Upload_Types_Mutation_Response>;
  /** insert a single row into the table: "file_upload_types" */
  insert_file_upload_types_one?: Maybe<File_Upload_Types>;
  /** insert data into the table: "investment_types" */
  insert_investment_types?: Maybe<Investment_Types_Mutation_Response>;
  /** insert a single row into the table: "investment_types" */
  insert_investment_types_one?: Maybe<Investment_Types>;
  /** insert data into the table: "invite_links" */
  insert_invite_links?: Maybe<Invite_Links_Mutation_Response>;
  /** insert a single row into the table: "invite_links" */
  insert_invite_links_one?: Maybe<Invite_Links>;
  /** insert data into the table: "kyc_status" */
  insert_kyc_status?: Maybe<Kyc_Status_Mutation_Response>;
  /** insert a single row into the table: "kyc_status" */
  insert_kyc_status_one?: Maybe<Kyc_Status>;
  /** insert data into the table: "likes" */
  insert_likes?: Maybe<Likes_Mutation_Response>;
  /** insert a single row into the table: "likes" */
  insert_likes_one?: Maybe<Likes>;
  /** insert data into the table: "otp_messages" */
  insert_otp_messages?: Maybe<Otp_Messages_Mutation_Response>;
  /** insert a single row into the table: "otp_messages" */
  insert_otp_messages_one?: Maybe<Otp_Messages>;
  /** insert data into the table: "project_assets" */
  insert_project_assets?: Maybe<Project_Assets_Mutation_Response>;
  /** insert a single row into the table: "project_assets" */
  insert_project_assets_one?: Maybe<Project_Assets>;
  /** insert data into the table: "project_escalations" */
  insert_project_escalations?: Maybe<Project_Escalations_Mutation_Response>;
  /** insert a single row into the table: "project_escalations" */
  insert_project_escalations_one?: Maybe<Project_Escalations>;
  /** insert data into the table: "project_images" */
  insert_project_images?: Maybe<Project_Images_Mutation_Response>;
  /** insert a single row into the table: "project_images" */
  insert_project_images_one?: Maybe<Project_Images>;
  /** insert data into the table: "project_members" */
  insert_project_members?: Maybe<Project_Members_Mutation_Response>;
  /** insert a single row into the table: "project_members" */
  insert_project_members_one?: Maybe<Project_Members>;
  /** insert data into the table: "project_promotions" */
  insert_project_promotions?: Maybe<Project_Promotions_Mutation_Response>;
  /** insert a single row into the table: "project_promotions" */
  insert_project_promotions_one?: Maybe<Project_Promotions>;
  /** insert data into the table: "project_question_answers" */
  insert_project_question_answers?: Maybe<Project_Question_Answers_Mutation_Response>;
  /** insert a single row into the table: "project_question_answers" */
  insert_project_question_answers_one?: Maybe<Project_Question_Answers>;
  /** insert data into the table: "project_severities" */
  insert_project_severities?: Maybe<Project_Severities_Mutation_Response>;
  /** insert a single row into the table: "project_severities" */
  insert_project_severities_one?: Maybe<Project_Severities>;
  /** insert data into the table: "project_timelines" */
  insert_project_timelines?: Maybe<Project_Timelines_Mutation_Response>;
  /** insert a single row into the table: "project_timelines" */
  insert_project_timelines_one?: Maybe<Project_Timelines>;
  /** insert data into the table: "projects" */
  insert_projects?: Maybe<Projects_Mutation_Response>;
  /** insert a single row into the table: "projects" */
  insert_projects_one?: Maybe<Projects>;
  /** insert data into the table: "regions" */
  insert_regions?: Maybe<Regions_Mutation_Response>;
  /** insert a single row into the table: "regions" */
  insert_regions_one?: Maybe<Regions>;
  /** insert data into the table: "suggest_project" */
  insert_suggest_project?: Maybe<Suggest_Project_Mutation_Response>;
  /** insert data into the table: "suggest_project_images" */
  insert_suggest_project_images?: Maybe<Suggest_Project_Images_Mutation_Response>;
  /** insert a single row into the table: "suggest_project_images" */
  insert_suggest_project_images_one?: Maybe<Suggest_Project_Images>;
  /** insert a single row into the table: "suggest_project" */
  insert_suggest_project_one?: Maybe<Suggest_Project>;
  /** insert data into the table: "user_assets" */
  insert_user_assets?: Maybe<User_Assets_Mutation_Response>;
  /** insert a single row into the table: "user_assets" */
  insert_user_assets_one?: Maybe<User_Assets>;
  /** insert data into the table: "user_roles" */
  insert_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_roles" */
  insert_user_roles_one?: Maybe<User_Roles>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  inviteLink?: Maybe<Scalars['String']>;
  login?: Maybe<Scalars['String']>;
  ping: Scalars['String'];
  projectMember: Scalars['String'];
  register?: Maybe<Scalars['Boolean']>;
  resendOtp?: Maybe<Scalars['Boolean']>;
  resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  sendChangeEmailOtp: Scalars['Boolean'];
  shareProject: Scalars['Boolean'];
  updateComment: Scalars['String'];
  /** update data of the table: "change_email_otp" */
  update_change_email_otp?: Maybe<Change_Email_Otp_Mutation_Response>;
  /** update single row of the table: "change_email_otp" */
  update_change_email_otp_by_pk?: Maybe<Change_Email_Otp>;
  /** update multiples rows of table: "change_email_otp" */
  update_change_email_otp_many?: Maybe<Array<Maybe<Change_Email_Otp_Mutation_Response>>>;
  /** update data of the table: "comments" */
  update_comments?: Maybe<Comments_Mutation_Response>;
  /** update single row of the table: "comments" */
  update_comments_by_pk?: Maybe<Comments>;
  /** update multiples rows of table: "comments" */
  update_comments_many?: Maybe<Array<Maybe<Comments_Mutation_Response>>>;
  /** update data of the table: "districts" */
  update_districts?: Maybe<Districts_Mutation_Response>;
  /** update single row of the table: "districts" */
  update_districts_by_pk?: Maybe<Districts>;
  /** update multiples rows of table: "districts" */
  update_districts_many?: Maybe<Array<Maybe<Districts_Mutation_Response>>>;
  /** update data of the table: "expressions" */
  update_expressions?: Maybe<Expressions_Mutation_Response>;
  /** update single row of the table: "expressions" */
  update_expressions_by_pk?: Maybe<Expressions>;
  /** update multiples rows of table: "expressions" */
  update_expressions_many?: Maybe<Array<Maybe<Expressions_Mutation_Response>>>;
  /** update data of the table: "file_upload_parameters" */
  update_file_upload_parameters?: Maybe<File_Upload_Parameters_Mutation_Response>;
  /** update single row of the table: "file_upload_parameters" */
  update_file_upload_parameters_by_pk?: Maybe<File_Upload_Parameters>;
  /** update multiples rows of table: "file_upload_parameters" */
  update_file_upload_parameters_many?: Maybe<Array<Maybe<File_Upload_Parameters_Mutation_Response>>>;
  /** update data of the table: "file_upload_types" */
  update_file_upload_types?: Maybe<File_Upload_Types_Mutation_Response>;
  /** update single row of the table: "file_upload_types" */
  update_file_upload_types_by_pk?: Maybe<File_Upload_Types>;
  /** update multiples rows of table: "file_upload_types" */
  update_file_upload_types_many?: Maybe<Array<Maybe<File_Upload_Types_Mutation_Response>>>;
  /** update data of the table: "investment_types" */
  update_investment_types?: Maybe<Investment_Types_Mutation_Response>;
  /** update single row of the table: "investment_types" */
  update_investment_types_by_pk?: Maybe<Investment_Types>;
  /** update multiples rows of table: "investment_types" */
  update_investment_types_many?: Maybe<Array<Maybe<Investment_Types_Mutation_Response>>>;
  /** update data of the table: "invite_links" */
  update_invite_links?: Maybe<Invite_Links_Mutation_Response>;
  /** update single row of the table: "invite_links" */
  update_invite_links_by_pk?: Maybe<Invite_Links>;
  /** update multiples rows of table: "invite_links" */
  update_invite_links_many?: Maybe<Array<Maybe<Invite_Links_Mutation_Response>>>;
  /** update data of the table: "kyc_status" */
  update_kyc_status?: Maybe<Kyc_Status_Mutation_Response>;
  /** update single row of the table: "kyc_status" */
  update_kyc_status_by_pk?: Maybe<Kyc_Status>;
  /** update multiples rows of table: "kyc_status" */
  update_kyc_status_many?: Maybe<Array<Maybe<Kyc_Status_Mutation_Response>>>;
  /** update data of the table: "likes" */
  update_likes?: Maybe<Likes_Mutation_Response>;
  /** update single row of the table: "likes" */
  update_likes_by_pk?: Maybe<Likes>;
  /** update multiples rows of table: "likes" */
  update_likes_many?: Maybe<Array<Maybe<Likes_Mutation_Response>>>;
  /** update data of the table: "otp_messages" */
  update_otp_messages?: Maybe<Otp_Messages_Mutation_Response>;
  /** update single row of the table: "otp_messages" */
  update_otp_messages_by_pk?: Maybe<Otp_Messages>;
  /** update multiples rows of table: "otp_messages" */
  update_otp_messages_many?: Maybe<Array<Maybe<Otp_Messages_Mutation_Response>>>;
  /** update data of the table: "project_assets" */
  update_project_assets?: Maybe<Project_Assets_Mutation_Response>;
  /** update single row of the table: "project_assets" */
  update_project_assets_by_pk?: Maybe<Project_Assets>;
  /** update multiples rows of table: "project_assets" */
  update_project_assets_many?: Maybe<Array<Maybe<Project_Assets_Mutation_Response>>>;
  /** update data of the table: "project_escalations" */
  update_project_escalations?: Maybe<Project_Escalations_Mutation_Response>;
  /** update single row of the table: "project_escalations" */
  update_project_escalations_by_pk?: Maybe<Project_Escalations>;
  /** update multiples rows of table: "project_escalations" */
  update_project_escalations_many?: Maybe<Array<Maybe<Project_Escalations_Mutation_Response>>>;
  /** update data of the table: "project_images" */
  update_project_images?: Maybe<Project_Images_Mutation_Response>;
  /** update single row of the table: "project_images" */
  update_project_images_by_pk?: Maybe<Project_Images>;
  /** update multiples rows of table: "project_images" */
  update_project_images_many?: Maybe<Array<Maybe<Project_Images_Mutation_Response>>>;
  /** update data of the table: "project_members" */
  update_project_members?: Maybe<Project_Members_Mutation_Response>;
  /** update single row of the table: "project_members" */
  update_project_members_by_pk?: Maybe<Project_Members>;
  /** update multiples rows of table: "project_members" */
  update_project_members_many?: Maybe<Array<Maybe<Project_Members_Mutation_Response>>>;
  /** update data of the table: "project_promotions" */
  update_project_promotions?: Maybe<Project_Promotions_Mutation_Response>;
  /** update single row of the table: "project_promotions" */
  update_project_promotions_by_pk?: Maybe<Project_Promotions>;
  /** update multiples rows of table: "project_promotions" */
  update_project_promotions_many?: Maybe<Array<Maybe<Project_Promotions_Mutation_Response>>>;
  /** update data of the table: "project_question_answers" */
  update_project_question_answers?: Maybe<Project_Question_Answers_Mutation_Response>;
  /** update single row of the table: "project_question_answers" */
  update_project_question_answers_by_pk?: Maybe<Project_Question_Answers>;
  /** update multiples rows of table: "project_question_answers" */
  update_project_question_answers_many?: Maybe<Array<Maybe<Project_Question_Answers_Mutation_Response>>>;
  /** update data of the table: "project_severities" */
  update_project_severities?: Maybe<Project_Severities_Mutation_Response>;
  /** update single row of the table: "project_severities" */
  update_project_severities_by_pk?: Maybe<Project_Severities>;
  /** update multiples rows of table: "project_severities" */
  update_project_severities_many?: Maybe<Array<Maybe<Project_Severities_Mutation_Response>>>;
  /** update data of the table: "project_timelines" */
  update_project_timelines?: Maybe<Project_Timelines_Mutation_Response>;
  /** update single row of the table: "project_timelines" */
  update_project_timelines_by_pk?: Maybe<Project_Timelines>;
  /** update multiples rows of table: "project_timelines" */
  update_project_timelines_many?: Maybe<Array<Maybe<Project_Timelines_Mutation_Response>>>;
  /** update data of the table: "projects" */
  update_projects?: Maybe<Projects_Mutation_Response>;
  /** update single row of the table: "projects" */
  update_projects_by_pk?: Maybe<Projects>;
  /** update multiples rows of table: "projects" */
  update_projects_many?: Maybe<Array<Maybe<Projects_Mutation_Response>>>;
  /** update data of the table: "regions" */
  update_regions?: Maybe<Regions_Mutation_Response>;
  /** update single row of the table: "regions" */
  update_regions_by_pk?: Maybe<Regions>;
  /** update multiples rows of table: "regions" */
  update_regions_many?: Maybe<Array<Maybe<Regions_Mutation_Response>>>;
  /** update data of the table: "suggest_project" */
  update_suggest_project?: Maybe<Suggest_Project_Mutation_Response>;
  /** update single row of the table: "suggest_project" */
  update_suggest_project_by_pk?: Maybe<Suggest_Project>;
  /** update data of the table: "suggest_project_images" */
  update_suggest_project_images?: Maybe<Suggest_Project_Images_Mutation_Response>;
  /** update single row of the table: "suggest_project_images" */
  update_suggest_project_images_by_pk?: Maybe<Suggest_Project_Images>;
  /** update multiples rows of table: "suggest_project_images" */
  update_suggest_project_images_many?: Maybe<Array<Maybe<Suggest_Project_Images_Mutation_Response>>>;
  /** update multiples rows of table: "suggest_project" */
  update_suggest_project_many?: Maybe<Array<Maybe<Suggest_Project_Mutation_Response>>>;
  /** update data of the table: "user_assets" */
  update_user_assets?: Maybe<User_Assets_Mutation_Response>;
  /** update single row of the table: "user_assets" */
  update_user_assets_by_pk?: Maybe<User_Assets>;
  /** update multiples rows of table: "user_assets" */
  update_user_assets_many?: Maybe<Array<Maybe<User_Assets_Mutation_Response>>>;
  /** update data of the table: "user_roles" */
  update_user_roles?: Maybe<User_Roles_Mutation_Response>;
  /** update single row of the table: "user_roles" */
  update_user_roles_by_pk?: Maybe<User_Roles>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<User_Roles_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  verifyChangeEmailOtp: Scalars['Boolean'];
  verifyEmail: Scalars['String'];
  verifyOtp: Scalars['String'];
};


/** mutation root */
export type MutationAcceptInviteArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type MutationCheckUserExistsArgs = {
  email: Scalars['String'];
  phone_number: Scalars['String'];
};


/** mutation root */
export type MutationCreateUserArgs = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  mobile: Scalars['String'];
  password: Scalars['String'];
  user_name: Scalars['String'];
  user_type: Scalars['String'];
};


/** mutation root */
export type MutationDelete_Change_Email_OtpArgs = {
  where: Change_Email_Otp_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Change_Email_Otp_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_CommentsArgs = {
  where: Comments_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Comments_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_DistrictsArgs = {
  where: Districts_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Districts_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_ExpressionsArgs = {
  where: Expressions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Expressions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_File_Upload_ParametersArgs = {
  where: File_Upload_Parameters_Bool_Exp;
};


/** mutation root */
export type MutationDelete_File_Upload_Parameters_By_PkArgs = {
  type: File_Upload_Types_Enum;
};


/** mutation root */
export type MutationDelete_File_Upload_TypesArgs = {
  where: File_Upload_Types_Bool_Exp;
};


/** mutation root */
export type MutationDelete_File_Upload_Types_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationDelete_Investment_TypesArgs = {
  where: Investment_Types_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Investment_Types_By_PkArgs = {
  type: Scalars['String'];
};


/** mutation root */
export type MutationDelete_Invite_LinksArgs = {
  where: Invite_Links_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Invite_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Kyc_StatusArgs = {
  where: Kyc_Status_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Kyc_Status_By_PkArgs = {
  kyc_status: Scalars['String'];
};


/** mutation root */
export type MutationDelete_LikesArgs = {
  where: Likes_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Likes_By_PkArgs = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Otp_MessagesArgs = {
  where: Otp_Messages_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Otp_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_AssetsArgs = {
  where: Project_Assets_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Assets_By_PkArgs = {
  file_name: Scalars['String'];
  id: Scalars['uuid'];
  project_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_EscalationsArgs = {
  where: Project_Escalations_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Escalations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_ImagesArgs = {
  where: Project_Images_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Images_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_MembersArgs = {
  where: Project_Members_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_PromotionsArgs = {
  where: Project_Promotions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Promotions_By_PkArgs = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_Question_AnswersArgs = {
  where: Project_Question_Answers_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Question_Answers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Project_SeveritiesArgs = {
  where: Project_Severities_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Severities_By_PkArgs = {
  severity: Scalars['String'];
};


/** mutation root */
export type MutationDelete_Project_TimelinesArgs = {
  where: Project_Timelines_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Project_Timelines_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_ProjectsArgs = {
  where: Projects_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Projects_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_RegionsArgs = {
  where: Regions_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Regions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Suggest_ProjectArgs = {
  where: Suggest_Project_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Suggest_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_Suggest_Project_ImagesArgs = {
  where: Suggest_Project_Images_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Suggest_Project_Images_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_User_AssetsArgs = {
  where: User_Assets_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationDelete_User_RolesArgs = {
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type MutationDelete_User_Roles_By_PkArgs = {
  role: Scalars['String'];
};


/** mutation root */
export type MutationDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type MutationDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type MutationForgotPasswordArgs = {
  phone_number: Scalars['String'];
};


/** mutation root */
export type MutationGeneratePasswordArgs = {
  password: Scalars['String'];
};


/** mutation root */
export type MutationGetUploadUrlArgs = {
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  path: Scalars['String'];
  uploadType: Scalars['String'];
};


/** mutation root */
export type MutationInsert_Change_Email_OtpArgs = {
  objects: Array<Change_Email_Otp_Insert_Input>;
  on_conflict?: InputMaybe<Change_Email_Otp_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Change_Email_Otp_OneArgs = {
  object: Change_Email_Otp_Insert_Input;
  on_conflict?: InputMaybe<Change_Email_Otp_On_Conflict>;
};


/** mutation root */
export type MutationInsert_CommentsArgs = {
  objects: Array<Comments_Insert_Input>;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Comments_OneArgs = {
  object: Comments_Insert_Input;
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};


/** mutation root */
export type MutationInsert_DistrictsArgs = {
  objects: Array<Districts_Insert_Input>;
  on_conflict?: InputMaybe<Districts_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Districts_OneArgs = {
  object: Districts_Insert_Input;
  on_conflict?: InputMaybe<Districts_On_Conflict>;
};


/** mutation root */
export type MutationInsert_ExpressionsArgs = {
  objects: Array<Expressions_Insert_Input>;
  on_conflict?: InputMaybe<Expressions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Expressions_OneArgs = {
  object: Expressions_Insert_Input;
  on_conflict?: InputMaybe<Expressions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_File_Upload_ParametersArgs = {
  objects: Array<File_Upload_Parameters_Insert_Input>;
  on_conflict?: InputMaybe<File_Upload_Parameters_On_Conflict>;
};


/** mutation root */
export type MutationInsert_File_Upload_Parameters_OneArgs = {
  object: File_Upload_Parameters_Insert_Input;
  on_conflict?: InputMaybe<File_Upload_Parameters_On_Conflict>;
};


/** mutation root */
export type MutationInsert_File_Upload_TypesArgs = {
  objects: Array<File_Upload_Types_Insert_Input>;
  on_conflict?: InputMaybe<File_Upload_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_File_Upload_Types_OneArgs = {
  object: File_Upload_Types_Insert_Input;
  on_conflict?: InputMaybe<File_Upload_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Investment_TypesArgs = {
  objects: Array<Investment_Types_Insert_Input>;
  on_conflict?: InputMaybe<Investment_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Investment_Types_OneArgs = {
  object: Investment_Types_Insert_Input;
  on_conflict?: InputMaybe<Investment_Types_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Invite_LinksArgs = {
  objects: Array<Invite_Links_Insert_Input>;
  on_conflict?: InputMaybe<Invite_Links_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Invite_Links_OneArgs = {
  object: Invite_Links_Insert_Input;
  on_conflict?: InputMaybe<Invite_Links_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Kyc_StatusArgs = {
  objects: Array<Kyc_Status_Insert_Input>;
  on_conflict?: InputMaybe<Kyc_Status_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Kyc_Status_OneArgs = {
  object: Kyc_Status_Insert_Input;
  on_conflict?: InputMaybe<Kyc_Status_On_Conflict>;
};


/** mutation root */
export type MutationInsert_LikesArgs = {
  objects: Array<Likes_Insert_Input>;
  on_conflict?: InputMaybe<Likes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Likes_OneArgs = {
  object: Likes_Insert_Input;
  on_conflict?: InputMaybe<Likes_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Otp_MessagesArgs = {
  objects: Array<Otp_Messages_Insert_Input>;
  on_conflict?: InputMaybe<Otp_Messages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Otp_Messages_OneArgs = {
  object: Otp_Messages_Insert_Input;
  on_conflict?: InputMaybe<Otp_Messages_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_AssetsArgs = {
  objects: Array<Project_Assets_Insert_Input>;
  on_conflict?: InputMaybe<Project_Assets_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Assets_OneArgs = {
  object: Project_Assets_Insert_Input;
  on_conflict?: InputMaybe<Project_Assets_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_EscalationsArgs = {
  objects: Array<Project_Escalations_Insert_Input>;
  on_conflict?: InputMaybe<Project_Escalations_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Escalations_OneArgs = {
  object: Project_Escalations_Insert_Input;
  on_conflict?: InputMaybe<Project_Escalations_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_ImagesArgs = {
  objects: Array<Project_Images_Insert_Input>;
  on_conflict?: InputMaybe<Project_Images_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Images_OneArgs = {
  object: Project_Images_Insert_Input;
  on_conflict?: InputMaybe<Project_Images_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_MembersArgs = {
  objects: Array<Project_Members_Insert_Input>;
  on_conflict?: InputMaybe<Project_Members_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Members_OneArgs = {
  object: Project_Members_Insert_Input;
  on_conflict?: InputMaybe<Project_Members_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_PromotionsArgs = {
  objects: Array<Project_Promotions_Insert_Input>;
  on_conflict?: InputMaybe<Project_Promotions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Promotions_OneArgs = {
  object: Project_Promotions_Insert_Input;
  on_conflict?: InputMaybe<Project_Promotions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Question_AnswersArgs = {
  objects: Array<Project_Question_Answers_Insert_Input>;
  on_conflict?: InputMaybe<Project_Question_Answers_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Question_Answers_OneArgs = {
  object: Project_Question_Answers_Insert_Input;
  on_conflict?: InputMaybe<Project_Question_Answers_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_SeveritiesArgs = {
  objects: Array<Project_Severities_Insert_Input>;
  on_conflict?: InputMaybe<Project_Severities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Severities_OneArgs = {
  object: Project_Severities_Insert_Input;
  on_conflict?: InputMaybe<Project_Severities_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_TimelinesArgs = {
  objects: Array<Project_Timelines_Insert_Input>;
  on_conflict?: InputMaybe<Project_Timelines_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Project_Timelines_OneArgs = {
  object: Project_Timelines_Insert_Input;
  on_conflict?: InputMaybe<Project_Timelines_On_Conflict>;
};


/** mutation root */
export type MutationInsert_ProjectsArgs = {
  objects: Array<Projects_Insert_Input>;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Projects_OneArgs = {
  object: Projects_Insert_Input;
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};


/** mutation root */
export type MutationInsert_RegionsArgs = {
  objects: Array<Regions_Insert_Input>;
  on_conflict?: InputMaybe<Regions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Regions_OneArgs = {
  object: Regions_Insert_Input;
  on_conflict?: InputMaybe<Regions_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Suggest_ProjectArgs = {
  objects: Array<Suggest_Project_Insert_Input>;
  on_conflict?: InputMaybe<Suggest_Project_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Suggest_Project_ImagesArgs = {
  objects: Array<Suggest_Project_Images_Insert_Input>;
  on_conflict?: InputMaybe<Suggest_Project_Images_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Suggest_Project_Images_OneArgs = {
  object: Suggest_Project_Images_Insert_Input;
  on_conflict?: InputMaybe<Suggest_Project_Images_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Suggest_Project_OneArgs = {
  object: Suggest_Project_Insert_Input;
  on_conflict?: InputMaybe<Suggest_Project_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_AssetsArgs = {
  objects: Array<User_Assets_Insert_Input>;
  on_conflict?: InputMaybe<User_Assets_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Assets_OneArgs = {
  object: User_Assets_Insert_Input;
  on_conflict?: InputMaybe<User_Assets_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_RolesArgs = {
  objects: Array<User_Roles_Insert_Input>;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type MutationInsert_User_Roles_OneArgs = {
  object: User_Roles_Insert_Input;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type MutationInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type MutationInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type MutationInviteLinkArgs = {
  is_all?: InputMaybe<Scalars['Boolean']>;
  project_id?: InputMaybe<Scalars['String']>;
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationLoginArgs = {
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone_number?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationProjectMemberArgs = {
  project_id: Scalars['String'];
  user_id: Scalars['String'];
};


/** mutation root */
export type MutationRegisterArgs = {
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  password: Scalars['String'];
  phone_number: Scalars['String'];
  user_name: Scalars['String'];
  user_type?: InputMaybe<Scalars['String']>;
  user_type_details?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationResendOtpArgs = {
  phone_number: Scalars['String'];
};


/** mutation root */
export type MutationResendVerificationEmailArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type MutationResetPasswordArgs = {
  otp: Scalars['String'];
  password: Scalars['String'];
  phone_number: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type MutationSendChangeEmailOtpArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type MutationShareProjectArgs = {
  email: Scalars['String'];
  project_id: Scalars['String'];
};


/** mutation root */
export type MutationUpdateCommentArgs = {
  comment: Scalars['String'];
  commentId: Scalars['String'];
};


/** mutation root */
export type MutationUpdate_Change_Email_OtpArgs = {
  _inc?: InputMaybe<Change_Email_Otp_Inc_Input>;
  _set?: InputMaybe<Change_Email_Otp_Set_Input>;
  where: Change_Email_Otp_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Change_Email_Otp_By_PkArgs = {
  _inc?: InputMaybe<Change_Email_Otp_Inc_Input>;
  _set?: InputMaybe<Change_Email_Otp_Set_Input>;
  pk_columns: Change_Email_Otp_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Change_Email_Otp_ManyArgs = {
  updates: Array<Change_Email_Otp_Updates>;
};


/** mutation root */
export type MutationUpdate_CommentsArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Comments_By_PkArgs = {
  _set?: InputMaybe<Comments_Set_Input>;
  pk_columns: Comments_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Comments_ManyArgs = {
  updates: Array<Comments_Updates>;
};


/** mutation root */
export type MutationUpdate_DistrictsArgs = {
  _set?: InputMaybe<Districts_Set_Input>;
  where: Districts_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Districts_By_PkArgs = {
  _set?: InputMaybe<Districts_Set_Input>;
  pk_columns: Districts_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Districts_ManyArgs = {
  updates: Array<Districts_Updates>;
};


/** mutation root */
export type MutationUpdate_ExpressionsArgs = {
  _inc?: InputMaybe<Expressions_Inc_Input>;
  _set?: InputMaybe<Expressions_Set_Input>;
  where: Expressions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Expressions_By_PkArgs = {
  _inc?: InputMaybe<Expressions_Inc_Input>;
  _set?: InputMaybe<Expressions_Set_Input>;
  pk_columns: Expressions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Expressions_ManyArgs = {
  updates: Array<Expressions_Updates>;
};


/** mutation root */
export type MutationUpdate_File_Upload_ParametersArgs = {
  _inc?: InputMaybe<File_Upload_Parameters_Inc_Input>;
  _set?: InputMaybe<File_Upload_Parameters_Set_Input>;
  where: File_Upload_Parameters_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_File_Upload_Parameters_By_PkArgs = {
  _inc?: InputMaybe<File_Upload_Parameters_Inc_Input>;
  _set?: InputMaybe<File_Upload_Parameters_Set_Input>;
  pk_columns: File_Upload_Parameters_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_File_Upload_Parameters_ManyArgs = {
  updates: Array<File_Upload_Parameters_Updates>;
};


/** mutation root */
export type MutationUpdate_File_Upload_TypesArgs = {
  _set?: InputMaybe<File_Upload_Types_Set_Input>;
  where: File_Upload_Types_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_File_Upload_Types_By_PkArgs = {
  _set?: InputMaybe<File_Upload_Types_Set_Input>;
  pk_columns: File_Upload_Types_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_File_Upload_Types_ManyArgs = {
  updates: Array<File_Upload_Types_Updates>;
};


/** mutation root */
export type MutationUpdate_Investment_TypesArgs = {
  _set?: InputMaybe<Investment_Types_Set_Input>;
  where: Investment_Types_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Investment_Types_By_PkArgs = {
  _set?: InputMaybe<Investment_Types_Set_Input>;
  pk_columns: Investment_Types_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Investment_Types_ManyArgs = {
  updates: Array<Investment_Types_Updates>;
};


/** mutation root */
export type MutationUpdate_Invite_LinksArgs = {
  _set?: InputMaybe<Invite_Links_Set_Input>;
  where: Invite_Links_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Invite_Links_By_PkArgs = {
  _set?: InputMaybe<Invite_Links_Set_Input>;
  pk_columns: Invite_Links_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Invite_Links_ManyArgs = {
  updates: Array<Invite_Links_Updates>;
};


/** mutation root */
export type MutationUpdate_Kyc_StatusArgs = {
  _set?: InputMaybe<Kyc_Status_Set_Input>;
  where: Kyc_Status_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Kyc_Status_By_PkArgs = {
  _set?: InputMaybe<Kyc_Status_Set_Input>;
  pk_columns: Kyc_Status_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Kyc_Status_ManyArgs = {
  updates: Array<Kyc_Status_Updates>;
};


/** mutation root */
export type MutationUpdate_LikesArgs = {
  _set?: InputMaybe<Likes_Set_Input>;
  where: Likes_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Likes_By_PkArgs = {
  _set?: InputMaybe<Likes_Set_Input>;
  pk_columns: Likes_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Likes_ManyArgs = {
  updates: Array<Likes_Updates>;
};


/** mutation root */
export type MutationUpdate_Otp_MessagesArgs = {
  _inc?: InputMaybe<Otp_Messages_Inc_Input>;
  _set?: InputMaybe<Otp_Messages_Set_Input>;
  where: Otp_Messages_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Otp_Messages_By_PkArgs = {
  _inc?: InputMaybe<Otp_Messages_Inc_Input>;
  _set?: InputMaybe<Otp_Messages_Set_Input>;
  pk_columns: Otp_Messages_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Otp_Messages_ManyArgs = {
  updates: Array<Otp_Messages_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_AssetsArgs = {
  _set?: InputMaybe<Project_Assets_Set_Input>;
  where: Project_Assets_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Assets_By_PkArgs = {
  _set?: InputMaybe<Project_Assets_Set_Input>;
  pk_columns: Project_Assets_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Assets_ManyArgs = {
  updates: Array<Project_Assets_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_EscalationsArgs = {
  _set?: InputMaybe<Project_Escalations_Set_Input>;
  where: Project_Escalations_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Escalations_By_PkArgs = {
  _set?: InputMaybe<Project_Escalations_Set_Input>;
  pk_columns: Project_Escalations_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Escalations_ManyArgs = {
  updates: Array<Project_Escalations_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_ImagesArgs = {
  _set?: InputMaybe<Project_Images_Set_Input>;
  where: Project_Images_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Images_By_PkArgs = {
  _set?: InputMaybe<Project_Images_Set_Input>;
  pk_columns: Project_Images_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Images_ManyArgs = {
  updates: Array<Project_Images_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_MembersArgs = {
  _set?: InputMaybe<Project_Members_Set_Input>;
  where: Project_Members_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Members_By_PkArgs = {
  _set?: InputMaybe<Project_Members_Set_Input>;
  pk_columns: Project_Members_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Members_ManyArgs = {
  updates: Array<Project_Members_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_PromotionsArgs = {
  _set?: InputMaybe<Project_Promotions_Set_Input>;
  where: Project_Promotions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Promotions_By_PkArgs = {
  _set?: InputMaybe<Project_Promotions_Set_Input>;
  pk_columns: Project_Promotions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Promotions_ManyArgs = {
  updates: Array<Project_Promotions_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_Question_AnswersArgs = {
  _set?: InputMaybe<Project_Question_Answers_Set_Input>;
  where: Project_Question_Answers_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Question_Answers_By_PkArgs = {
  _set?: InputMaybe<Project_Question_Answers_Set_Input>;
  pk_columns: Project_Question_Answers_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Question_Answers_ManyArgs = {
  updates: Array<Project_Question_Answers_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_SeveritiesArgs = {
  _set?: InputMaybe<Project_Severities_Set_Input>;
  where: Project_Severities_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Severities_By_PkArgs = {
  _set?: InputMaybe<Project_Severities_Set_Input>;
  pk_columns: Project_Severities_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Severities_ManyArgs = {
  updates: Array<Project_Severities_Updates>;
};


/** mutation root */
export type MutationUpdate_Project_TimelinesArgs = {
  _set?: InputMaybe<Project_Timelines_Set_Input>;
  where: Project_Timelines_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Project_Timelines_By_PkArgs = {
  _set?: InputMaybe<Project_Timelines_Set_Input>;
  pk_columns: Project_Timelines_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Project_Timelines_ManyArgs = {
  updates: Array<Project_Timelines_Updates>;
};


/** mutation root */
export type MutationUpdate_ProjectsArgs = {
  _inc?: InputMaybe<Projects_Inc_Input>;
  _set?: InputMaybe<Projects_Set_Input>;
  where: Projects_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Projects_By_PkArgs = {
  _inc?: InputMaybe<Projects_Inc_Input>;
  _set?: InputMaybe<Projects_Set_Input>;
  pk_columns: Projects_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Projects_ManyArgs = {
  updates: Array<Projects_Updates>;
};


/** mutation root */
export type MutationUpdate_RegionsArgs = {
  _set?: InputMaybe<Regions_Set_Input>;
  where: Regions_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Regions_By_PkArgs = {
  _set?: InputMaybe<Regions_Set_Input>;
  pk_columns: Regions_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Regions_ManyArgs = {
  updates: Array<Regions_Updates>;
};


/** mutation root */
export type MutationUpdate_Suggest_ProjectArgs = {
  _set?: InputMaybe<Suggest_Project_Set_Input>;
  where: Suggest_Project_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Suggest_Project_By_PkArgs = {
  _set?: InputMaybe<Suggest_Project_Set_Input>;
  pk_columns: Suggest_Project_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Suggest_Project_ImagesArgs = {
  _set?: InputMaybe<Suggest_Project_Images_Set_Input>;
  where: Suggest_Project_Images_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Suggest_Project_Images_By_PkArgs = {
  _set?: InputMaybe<Suggest_Project_Images_Set_Input>;
  pk_columns: Suggest_Project_Images_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Suggest_Project_Images_ManyArgs = {
  updates: Array<Suggest_Project_Images_Updates>;
};


/** mutation root */
export type MutationUpdate_Suggest_Project_ManyArgs = {
  updates: Array<Suggest_Project_Updates>;
};


/** mutation root */
export type MutationUpdate_User_AssetsArgs = {
  _set?: InputMaybe<User_Assets_Set_Input>;
  where: User_Assets_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Assets_By_PkArgs = {
  _set?: InputMaybe<User_Assets_Set_Input>;
  pk_columns: User_Assets_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Assets_ManyArgs = {
  updates: Array<User_Assets_Updates>;
};


/** mutation root */
export type MutationUpdate_User_RolesArgs = {
  _set?: InputMaybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_User_Roles_By_PkArgs = {
  _set?: InputMaybe<User_Roles_Set_Input>;
  pk_columns: User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_User_Roles_ManyArgs = {
  updates: Array<User_Roles_Updates>;
};


/** mutation root */
export type MutationUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type MutationUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type MutationUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type MutationVerifyChangeEmailOtpArgs = {
  email: Scalars['String'];
  otp: Scalars['String'];
};


/** mutation root */
export type MutationVerifyEmailArgs = {
  token: Scalars['String'];
};


/** mutation root */
export type MutationVerifyOtpArgs = {
  otp: Scalars['String'];
  phone_number: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /** fetch data from the table: "change_email_otp" */
  change_email_otp: Array<Change_Email_Otp>;
  /** fetch aggregated fields from the table: "change_email_otp" */
  change_email_otp_aggregate: Change_Email_Otp_Aggregate;
  /** fetch data from the table: "change_email_otp" using primary key columns */
  change_email_otp_by_pk?: Maybe<Change_Email_Otp>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table: "districts" */
  districts: Array<Districts>;
  /** fetch aggregated fields from the table: "districts" */
  districts_aggregate: Districts_Aggregate;
  /** fetch data from the table: "districts" using primary key columns */
  districts_by_pk?: Maybe<Districts>;
  /** An array relationship */
  expressions: Array<Expressions>;
  /** An aggregate relationship */
  expressions_aggregate: Expressions_Aggregate;
  /** fetch data from the table: "expressions" using primary key columns */
  expressions_by_pk?: Maybe<Expressions>;
  /** fetch data from the table: "file_upload_parameters" */
  file_upload_parameters: Array<File_Upload_Parameters>;
  /** fetch aggregated fields from the table: "file_upload_parameters" */
  file_upload_parameters_aggregate: File_Upload_Parameters_Aggregate;
  /** fetch data from the table: "file_upload_parameters" using primary key columns */
  file_upload_parameters_by_pk?: Maybe<File_Upload_Parameters>;
  /** fetch data from the table: "file_upload_types" */
  file_upload_types: Array<File_Upload_Types>;
  /** fetch aggregated fields from the table: "file_upload_types" */
  file_upload_types_aggregate: File_Upload_Types_Aggregate;
  /** fetch data from the table: "file_upload_types" using primary key columns */
  file_upload_types_by_pk?: Maybe<File_Upload_Types>;
  /** fetch data from the table: "investment_types" */
  investment_types: Array<Investment_Types>;
  /** fetch aggregated fields from the table: "investment_types" */
  investment_types_aggregate: Investment_Types_Aggregate;
  /** fetch data from the table: "investment_types" using primary key columns */
  investment_types_by_pk?: Maybe<Investment_Types>;
  /** An array relationship */
  invite_links: Array<Invite_Links>;
  /** An aggregate relationship */
  invite_links_aggregate: Invite_Links_Aggregate;
  /** fetch data from the table: "invite_links" using primary key columns */
  invite_links_by_pk?: Maybe<Invite_Links>;
  /** fetch data from the table: "kyc_status" */
  kyc_status: Array<Kyc_Status>;
  /** fetch aggregated fields from the table: "kyc_status" */
  kyc_status_aggregate: Kyc_Status_Aggregate;
  /** fetch data from the table: "kyc_status" using primary key columns */
  kyc_status_by_pk?: Maybe<Kyc_Status>;
  /** An array relationship */
  likes: Array<Likes>;
  /** An aggregate relationship */
  likes_aggregate: Likes_Aggregate;
  /** fetch data from the table: "likes" using primary key columns */
  likes_by_pk?: Maybe<Likes>;
  me: Users;
  /** fetch data from the table: "otp_messages" */
  otp_messages: Array<Otp_Messages>;
  /** fetch aggregated fields from the table: "otp_messages" */
  otp_messages_aggregate: Otp_Messages_Aggregate;
  /** fetch data from the table: "otp_messages" using primary key columns */
  otp_messages_by_pk?: Maybe<Otp_Messages>;
  ping: Scalars['String'];
  /** An array relationship */
  project_assets: Array<Project_Assets>;
  /** An aggregate relationship */
  project_assets_aggregate: Project_Assets_Aggregate;
  /** fetch data from the table: "project_assets" using primary key columns */
  project_assets_by_pk?: Maybe<Project_Assets>;
  /** An array relationship */
  project_escalations: Array<Project_Escalations>;
  /** An aggregate relationship */
  project_escalations_aggregate: Project_Escalations_Aggregate;
  /** fetch data from the table: "project_escalations" using primary key columns */
  project_escalations_by_pk?: Maybe<Project_Escalations>;
  /** fetch data from the table: "project_images" */
  project_images: Array<Project_Images>;
  /** fetch aggregated fields from the table: "project_images" */
  project_images_aggregate: Project_Images_Aggregate;
  /** fetch data from the table: "project_images" using primary key columns */
  project_images_by_pk?: Maybe<Project_Images>;
  /** An array relationship */
  project_members: Array<Project_Members>;
  /** An aggregate relationship */
  project_members_aggregate: Project_Members_Aggregate;
  /** fetch data from the table: "project_members" using primary key columns */
  project_members_by_pk?: Maybe<Project_Members>;
  /** fetch data from the table: "project_promotions" */
  project_promotions: Array<Project_Promotions>;
  /** fetch aggregated fields from the table: "project_promotions" */
  project_promotions_aggregate: Project_Promotions_Aggregate;
  /** fetch data from the table: "project_promotions" using primary key columns */
  project_promotions_by_pk?: Maybe<Project_Promotions>;
  /** fetch data from the table: "project_question_answers" */
  project_question_answers: Array<Project_Question_Answers>;
  /** fetch aggregated fields from the table: "project_question_answers" */
  project_question_answers_aggregate: Project_Question_Answers_Aggregate;
  /** fetch data from the table: "project_question_answers" using primary key columns */
  project_question_answers_by_pk?: Maybe<Project_Question_Answers>;
  /** fetch data from the table: "project_severities" */
  project_severities: Array<Project_Severities>;
  /** fetch aggregated fields from the table: "project_severities" */
  project_severities_aggregate: Project_Severities_Aggregate;
  /** fetch data from the table: "project_severities" using primary key columns */
  project_severities_by_pk?: Maybe<Project_Severities>;
  /** fetch data from the table: "project_timelines" */
  project_timelines: Array<Project_Timelines>;
  /** fetch aggregated fields from the table: "project_timelines" */
  project_timelines_aggregate: Project_Timelines_Aggregate;
  /** fetch data from the table: "project_timelines" using primary key columns */
  project_timelines_by_pk?: Maybe<Project_Timelines>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "regions" */
  regions: Array<Regions>;
  /** fetch aggregated fields from the table: "regions" */
  regions_aggregate: Regions_Aggregate;
  /** fetch data from the table: "regions" using primary key columns */
  regions_by_pk?: Maybe<Regions>;
  /** fetch data from the table: "suggest_project" */
  suggest_project: Array<Suggest_Project>;
  /** fetch aggregated fields from the table: "suggest_project" */
  suggest_project_aggregate: Suggest_Project_Aggregate;
  /** fetch data from the table: "suggest_project" using primary key columns */
  suggest_project_by_pk?: Maybe<Suggest_Project>;
  /** fetch data from the table: "suggest_project_images" */
  suggest_project_images: Array<Suggest_Project_Images>;
  /** fetch aggregated fields from the table: "suggest_project_images" */
  suggest_project_images_aggregate: Suggest_Project_Images_Aggregate;
  /** fetch data from the table: "suggest_project_images" using primary key columns */
  suggest_project_images_by_pk?: Maybe<Suggest_Project_Images>;
  /** An array relationship */
  user_assets: Array<User_Assets>;
  /** An aggregate relationship */
  user_assets_aggregate: User_Assets_Aggregate;
  /** fetch data from the table: "user_assets" using primary key columns */
  user_assets_by_pk?: Maybe<User_Assets>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type QueryChange_Email_OtpArgs = {
  distinct_on?: InputMaybe<Array<Change_Email_Otp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Change_Email_Otp_Order_By>>;
  where?: InputMaybe<Change_Email_Otp_Bool_Exp>;
};


export type QueryChange_Email_Otp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Change_Email_Otp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Change_Email_Otp_Order_By>>;
  where?: InputMaybe<Change_Email_Otp_Bool_Exp>;
};


export type QueryChange_Email_Otp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type QueryComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type QueryComments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryDistrictsArgs = {
  distinct_on?: InputMaybe<Array<Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Districts_Order_By>>;
  where?: InputMaybe<Districts_Bool_Exp>;
};


export type QueryDistricts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Districts_Order_By>>;
  where?: InputMaybe<Districts_Bool_Exp>;
};


export type QueryDistricts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryExpressionsArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


export type QueryExpressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


export type QueryExpressions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryFile_Upload_ParametersArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Parameters_Order_By>>;
  where?: InputMaybe<File_Upload_Parameters_Bool_Exp>;
};


export type QueryFile_Upload_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Parameters_Order_By>>;
  where?: InputMaybe<File_Upload_Parameters_Bool_Exp>;
};


export type QueryFile_Upload_Parameters_By_PkArgs = {
  type: File_Upload_Types_Enum;
};


export type QueryFile_Upload_TypesArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Types_Order_By>>;
  where?: InputMaybe<File_Upload_Types_Bool_Exp>;
};


export type QueryFile_Upload_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Types_Order_By>>;
  where?: InputMaybe<File_Upload_Types_Bool_Exp>;
};


export type QueryFile_Upload_Types_By_PkArgs = {
  type: Scalars['String'];
};


export type QueryInvestment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Investment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Investment_Types_Order_By>>;
  where?: InputMaybe<Investment_Types_Bool_Exp>;
};


export type QueryInvestment_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Investment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Investment_Types_Order_By>>;
  where?: InputMaybe<Investment_Types_Bool_Exp>;
};


export type QueryInvestment_Types_By_PkArgs = {
  type: Scalars['String'];
};


export type QueryInvite_LinksArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


export type QueryInvite_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


export type QueryInvite_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryKyc_StatusArgs = {
  distinct_on?: InputMaybe<Array<Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kyc_Status_Order_By>>;
  where?: InputMaybe<Kyc_Status_Bool_Exp>;
};


export type QueryKyc_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kyc_Status_Order_By>>;
  where?: InputMaybe<Kyc_Status_Bool_Exp>;
};


export type QueryKyc_Status_By_PkArgs = {
  kyc_status: Scalars['String'];
};


export type QueryLikesArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


export type QueryLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


export type QueryLikes_By_PkArgs = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type QueryOtp_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Otp_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otp_Messages_Order_By>>;
  where?: InputMaybe<Otp_Messages_Bool_Exp>;
};


export type QueryOtp_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Otp_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otp_Messages_Order_By>>;
  where?: InputMaybe<Otp_Messages_Bool_Exp>;
};


export type QueryOtp_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryProject_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Project_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Assets_Order_By>>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};


export type QueryProject_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Assets_Order_By>>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};


export type QueryProject_Assets_By_PkArgs = {
  file_name: Scalars['String'];
  id: Scalars['uuid'];
  project_id: Scalars['uuid'];
};


export type QueryProject_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Escalations_Order_By>>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};


export type QueryProject_Escalations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Escalations_Order_By>>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};


export type QueryProject_Escalations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryProject_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Images_Order_By>>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};


export type QueryProject_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Images_Order_By>>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};


export type QueryProject_Images_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryProject_MembersArgs = {
  distinct_on?: InputMaybe<Array<Project_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Members_Order_By>>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};


export type QueryProject_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Members_Order_By>>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};


export type QueryProject_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryProject_PromotionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Promotions_Order_By>>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};


export type QueryProject_Promotions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Promotions_Order_By>>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};


export type QueryProject_Promotions_By_PkArgs = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type QueryProject_Question_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Question_Answers_Order_By>>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};


export type QueryProject_Question_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Question_Answers_Order_By>>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};


export type QueryProject_Question_Answers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryProject_SeveritiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Severities_Order_By>>;
  where?: InputMaybe<Project_Severities_Bool_Exp>;
};


export type QueryProject_Severities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Severities_Order_By>>;
  where?: InputMaybe<Project_Severities_Bool_Exp>;
};


export type QueryProject_Severities_By_PkArgs = {
  severity: Scalars['String'];
};


export type QueryProject_TimelinesArgs = {
  distinct_on?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Timelines_Order_By>>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};


export type QueryProject_Timelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Timelines_Order_By>>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};


export type QueryProject_Timelines_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type QueryProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type QueryProjects_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryRegionsArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type QueryRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type QueryRegions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QuerySuggest_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Order_By>>;
  where?: InputMaybe<Suggest_Project_Bool_Exp>;
};


export type QuerySuggest_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Order_By>>;
  where?: InputMaybe<Suggest_Project_Bool_Exp>;
};


export type QuerySuggest_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QuerySuggest_Project_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Images_Order_By>>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};


export type QuerySuggest_Project_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Images_Order_By>>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};


export type QuerySuggest_Project_Images_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryUser_AssetsArgs = {
  distinct_on?: InputMaybe<Array<User_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assets_Order_By>>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};


export type QueryUser_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assets_Order_By>>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};


export type QueryUser_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type QueryUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type QueryUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type QueryUser_Roles_By_PkArgs = {
  role: Scalars['String'];
};


export type QueryUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type QueryUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type QueryUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

export enum Role {
  Admin = 'ADMIN',
  Anonymous = 'ANONYMOUS',
  User = 'USER'
}

export type Sdl = {
  __typename?: 'SDL';
  sdl: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** fetch data from the table: "change_email_otp" */
  change_email_otp: Array<Change_Email_Otp>;
  /** fetch aggregated fields from the table: "change_email_otp" */
  change_email_otp_aggregate: Change_Email_Otp_Aggregate;
  /** fetch data from the table: "change_email_otp" using primary key columns */
  change_email_otp_by_pk?: Maybe<Change_Email_Otp>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  /** fetch data from the table: "comments" using primary key columns */
  comments_by_pk?: Maybe<Comments>;
  /** fetch data from the table: "districts" */
  districts: Array<Districts>;
  /** fetch aggregated fields from the table: "districts" */
  districts_aggregate: Districts_Aggregate;
  /** fetch data from the table: "districts" using primary key columns */
  districts_by_pk?: Maybe<Districts>;
  /** An array relationship */
  expressions: Array<Expressions>;
  /** An aggregate relationship */
  expressions_aggregate: Expressions_Aggregate;
  /** fetch data from the table: "expressions" using primary key columns */
  expressions_by_pk?: Maybe<Expressions>;
  /** fetch data from the table: "file_upload_parameters" */
  file_upload_parameters: Array<File_Upload_Parameters>;
  /** fetch aggregated fields from the table: "file_upload_parameters" */
  file_upload_parameters_aggregate: File_Upload_Parameters_Aggregate;
  /** fetch data from the table: "file_upload_parameters" using primary key columns */
  file_upload_parameters_by_pk?: Maybe<File_Upload_Parameters>;
  /** fetch data from the table: "file_upload_types" */
  file_upload_types: Array<File_Upload_Types>;
  /** fetch aggregated fields from the table: "file_upload_types" */
  file_upload_types_aggregate: File_Upload_Types_Aggregate;
  /** fetch data from the table: "file_upload_types" using primary key columns */
  file_upload_types_by_pk?: Maybe<File_Upload_Types>;
  /** fetch data from the table: "investment_types" */
  investment_types: Array<Investment_Types>;
  /** fetch aggregated fields from the table: "investment_types" */
  investment_types_aggregate: Investment_Types_Aggregate;
  /** fetch data from the table: "investment_types" using primary key columns */
  investment_types_by_pk?: Maybe<Investment_Types>;
  /** An array relationship */
  invite_links: Array<Invite_Links>;
  /** An aggregate relationship */
  invite_links_aggregate: Invite_Links_Aggregate;
  /** fetch data from the table: "invite_links" using primary key columns */
  invite_links_by_pk?: Maybe<Invite_Links>;
  /** fetch data from the table: "kyc_status" */
  kyc_status: Array<Kyc_Status>;
  /** fetch aggregated fields from the table: "kyc_status" */
  kyc_status_aggregate: Kyc_Status_Aggregate;
  /** fetch data from the table: "kyc_status" using primary key columns */
  kyc_status_by_pk?: Maybe<Kyc_Status>;
  /** An array relationship */
  likes: Array<Likes>;
  /** An aggregate relationship */
  likes_aggregate: Likes_Aggregate;
  /** fetch data from the table: "likes" using primary key columns */
  likes_by_pk?: Maybe<Likes>;
  /** fetch data from the table: "otp_messages" */
  otp_messages: Array<Otp_Messages>;
  /** fetch aggregated fields from the table: "otp_messages" */
  otp_messages_aggregate: Otp_Messages_Aggregate;
  /** fetch data from the table: "otp_messages" using primary key columns */
  otp_messages_by_pk?: Maybe<Otp_Messages>;
  ping: Scalars['String'];
  /** An array relationship */
  project_assets: Array<Project_Assets>;
  /** An aggregate relationship */
  project_assets_aggregate: Project_Assets_Aggregate;
  /** fetch data from the table: "project_assets" using primary key columns */
  project_assets_by_pk?: Maybe<Project_Assets>;
  /** An array relationship */
  project_escalations: Array<Project_Escalations>;
  /** An aggregate relationship */
  project_escalations_aggregate: Project_Escalations_Aggregate;
  /** fetch data from the table: "project_escalations" using primary key columns */
  project_escalations_by_pk?: Maybe<Project_Escalations>;
  /** fetch data from the table: "project_images" */
  project_images: Array<Project_Images>;
  /** fetch aggregated fields from the table: "project_images" */
  project_images_aggregate: Project_Images_Aggregate;
  /** fetch data from the table: "project_images" using primary key columns */
  project_images_by_pk?: Maybe<Project_Images>;
  /** An array relationship */
  project_members: Array<Project_Members>;
  /** An aggregate relationship */
  project_members_aggregate: Project_Members_Aggregate;
  /** fetch data from the table: "project_members" using primary key columns */
  project_members_by_pk?: Maybe<Project_Members>;
  /** fetch data from the table: "project_promotions" */
  project_promotions: Array<Project_Promotions>;
  /** fetch aggregated fields from the table: "project_promotions" */
  project_promotions_aggregate: Project_Promotions_Aggregate;
  /** fetch data from the table: "project_promotions" using primary key columns */
  project_promotions_by_pk?: Maybe<Project_Promotions>;
  /** fetch data from the table: "project_question_answers" */
  project_question_answers: Array<Project_Question_Answers>;
  /** fetch aggregated fields from the table: "project_question_answers" */
  project_question_answers_aggregate: Project_Question_Answers_Aggregate;
  /** fetch data from the table: "project_question_answers" using primary key columns */
  project_question_answers_by_pk?: Maybe<Project_Question_Answers>;
  /** fetch data from the table: "project_severities" */
  project_severities: Array<Project_Severities>;
  /** fetch aggregated fields from the table: "project_severities" */
  project_severities_aggregate: Project_Severities_Aggregate;
  /** fetch data from the table: "project_severities" using primary key columns */
  project_severities_by_pk?: Maybe<Project_Severities>;
  /** fetch data from the table: "project_timelines" */
  project_timelines: Array<Project_Timelines>;
  /** fetch aggregated fields from the table: "project_timelines" */
  project_timelines_aggregate: Project_Timelines_Aggregate;
  /** fetch data from the table: "project_timelines" using primary key columns */
  project_timelines_by_pk?: Maybe<Project_Timelines>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** fetch data from the table: "projects" using primary key columns */
  projects_by_pk?: Maybe<Projects>;
  /** fetch data from the table: "regions" */
  regions: Array<Regions>;
  /** fetch aggregated fields from the table: "regions" */
  regions_aggregate: Regions_Aggregate;
  /** fetch data from the table: "regions" using primary key columns */
  regions_by_pk?: Maybe<Regions>;
  /** fetch data from the table: "suggest_project" */
  suggest_project: Array<Suggest_Project>;
  /** fetch aggregated fields from the table: "suggest_project" */
  suggest_project_aggregate: Suggest_Project_Aggregate;
  /** fetch data from the table: "suggest_project" using primary key columns */
  suggest_project_by_pk?: Maybe<Suggest_Project>;
  /** fetch data from the table: "suggest_project_images" */
  suggest_project_images: Array<Suggest_Project_Images>;
  /** fetch aggregated fields from the table: "suggest_project_images" */
  suggest_project_images_aggregate: Suggest_Project_Images_Aggregate;
  /** fetch data from the table: "suggest_project_images" using primary key columns */
  suggest_project_images_by_pk?: Maybe<Suggest_Project_Images>;
  /** An array relationship */
  user_assets: Array<User_Assets>;
  /** An aggregate relationship */
  user_assets_aggregate: User_Assets_Aggregate;
  /** fetch data from the table: "user_assets" using primary key columns */
  user_assets_by_pk?: Maybe<User_Assets>;
  /** fetch data from the table: "user_roles" */
  user_roles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  user_roles_aggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_roles" using primary key columns */
  user_roles_by_pk?: Maybe<User_Roles>;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type SubscriptionChange_Email_OtpArgs = {
  distinct_on?: InputMaybe<Array<Change_Email_Otp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Change_Email_Otp_Order_By>>;
  where?: InputMaybe<Change_Email_Otp_Bool_Exp>;
};


export type SubscriptionChange_Email_Otp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Change_Email_Otp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Change_Email_Otp_Order_By>>;
  where?: InputMaybe<Change_Email_Otp_Bool_Exp>;
};


export type SubscriptionChange_Email_Otp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type SubscriptionComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


export type SubscriptionComments_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionDistrictsArgs = {
  distinct_on?: InputMaybe<Array<Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Districts_Order_By>>;
  where?: InputMaybe<Districts_Bool_Exp>;
};


export type SubscriptionDistricts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Districts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Districts_Order_By>>;
  where?: InputMaybe<Districts_Bool_Exp>;
};


export type SubscriptionDistricts_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionExpressionsArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


export type SubscriptionExpressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


export type SubscriptionExpressions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionFile_Upload_ParametersArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Parameters_Order_By>>;
  where?: InputMaybe<File_Upload_Parameters_Bool_Exp>;
};


export type SubscriptionFile_Upload_Parameters_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Parameters_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Parameters_Order_By>>;
  where?: InputMaybe<File_Upload_Parameters_Bool_Exp>;
};


export type SubscriptionFile_Upload_Parameters_By_PkArgs = {
  type: File_Upload_Types_Enum;
};


export type SubscriptionFile_Upload_TypesArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Types_Order_By>>;
  where?: InputMaybe<File_Upload_Types_Bool_Exp>;
};


export type SubscriptionFile_Upload_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<File_Upload_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_Upload_Types_Order_By>>;
  where?: InputMaybe<File_Upload_Types_Bool_Exp>;
};


export type SubscriptionFile_Upload_Types_By_PkArgs = {
  type: Scalars['String'];
};


export type SubscriptionInvestment_TypesArgs = {
  distinct_on?: InputMaybe<Array<Investment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Investment_Types_Order_By>>;
  where?: InputMaybe<Investment_Types_Bool_Exp>;
};


export type SubscriptionInvestment_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Investment_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Investment_Types_Order_By>>;
  where?: InputMaybe<Investment_Types_Bool_Exp>;
};


export type SubscriptionInvestment_Types_By_PkArgs = {
  type: Scalars['String'];
};


export type SubscriptionInvite_LinksArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


export type SubscriptionInvite_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


export type SubscriptionInvite_Links_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionKyc_StatusArgs = {
  distinct_on?: InputMaybe<Array<Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kyc_Status_Order_By>>;
  where?: InputMaybe<Kyc_Status_Bool_Exp>;
};


export type SubscriptionKyc_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Kyc_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Kyc_Status_Order_By>>;
  where?: InputMaybe<Kyc_Status_Bool_Exp>;
};


export type SubscriptionKyc_Status_By_PkArgs = {
  kyc_status: Scalars['String'];
};


export type SubscriptionLikesArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


export type SubscriptionLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


export type SubscriptionLikes_By_PkArgs = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type SubscriptionOtp_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Otp_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otp_Messages_Order_By>>;
  where?: InputMaybe<Otp_Messages_Bool_Exp>;
};


export type SubscriptionOtp_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Otp_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Otp_Messages_Order_By>>;
  where?: InputMaybe<Otp_Messages_Bool_Exp>;
};


export type SubscriptionOtp_Messages_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionProject_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Project_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Assets_Order_By>>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};


export type SubscriptionProject_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Assets_Order_By>>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};


export type SubscriptionProject_Assets_By_PkArgs = {
  file_name: Scalars['String'];
  id: Scalars['uuid'];
  project_id: Scalars['uuid'];
};


export type SubscriptionProject_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Escalations_Order_By>>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};


export type SubscriptionProject_Escalations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Escalations_Order_By>>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};


export type SubscriptionProject_Escalations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionProject_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Images_Order_By>>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};


export type SubscriptionProject_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Images_Order_By>>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};


export type SubscriptionProject_Images_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionProject_MembersArgs = {
  distinct_on?: InputMaybe<Array<Project_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Members_Order_By>>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};


export type SubscriptionProject_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Members_Order_By>>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};


export type SubscriptionProject_Members_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionProject_PromotionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Promotions_Order_By>>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};


export type SubscriptionProject_Promotions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Promotions_Order_By>>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};


export type SubscriptionProject_Promotions_By_PkArgs = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};


export type SubscriptionProject_Question_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Question_Answers_Order_By>>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};


export type SubscriptionProject_Question_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Question_Answers_Order_By>>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};


export type SubscriptionProject_Question_Answers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionProject_SeveritiesArgs = {
  distinct_on?: InputMaybe<Array<Project_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Severities_Order_By>>;
  where?: InputMaybe<Project_Severities_Bool_Exp>;
};


export type SubscriptionProject_Severities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Severities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Severities_Order_By>>;
  where?: InputMaybe<Project_Severities_Bool_Exp>;
};


export type SubscriptionProject_Severities_By_PkArgs = {
  severity: Scalars['String'];
};


export type SubscriptionProject_TimelinesArgs = {
  distinct_on?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Timelines_Order_By>>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};


export type SubscriptionProject_Timelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Timelines_Order_By>>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};


export type SubscriptionProject_Timelines_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type SubscriptionProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


export type SubscriptionProjects_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionRegionsArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type SubscriptionRegions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Regions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Regions_Order_By>>;
  where?: InputMaybe<Regions_Bool_Exp>;
};


export type SubscriptionRegions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSuggest_ProjectArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Order_By>>;
  where?: InputMaybe<Suggest_Project_Bool_Exp>;
};


export type SubscriptionSuggest_Project_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Order_By>>;
  where?: InputMaybe<Suggest_Project_Bool_Exp>;
};


export type SubscriptionSuggest_Project_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionSuggest_Project_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Images_Order_By>>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};


export type SubscriptionSuggest_Project_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Images_Order_By>>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};


export type SubscriptionSuggest_Project_Images_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionUser_AssetsArgs = {
  distinct_on?: InputMaybe<Array<User_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assets_Order_By>>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};


export type SubscriptionUser_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assets_Order_By>>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};


export type SubscriptionUser_Assets_By_PkArgs = {
  id: Scalars['uuid'];
};


export type SubscriptionUser_RolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type SubscriptionUser_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type SubscriptionUser_Roles_By_PkArgs = {
  role: Scalars['String'];
};


export type SubscriptionUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type SubscriptionUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type SubscriptionUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

export type UploadFilePayload = {
  __typename?: 'UploadFilePayload';
  downloadUrl: Scalars['String'];
  success: Scalars['Boolean'];
  /** The upload is a JSON string with the following format: */
  uploadParams: Scalars['String'];
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "change_email_otp" */
export type Change_Email_Otp = {
  __typename?: 'change_email_otp';
  created_at: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  otp: Scalars['Int'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "change_email_otp" */
export type Change_Email_Otp_Aggregate = {
  __typename?: 'change_email_otp_aggregate';
  aggregate?: Maybe<Change_Email_Otp_Aggregate_Fields>;
  nodes: Array<Change_Email_Otp>;
};

/** aggregate fields of "change_email_otp" */
export type Change_Email_Otp_Aggregate_Fields = {
  __typename?: 'change_email_otp_aggregate_fields';
  avg?: Maybe<Change_Email_Otp_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Change_Email_Otp_Max_Fields>;
  min?: Maybe<Change_Email_Otp_Min_Fields>;
  stddev?: Maybe<Change_Email_Otp_Stddev_Fields>;
  stddev_pop?: Maybe<Change_Email_Otp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Change_Email_Otp_Stddev_Samp_Fields>;
  sum?: Maybe<Change_Email_Otp_Sum_Fields>;
  var_pop?: Maybe<Change_Email_Otp_Var_Pop_Fields>;
  var_samp?: Maybe<Change_Email_Otp_Var_Samp_Fields>;
  variance?: Maybe<Change_Email_Otp_Variance_Fields>;
};


/** aggregate fields of "change_email_otp" */
export type Change_Email_Otp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Change_Email_Otp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Change_Email_Otp_Avg_Fields = {
  __typename?: 'change_email_otp_avg_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "change_email_otp". All fields are combined with a logical 'AND'. */
export type Change_Email_Otp_Bool_Exp = {
  _and?: InputMaybe<Array<Change_Email_Otp_Bool_Exp>>;
  _not?: InputMaybe<Change_Email_Otp_Bool_Exp>;
  _or?: InputMaybe<Array<Change_Email_Otp_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  otp?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "change_email_otp" */
export enum Change_Email_Otp_Constraint {
  /** unique or primary key constraint on columns "email" */
  ChangeEmailOtpEmailKey = 'change_email_otp_email_key',
  /** unique or primary key constraint on columns "id" */
  ChangeEmailOtpPkey = 'change_email_otp_pkey'
}

/** input type for incrementing numeric columns in table "change_email_otp" */
export type Change_Email_Otp_Inc_Input = {
  otp?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "change_email_otp" */
export type Change_Email_Otp_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  otp?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Change_Email_Otp_Max_Fields = {
  __typename?: 'change_email_otp_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  otp?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Change_Email_Otp_Min_Fields = {
  __typename?: 'change_email_otp_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  otp?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "change_email_otp" */
export type Change_Email_Otp_Mutation_Response = {
  __typename?: 'change_email_otp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Change_Email_Otp>;
};

/** on_conflict condition type for table "change_email_otp" */
export type Change_Email_Otp_On_Conflict = {
  constraint: Change_Email_Otp_Constraint;
  update_columns?: Array<Change_Email_Otp_Update_Column>;
  where?: InputMaybe<Change_Email_Otp_Bool_Exp>;
};

/** Ordering options when selecting data from "change_email_otp". */
export type Change_Email_Otp_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: change_email_otp */
export type Change_Email_Otp_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "change_email_otp" */
export enum Change_Email_Otp_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Otp = 'otp',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "change_email_otp" */
export type Change_Email_Otp_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  otp?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Change_Email_Otp_Stddev_Fields = {
  __typename?: 'change_email_otp_stddev_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Change_Email_Otp_Stddev_Pop_Fields = {
  __typename?: 'change_email_otp_stddev_pop_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Change_Email_Otp_Stddev_Samp_Fields = {
  __typename?: 'change_email_otp_stddev_samp_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Change_Email_Otp_Sum_Fields = {
  __typename?: 'change_email_otp_sum_fields';
  otp?: Maybe<Scalars['Int']>;
};

/** update columns of table "change_email_otp" */
export enum Change_Email_Otp_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Otp = 'otp',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Change_Email_Otp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Change_Email_Otp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Change_Email_Otp_Set_Input>;
  where: Change_Email_Otp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Change_Email_Otp_Var_Pop_Fields = {
  __typename?: 'change_email_otp_var_pop_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Change_Email_Otp_Var_Samp_Fields = {
  __typename?: 'change_email_otp_var_samp_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Change_Email_Otp_Variance_Fields = {
  __typename?: 'change_email_otp_variance_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "comments" */
export type Comments = {
  __typename?: 'comments';
  added_by: Scalars['uuid'];
  comment: Scalars['String'];
  created_at?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  parent_comment_id?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid'];
  /** An array relationship */
  replies: Array<Comments>;
  /** An aggregate relationship */
  replies_aggregate: Comments_Aggregate;
  status?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  user: Users;
};


/** columns and relationships of "comments" */
export type CommentsRepliesArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "comments" */
export type CommentsReplies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** aggregated selection of "comments" */
export type Comments_Aggregate = {
  __typename?: 'comments_aggregate';
  aggregate?: Maybe<Comments_Aggregate_Fields>;
  nodes: Array<Comments>;
};

/** aggregate fields of "comments" */
export type Comments_Aggregate_Fields = {
  __typename?: 'comments_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Comments_Max_Fields>;
  min?: Maybe<Comments_Min_Fields>;
};


/** aggregate fields of "comments" */
export type Comments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Comments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "comments" */
export type Comments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Comments_Max_Order_By>;
  min?: InputMaybe<Comments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "comments" */
export type Comments_Arr_Rel_Insert_Input = {
  data: Array<Comments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "comments". All fields are combined with a logical 'AND'. */
export type Comments_Bool_Exp = {
  _and?: InputMaybe<Array<Comments_Bool_Exp>>;
  _not?: InputMaybe<Comments_Bool_Exp>;
  _or?: InputMaybe<Array<Comments_Bool_Exp>>;
  added_by?: InputMaybe<Uuid_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  parent_comment_id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  replies?: InputMaybe<Comments_Bool_Exp>;
  status?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "comments" */
export enum Comments_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectCommentsPkey = 'project_comments_pkey'
}

/** input type for inserting data into table "comments" */
export type Comments_Insert_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  replies?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  status?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Comments_Max_Fields = {
  __typename?: 'comments_max_fields';
  added_by?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_comment_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "comments" */
export type Comments_Max_Order_By = {
  added_by?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Comments_Min_Fields = {
  __typename?: 'comments_min_fields';
  added_by?: Maybe<Scalars['uuid']>;
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_comment_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "comments" */
export type Comments_Min_Order_By = {
  added_by?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "comments" */
export type Comments_Mutation_Response = {
  __typename?: 'comments_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Comments>;
};

/** on_conflict condition type for table "comments" */
export type Comments_On_Conflict = {
  constraint: Comments_Constraint;
  update_columns?: Array<Comments_Update_Column>;
  where?: InputMaybe<Comments_Bool_Exp>;
};

/** Ordering options when selecting data from "comments". */
export type Comments_Order_By = {
  added_by?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  parent_comment_id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  replies_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: comments */
export type Comments_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "comments" */
export enum Comments_Select_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "comments" */
export type Comments_Set_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  parent_comment_id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "comments" */
export enum Comments_Update_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Comments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comments_Set_Input>;
  where: Comments_Bool_Exp;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "districts" */
export type Districts = {
  __typename?: 'districts';
  constituency?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  district?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  state?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "districts" */
export type Districts_Aggregate = {
  __typename?: 'districts_aggregate';
  aggregate?: Maybe<Districts_Aggregate_Fields>;
  nodes: Array<Districts>;
};

/** aggregate fields of "districts" */
export type Districts_Aggregate_Fields = {
  __typename?: 'districts_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Districts_Max_Fields>;
  min?: Maybe<Districts_Min_Fields>;
};


/** aggregate fields of "districts" */
export type Districts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Districts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "districts". All fields are combined with a logical 'AND'. */
export type Districts_Bool_Exp = {
  _and?: InputMaybe<Array<Districts_Bool_Exp>>;
  _not?: InputMaybe<Districts_Bool_Exp>;
  _or?: InputMaybe<Array<Districts_Bool_Exp>>;
  constituency?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  district?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "districts" */
export enum Districts_Constraint {
  /** unique or primary key constraint on columns "id" */
  DistrictsPkey = 'districts_pkey'
}

/** input type for inserting data into table "districts" */
export type Districts_Insert_Input = {
  constituency?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Districts_Max_Fields = {
  __typename?: 'districts_max_fields';
  constituency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Districts_Min_Fields = {
  __typename?: 'districts_min_fields';
  constituency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  district?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  state?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "districts" */
export type Districts_Mutation_Response = {
  __typename?: 'districts_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Districts>;
};

/** on_conflict condition type for table "districts" */
export type Districts_On_Conflict = {
  constraint: Districts_Constraint;
  update_columns?: Array<Districts_Update_Column>;
  where?: InputMaybe<Districts_Bool_Exp>;
};

/** Ordering options when selecting data from "districts". */
export type Districts_Order_By = {
  constituency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  district?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: districts */
export type Districts_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "districts" */
export enum Districts_Select_Column {
  /** column name */
  Constituency = 'constituency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "districts" */
export type Districts_Set_Input = {
  constituency?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  district?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  state?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "districts" */
export enum Districts_Update_Column {
  /** column name */
  Constituency = 'constituency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  District = 'district',
  /** column name */
  Id = 'id',
  /** column name */
  State = 'state',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Districts_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Districts_Set_Input>;
  where: Districts_Bool_Exp;
};

/** columns and relationships of "expressions" */
export type Expressions = {
  __typename?: 'expressions';
  added_by: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  expression_message: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  investmentTypeByInvestmentType?: Maybe<Investment_Types>;
  investment_amount?: Maybe<Scalars['numeric']>;
  investment_type?: Maybe<Scalars['String']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  participation_type?: Maybe<Scalars['String']>;
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid'];
  status?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
};

/** aggregated selection of "expressions" */
export type Expressions_Aggregate = {
  __typename?: 'expressions_aggregate';
  aggregate?: Maybe<Expressions_Aggregate_Fields>;
  nodes: Array<Expressions>;
};

/** aggregate fields of "expressions" */
export type Expressions_Aggregate_Fields = {
  __typename?: 'expressions_aggregate_fields';
  avg?: Maybe<Expressions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Expressions_Max_Fields>;
  min?: Maybe<Expressions_Min_Fields>;
  stddev?: Maybe<Expressions_Stddev_Fields>;
  stddev_pop?: Maybe<Expressions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Expressions_Stddev_Samp_Fields>;
  sum?: Maybe<Expressions_Sum_Fields>;
  var_pop?: Maybe<Expressions_Var_Pop_Fields>;
  var_samp?: Maybe<Expressions_Var_Samp_Fields>;
  variance?: Maybe<Expressions_Variance_Fields>;
};


/** aggregate fields of "expressions" */
export type Expressions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expressions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "expressions" */
export type Expressions_Aggregate_Order_By = {
  avg?: InputMaybe<Expressions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Expressions_Max_Order_By>;
  min?: InputMaybe<Expressions_Min_Order_By>;
  stddev?: InputMaybe<Expressions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Expressions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Expressions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Expressions_Sum_Order_By>;
  var_pop?: InputMaybe<Expressions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Expressions_Var_Samp_Order_By>;
  variance?: InputMaybe<Expressions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "expressions" */
export type Expressions_Arr_Rel_Insert_Input = {
  data: Array<Expressions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Expressions_On_Conflict>;
};

/** aggregate avg on columns */
export type Expressions_Avg_Fields = {
  __typename?: 'expressions_avg_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "expressions" */
export type Expressions_Avg_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "expressions". All fields are combined with a logical 'AND'. */
export type Expressions_Bool_Exp = {
  _and?: InputMaybe<Array<Expressions_Bool_Exp>>;
  _not?: InputMaybe<Expressions_Bool_Exp>;
  _or?: InputMaybe<Array<Expressions_Bool_Exp>>;
  added_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expression_message?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  investmentTypeByInvestmentType?: InputMaybe<Investment_Types_Bool_Exp>;
  investment_amount?: InputMaybe<Numeric_Comparison_Exp>;
  investment_type?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  participation_type?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "expressions" */
export enum Expressions_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectExpressionsPkey = 'project_expressions_pkey'
}

/** input type for incrementing numeric columns in table "expressions" */
export type Expressions_Inc_Input = {
  investment_amount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "expressions" */
export type Expressions_Insert_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expression_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  investmentTypeByInvestmentType?: InputMaybe<Investment_Types_Obj_Rel_Insert_Input>;
  investment_amount?: InputMaybe<Scalars['numeric']>;
  investment_type?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  participation_type?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Expressions_Max_Fields = {
  __typename?: 'expressions_max_fields';
  added_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expression_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  investment_amount?: Maybe<Scalars['numeric']>;
  investment_type?: Maybe<Scalars['String']>;
  participation_type?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "expressions" */
export type Expressions_Max_Order_By = {
  added_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expression_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  investment_type?: InputMaybe<Order_By>;
  participation_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Expressions_Min_Fields = {
  __typename?: 'expressions_min_fields';
  added_by?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expression_message?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  investment_amount?: Maybe<Scalars['numeric']>;
  investment_type?: Maybe<Scalars['String']>;
  participation_type?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "expressions" */
export type Expressions_Min_Order_By = {
  added_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expression_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  investment_type?: InputMaybe<Order_By>;
  participation_type?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "expressions" */
export type Expressions_Mutation_Response = {
  __typename?: 'expressions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Expressions>;
};

/** on_conflict condition type for table "expressions" */
export type Expressions_On_Conflict = {
  constraint: Expressions_Constraint;
  update_columns?: Array<Expressions_Update_Column>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};

/** Ordering options when selecting data from "expressions". */
export type Expressions_Order_By = {
  added_by?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expression_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  investmentTypeByInvestmentType?: InputMaybe<Investment_Types_Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  investment_type?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  participation_type?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: expressions */
export type Expressions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "expressions" */
export enum Expressions_Select_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpressionMessage = 'expression_message',
  /** column name */
  Id = 'id',
  /** column name */
  InvestmentAmount = 'investment_amount',
  /** column name */
  InvestmentType = 'investment_type',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  ParticipationType = 'participation_type',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "expressions" */
export type Expressions_Set_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expression_message?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  investment_amount?: InputMaybe<Scalars['numeric']>;
  investment_type?: InputMaybe<Scalars['String']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  participation_type?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Expressions_Stddev_Fields = {
  __typename?: 'expressions_stddev_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "expressions" */
export type Expressions_Stddev_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Expressions_Stddev_Pop_Fields = {
  __typename?: 'expressions_stddev_pop_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "expressions" */
export type Expressions_Stddev_Pop_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Expressions_Stddev_Samp_Fields = {
  __typename?: 'expressions_stddev_samp_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "expressions" */
export type Expressions_Stddev_Samp_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Expressions_Sum_Fields = {
  __typename?: 'expressions_sum_fields';
  investment_amount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "expressions" */
export type Expressions_Sum_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** update columns of table "expressions" */
export enum Expressions_Update_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpressionMessage = 'expression_message',
  /** column name */
  Id = 'id',
  /** column name */
  InvestmentAmount = 'investment_amount',
  /** column name */
  InvestmentType = 'investment_type',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  ParticipationType = 'participation_type',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Expressions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Expressions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Expressions_Set_Input>;
  where: Expressions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Expressions_Var_Pop_Fields = {
  __typename?: 'expressions_var_pop_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "expressions" */
export type Expressions_Var_Pop_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Expressions_Var_Samp_Fields = {
  __typename?: 'expressions_var_samp_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "expressions" */
export type Expressions_Var_Samp_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Expressions_Variance_Fields = {
  __typename?: 'expressions_variance_fields';
  investment_amount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "expressions" */
export type Expressions_Variance_Order_By = {
  investment_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "file_upload_parameters" */
export type File_Upload_Parameters = {
  __typename?: 'file_upload_parameters';
  allowed_file_types: Scalars['String'];
  max_file_size_in_mb: Scalars['Int'];
  path_regex: Scalars['String'];
  type: File_Upload_Types_Enum;
};

/** aggregated selection of "file_upload_parameters" */
export type File_Upload_Parameters_Aggregate = {
  __typename?: 'file_upload_parameters_aggregate';
  aggregate?: Maybe<File_Upload_Parameters_Aggregate_Fields>;
  nodes: Array<File_Upload_Parameters>;
};

/** aggregate fields of "file_upload_parameters" */
export type File_Upload_Parameters_Aggregate_Fields = {
  __typename?: 'file_upload_parameters_aggregate_fields';
  avg?: Maybe<File_Upload_Parameters_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<File_Upload_Parameters_Max_Fields>;
  min?: Maybe<File_Upload_Parameters_Min_Fields>;
  stddev?: Maybe<File_Upload_Parameters_Stddev_Fields>;
  stddev_pop?: Maybe<File_Upload_Parameters_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<File_Upload_Parameters_Stddev_Samp_Fields>;
  sum?: Maybe<File_Upload_Parameters_Sum_Fields>;
  var_pop?: Maybe<File_Upload_Parameters_Var_Pop_Fields>;
  var_samp?: Maybe<File_Upload_Parameters_Var_Samp_Fields>;
  variance?: Maybe<File_Upload_Parameters_Variance_Fields>;
};


/** aggregate fields of "file_upload_parameters" */
export type File_Upload_Parameters_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Upload_Parameters_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type File_Upload_Parameters_Avg_Fields = {
  __typename?: 'file_upload_parameters_avg_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "file_upload_parameters". All fields are combined with a logical 'AND'. */
export type File_Upload_Parameters_Bool_Exp = {
  _and?: InputMaybe<Array<File_Upload_Parameters_Bool_Exp>>;
  _not?: InputMaybe<File_Upload_Parameters_Bool_Exp>;
  _or?: InputMaybe<Array<File_Upload_Parameters_Bool_Exp>>;
  allowed_file_types?: InputMaybe<String_Comparison_Exp>;
  max_file_size_in_mb?: InputMaybe<Int_Comparison_Exp>;
  path_regex?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<File_Upload_Types_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_upload_parameters" */
export enum File_Upload_Parameters_Constraint {
  /** unique or primary key constraint on columns "type" */
  FileUploadParametersPkey = 'file_upload_parameters_pkey'
}

/** input type for incrementing numeric columns in table "file_upload_parameters" */
export type File_Upload_Parameters_Inc_Input = {
  max_file_size_in_mb?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "file_upload_parameters" */
export type File_Upload_Parameters_Insert_Input = {
  allowed_file_types?: InputMaybe<Scalars['String']>;
  max_file_size_in_mb?: InputMaybe<Scalars['Int']>;
  path_regex?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<File_Upload_Types_Enum>;
};

/** aggregate max on columns */
export type File_Upload_Parameters_Max_Fields = {
  __typename?: 'file_upload_parameters_max_fields';
  allowed_file_types?: Maybe<Scalars['String']>;
  max_file_size_in_mb?: Maybe<Scalars['Int']>;
  path_regex?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_Upload_Parameters_Min_Fields = {
  __typename?: 'file_upload_parameters_min_fields';
  allowed_file_types?: Maybe<Scalars['String']>;
  max_file_size_in_mb?: Maybe<Scalars['Int']>;
  path_regex?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file_upload_parameters" */
export type File_Upload_Parameters_Mutation_Response = {
  __typename?: 'file_upload_parameters_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File_Upload_Parameters>;
};

/** on_conflict condition type for table "file_upload_parameters" */
export type File_Upload_Parameters_On_Conflict = {
  constraint: File_Upload_Parameters_Constraint;
  update_columns?: Array<File_Upload_Parameters_Update_Column>;
  where?: InputMaybe<File_Upload_Parameters_Bool_Exp>;
};

/** Ordering options when selecting data from "file_upload_parameters". */
export type File_Upload_Parameters_Order_By = {
  allowed_file_types?: InputMaybe<Order_By>;
  max_file_size_in_mb?: InputMaybe<Order_By>;
  path_regex?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file_upload_parameters */
export type File_Upload_Parameters_Pk_Columns_Input = {
  type: File_Upload_Types_Enum;
};

/** select columns of table "file_upload_parameters" */
export enum File_Upload_Parameters_Select_Column {
  /** column name */
  AllowedFileTypes = 'allowed_file_types',
  /** column name */
  MaxFileSizeInMb = 'max_file_size_in_mb',
  /** column name */
  PathRegex = 'path_regex',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "file_upload_parameters" */
export type File_Upload_Parameters_Set_Input = {
  allowed_file_types?: InputMaybe<Scalars['String']>;
  max_file_size_in_mb?: InputMaybe<Scalars['Int']>;
  path_regex?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<File_Upload_Types_Enum>;
};

/** aggregate stddev on columns */
export type File_Upload_Parameters_Stddev_Fields = {
  __typename?: 'file_upload_parameters_stddev_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type File_Upload_Parameters_Stddev_Pop_Fields = {
  __typename?: 'file_upload_parameters_stddev_pop_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type File_Upload_Parameters_Stddev_Samp_Fields = {
  __typename?: 'file_upload_parameters_stddev_samp_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type File_Upload_Parameters_Sum_Fields = {
  __typename?: 'file_upload_parameters_sum_fields';
  max_file_size_in_mb?: Maybe<Scalars['Int']>;
};

/** update columns of table "file_upload_parameters" */
export enum File_Upload_Parameters_Update_Column {
  /** column name */
  AllowedFileTypes = 'allowed_file_types',
  /** column name */
  MaxFileSizeInMb = 'max_file_size_in_mb',
  /** column name */
  PathRegex = 'path_regex',
  /** column name */
  Type = 'type'
}

export type File_Upload_Parameters_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<File_Upload_Parameters_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Upload_Parameters_Set_Input>;
  where: File_Upload_Parameters_Bool_Exp;
};

/** aggregate var_pop on columns */
export type File_Upload_Parameters_Var_Pop_Fields = {
  __typename?: 'file_upload_parameters_var_pop_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type File_Upload_Parameters_Var_Samp_Fields = {
  __typename?: 'file_upload_parameters_var_samp_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type File_Upload_Parameters_Variance_Fields = {
  __typename?: 'file_upload_parameters_variance_fields';
  max_file_size_in_mb?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "file_upload_types" */
export type File_Upload_Types = {
  __typename?: 'file_upload_types';
  type: Scalars['String'];
};

/** aggregated selection of "file_upload_types" */
export type File_Upload_Types_Aggregate = {
  __typename?: 'file_upload_types_aggregate';
  aggregate?: Maybe<File_Upload_Types_Aggregate_Fields>;
  nodes: Array<File_Upload_Types>;
};

/** aggregate fields of "file_upload_types" */
export type File_Upload_Types_Aggregate_Fields = {
  __typename?: 'file_upload_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<File_Upload_Types_Max_Fields>;
  min?: Maybe<File_Upload_Types_Min_Fields>;
};


/** aggregate fields of "file_upload_types" */
export type File_Upload_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_Upload_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file_upload_types". All fields are combined with a logical 'AND'. */
export type File_Upload_Types_Bool_Exp = {
  _and?: InputMaybe<Array<File_Upload_Types_Bool_Exp>>;
  _not?: InputMaybe<File_Upload_Types_Bool_Exp>;
  _or?: InputMaybe<Array<File_Upload_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_upload_types" */
export enum File_Upload_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  FileUploadTypesPkey = 'file_upload_types_pkey'
}

export enum File_Upload_Types_Enum {
  Default = 'default',
  Documents = 'documents',
  Images = 'images',
  Kyc = 'kyc',
  ProfilePictures = 'profile_pictures'
}

/** Boolean expression to compare columns of type "file_upload_types_enum". All fields are combined with logical 'AND'. */
export type File_Upload_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<File_Upload_Types_Enum>;
  _in?: InputMaybe<Array<File_Upload_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<File_Upload_Types_Enum>;
  _nin?: InputMaybe<Array<File_Upload_Types_Enum>>;
};

/** input type for inserting data into table "file_upload_types" */
export type File_Upload_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type File_Upload_Types_Max_Fields = {
  __typename?: 'file_upload_types_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_Upload_Types_Min_Fields = {
  __typename?: 'file_upload_types_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file_upload_types" */
export type File_Upload_Types_Mutation_Response = {
  __typename?: 'file_upload_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File_Upload_Types>;
};

/** on_conflict condition type for table "file_upload_types" */
export type File_Upload_Types_On_Conflict = {
  constraint: File_Upload_Types_Constraint;
  update_columns?: Array<File_Upload_Types_Update_Column>;
  where?: InputMaybe<File_Upload_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "file_upload_types". */
export type File_Upload_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file_upload_types */
export type File_Upload_Types_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "file_upload_types" */
export enum File_Upload_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "file_upload_types" */
export type File_Upload_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "file_upload_types" */
export enum File_Upload_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type File_Upload_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_Upload_Types_Set_Input>;
  where: File_Upload_Types_Bool_Exp;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']>;
  _gt?: InputMaybe<Scalars['geography']>;
  _gte?: InputMaybe<Scalars['geography']>;
  _in?: InputMaybe<Array<Scalars['geography']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geography']>;
  _lte?: InputMaybe<Scalars['geography']>;
  _neq?: InputMaybe<Scalars['geography']>;
  _nin?: InputMaybe<Array<Scalars['geography']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']>;
  _gt?: InputMaybe<Scalars['geometry']>;
  _gte?: InputMaybe<Scalars['geometry']>;
  _in?: InputMaybe<Array<Scalars['geometry']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['geometry']>;
  _lte?: InputMaybe<Scalars['geometry']>;
  _neq?: InputMaybe<Scalars['geometry']>;
  _nin?: InputMaybe<Array<Scalars['geometry']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']>;
};

/** columns and relationships of "investment_types" */
export type Investment_Types = {
  __typename?: 'investment_types';
  type: Scalars['String'];
};

/** aggregated selection of "investment_types" */
export type Investment_Types_Aggregate = {
  __typename?: 'investment_types_aggregate';
  aggregate?: Maybe<Investment_Types_Aggregate_Fields>;
  nodes: Array<Investment_Types>;
};

/** aggregate fields of "investment_types" */
export type Investment_Types_Aggregate_Fields = {
  __typename?: 'investment_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Investment_Types_Max_Fields>;
  min?: Maybe<Investment_Types_Min_Fields>;
};


/** aggregate fields of "investment_types" */
export type Investment_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Investment_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "investment_types". All fields are combined with a logical 'AND'. */
export type Investment_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Investment_Types_Bool_Exp>>;
  _not?: InputMaybe<Investment_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Investment_Types_Bool_Exp>>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "investment_types" */
export enum Investment_Types_Constraint {
  /** unique or primary key constraint on columns "type" */
  InvestmentTypesPkey = 'investment_types_pkey'
}

/** input type for inserting data into table "investment_types" */
export type Investment_Types_Insert_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Investment_Types_Max_Fields = {
  __typename?: 'investment_types_max_fields';
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Investment_Types_Min_Fields = {
  __typename?: 'investment_types_min_fields';
  type?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "investment_types" */
export type Investment_Types_Mutation_Response = {
  __typename?: 'investment_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Investment_Types>;
};

/** input type for inserting object relation for remote table "investment_types" */
export type Investment_Types_Obj_Rel_Insert_Input = {
  data: Investment_Types_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Investment_Types_On_Conflict>;
};

/** on_conflict condition type for table "investment_types" */
export type Investment_Types_On_Conflict = {
  constraint: Investment_Types_Constraint;
  update_columns?: Array<Investment_Types_Update_Column>;
  where?: InputMaybe<Investment_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "investment_types". */
export type Investment_Types_Order_By = {
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: investment_types */
export type Investment_Types_Pk_Columns_Input = {
  type: Scalars['String'];
};

/** select columns of table "investment_types" */
export enum Investment_Types_Select_Column {
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "investment_types" */
export type Investment_Types_Set_Input = {
  type?: InputMaybe<Scalars['String']>;
};

/** update columns of table "investment_types" */
export enum Investment_Types_Update_Column {
  /** column name */
  Type = 'type'
}

export type Investment_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Investment_Types_Set_Input>;
  where: Investment_Types_Bool_Exp;
};

/** columns and relationships of "invite_links" */
export type Invite_Links = {
  __typename?: 'invite_links';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  invited_user?: Maybe<Users>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  is_all?: Maybe<Scalars['Boolean']>;
  is_clicked?: Maybe<Scalars['Boolean']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "invite_links" */
export type Invite_Links_Aggregate = {
  __typename?: 'invite_links_aggregate';
  aggregate?: Maybe<Invite_Links_Aggregate_Fields>;
  nodes: Array<Invite_Links>;
};

/** aggregate fields of "invite_links" */
export type Invite_Links_Aggregate_Fields = {
  __typename?: 'invite_links_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Invite_Links_Max_Fields>;
  min?: Maybe<Invite_Links_Min_Fields>;
};


/** aggregate fields of "invite_links" */
export type Invite_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invite_Links_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "invite_links" */
export type Invite_Links_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invite_Links_Max_Order_By>;
  min?: InputMaybe<Invite_Links_Min_Order_By>;
};

/** input type for inserting array relation for remote table "invite_links" */
export type Invite_Links_Arr_Rel_Insert_Input = {
  data: Array<Invite_Links_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Invite_Links_On_Conflict>;
};

/** Boolean expression to filter rows from the table "invite_links". All fields are combined with a logical 'AND'. */
export type Invite_Links_Bool_Exp = {
  _and?: InputMaybe<Array<Invite_Links_Bool_Exp>>;
  _not?: InputMaybe<Invite_Links_Bool_Exp>;
  _or?: InputMaybe<Array<Invite_Links_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_user?: InputMaybe<Users_Bool_Exp>;
  invited_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_all?: InputMaybe<Boolean_Comparison_Exp>;
  is_clicked?: InputMaybe<Boolean_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "invite_links" */
export enum Invite_Links_Constraint {
  /** unique or primary key constraint on columns "id" */
  InviteLinksPkey = 'invite_links_pkey'
}

/** input type for inserting data into table "invite_links" */
export type Invite_Links_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_all?: InputMaybe<Scalars['Boolean']>;
  is_clicked?: InputMaybe<Scalars['Boolean']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Invite_Links_Max_Fields = {
  __typename?: 'invite_links_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "invite_links" */
export type Invite_Links_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_user_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invite_Links_Min_Fields = {
  __typename?: 'invite_links_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  invited_user_id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "invite_links" */
export type Invite_Links_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_user_id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "invite_links" */
export type Invite_Links_Mutation_Response = {
  __typename?: 'invite_links_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Invite_Links>;
};

/** on_conflict condition type for table "invite_links" */
export type Invite_Links_On_Conflict = {
  constraint: Invite_Links_Constraint;
  update_columns?: Array<Invite_Links_Update_Column>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};

/** Ordering options when selecting data from "invite_links". */
export type Invite_Links_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_user?: InputMaybe<Users_Order_By>;
  invited_user_id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_all?: InputMaybe<Order_By>;
  is_clicked?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invite_links */
export type Invite_Links_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "invite_links" */
export enum Invite_Links_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedUserId = 'invited_user_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAll = 'is_all',
  /** column name */
  IsClicked = 'is_clicked',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "invite_links" */
export type Invite_Links_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_user_id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_all?: InputMaybe<Scalars['Boolean']>;
  is_clicked?: InputMaybe<Scalars['Boolean']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "invite_links" */
export enum Invite_Links_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedUserId = 'invited_user_id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsAll = 'is_all',
  /** column name */
  IsClicked = 'is_clicked',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Invite_Links_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invite_Links_Set_Input>;
  where: Invite_Links_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "kyc_status" */
export type Kyc_Status = {
  __typename?: 'kyc_status';
  kyc_status: Scalars['String'];
};

/** aggregated selection of "kyc_status" */
export type Kyc_Status_Aggregate = {
  __typename?: 'kyc_status_aggregate';
  aggregate?: Maybe<Kyc_Status_Aggregate_Fields>;
  nodes: Array<Kyc_Status>;
};

/** aggregate fields of "kyc_status" */
export type Kyc_Status_Aggregate_Fields = {
  __typename?: 'kyc_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Kyc_Status_Max_Fields>;
  min?: Maybe<Kyc_Status_Min_Fields>;
};


/** aggregate fields of "kyc_status" */
export type Kyc_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Kyc_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "kyc_status". All fields are combined with a logical 'AND'. */
export type Kyc_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Kyc_Status_Bool_Exp>>;
  _not?: InputMaybe<Kyc_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Kyc_Status_Bool_Exp>>;
  kyc_status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "kyc_status" */
export enum Kyc_Status_Constraint {
  /** unique or primary key constraint on columns "kyc_status" */
  KycStatusPkey = 'kyc_status_pkey'
}

export enum Kyc_Status_Enum {
  Accepted = 'accepted',
  Pending = 'pending',
  Rejected = 'rejected'
}

/** Boolean expression to compare columns of type "kyc_status_enum". All fields are combined with logical 'AND'. */
export type Kyc_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Kyc_Status_Enum>;
  _in?: InputMaybe<Array<Kyc_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Kyc_Status_Enum>;
  _nin?: InputMaybe<Array<Kyc_Status_Enum>>;
};

/** input type for inserting data into table "kyc_status" */
export type Kyc_Status_Insert_Input = {
  kyc_status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Kyc_Status_Max_Fields = {
  __typename?: 'kyc_status_max_fields';
  kyc_status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Kyc_Status_Min_Fields = {
  __typename?: 'kyc_status_min_fields';
  kyc_status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "kyc_status" */
export type Kyc_Status_Mutation_Response = {
  __typename?: 'kyc_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Kyc_Status>;
};

/** on_conflict condition type for table "kyc_status" */
export type Kyc_Status_On_Conflict = {
  constraint: Kyc_Status_Constraint;
  update_columns?: Array<Kyc_Status_Update_Column>;
  where?: InputMaybe<Kyc_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "kyc_status". */
export type Kyc_Status_Order_By = {
  kyc_status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: kyc_status */
export type Kyc_Status_Pk_Columns_Input = {
  kyc_status: Scalars['String'];
};

/** select columns of table "kyc_status" */
export enum Kyc_Status_Select_Column {
  /** column name */
  KycStatus = 'kyc_status'
}

/** input type for updating data in table "kyc_status" */
export type Kyc_Status_Set_Input = {
  kyc_status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "kyc_status" */
export enum Kyc_Status_Update_Column {
  /** column name */
  KycStatus = 'kyc_status'
}

export type Kyc_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Kyc_Status_Set_Input>;
  where: Kyc_Status_Bool_Exp;
};

/** columns and relationships of "likes" */
export type Likes = {
  __typename?: 'likes';
  created_at: Scalars['timestamptz'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "likes" */
export type Likes_Aggregate = {
  __typename?: 'likes_aggregate';
  aggregate?: Maybe<Likes_Aggregate_Fields>;
  nodes: Array<Likes>;
};

/** aggregate fields of "likes" */
export type Likes_Aggregate_Fields = {
  __typename?: 'likes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Likes_Max_Fields>;
  min?: Maybe<Likes_Min_Fields>;
};


/** aggregate fields of "likes" */
export type Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "likes" */
export type Likes_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Likes_Max_Order_By>;
  min?: InputMaybe<Likes_Min_Order_By>;
};

/** input type for inserting array relation for remote table "likes" */
export type Likes_Arr_Rel_Insert_Input = {
  data: Array<Likes_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Likes_On_Conflict>;
};

/** Boolean expression to filter rows from the table "likes". All fields are combined with a logical 'AND'. */
export type Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Likes_Bool_Exp>>;
  _not?: InputMaybe<Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Likes_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "likes" */
export enum Likes_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id" */
  ProjectLikesPkey = 'project_likes_pkey'
}

/** input type for inserting data into table "likes" */
export type Likes_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Likes_Max_Fields = {
  __typename?: 'likes_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "likes" */
export type Likes_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Likes_Min_Fields = {
  __typename?: 'likes_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  project_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "likes" */
export type Likes_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "likes" */
export type Likes_Mutation_Response = {
  __typename?: 'likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Likes>;
};

/** on_conflict condition type for table "likes" */
export type Likes_On_Conflict = {
  constraint: Likes_Constraint;
  update_columns?: Array<Likes_Update_Column>;
  where?: InputMaybe<Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "likes". */
export type Likes_Order_By = {
  created_at?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: likes */
export type Likes_Pk_Columns_Input = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "likes" */
export enum Likes_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "likes" */
export type Likes_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "likes" */
export enum Likes_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UserId = 'user_id'
}

export type Likes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Likes_Set_Input>;
  where: Likes_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "otp_messages" */
export type Otp_Messages = {
  __typename?: 'otp_messages';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  otp: Scalars['Int'];
  phone_number?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "otp_messages" */
export type Otp_Messages_Aggregate = {
  __typename?: 'otp_messages_aggregate';
  aggregate?: Maybe<Otp_Messages_Aggregate_Fields>;
  nodes: Array<Otp_Messages>;
};

/** aggregate fields of "otp_messages" */
export type Otp_Messages_Aggregate_Fields = {
  __typename?: 'otp_messages_aggregate_fields';
  avg?: Maybe<Otp_Messages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Otp_Messages_Max_Fields>;
  min?: Maybe<Otp_Messages_Min_Fields>;
  stddev?: Maybe<Otp_Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Otp_Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Otp_Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Otp_Messages_Sum_Fields>;
  var_pop?: Maybe<Otp_Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Otp_Messages_Var_Samp_Fields>;
  variance?: Maybe<Otp_Messages_Variance_Fields>;
};


/** aggregate fields of "otp_messages" */
export type Otp_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Otp_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Otp_Messages_Avg_Fields = {
  __typename?: 'otp_messages_avg_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "otp_messages". All fields are combined with a logical 'AND'. */
export type Otp_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Otp_Messages_Bool_Exp>>;
  _not?: InputMaybe<Otp_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Otp_Messages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  otp?: InputMaybe<Int_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "otp_messages" */
export enum Otp_Messages_Constraint {
  /** unique or primary key constraint on columns "phone_number" */
  OtpMessagesPhoneNumberKey = 'otp_messages_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  OtpMessagesPkey = 'otp_messages_pkey'
}

/** input type for incrementing numeric columns in table "otp_messages" */
export type Otp_Messages_Inc_Input = {
  otp?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "otp_messages" */
export type Otp_Messages_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  otp?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Otp_Messages_Max_Fields = {
  __typename?: 'otp_messages_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  otp?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Otp_Messages_Min_Fields = {
  __typename?: 'otp_messages_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  otp?: Maybe<Scalars['Int']>;
  phone_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "otp_messages" */
export type Otp_Messages_Mutation_Response = {
  __typename?: 'otp_messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Otp_Messages>;
};

/** on_conflict condition type for table "otp_messages" */
export type Otp_Messages_On_Conflict = {
  constraint: Otp_Messages_Constraint;
  update_columns?: Array<Otp_Messages_Update_Column>;
  where?: InputMaybe<Otp_Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "otp_messages". */
export type Otp_Messages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  otp?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: otp_messages */
export type Otp_Messages_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "otp_messages" */
export enum Otp_Messages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Otp = 'otp',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "otp_messages" */
export type Otp_Messages_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  otp?: InputMaybe<Scalars['Int']>;
  phone_number?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Otp_Messages_Stddev_Fields = {
  __typename?: 'otp_messages_stddev_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Otp_Messages_Stddev_Pop_Fields = {
  __typename?: 'otp_messages_stddev_pop_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Otp_Messages_Stddev_Samp_Fields = {
  __typename?: 'otp_messages_stddev_samp_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate sum on columns */
export type Otp_Messages_Sum_Fields = {
  __typename?: 'otp_messages_sum_fields';
  otp?: Maybe<Scalars['Int']>;
};

/** update columns of table "otp_messages" */
export enum Otp_Messages_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Otp = 'otp',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Otp_Messages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Otp_Messages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Otp_Messages_Set_Input>;
  where: Otp_Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Otp_Messages_Var_Pop_Fields = {
  __typename?: 'otp_messages_var_pop_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Otp_Messages_Var_Samp_Fields = {
  __typename?: 'otp_messages_var_samp_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Otp_Messages_Variance_Fields = {
  __typename?: 'otp_messages_variance_fields';
  otp?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "project_assets" */
export type Project_Assets = {
  __typename?: 'project_assets';
  asset_type?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  file_name: Scalars['String'];
  id: Scalars['uuid'];
  project_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  url: Scalars['String'];
};

/** aggregated selection of "project_assets" */
export type Project_Assets_Aggregate = {
  __typename?: 'project_assets_aggregate';
  aggregate?: Maybe<Project_Assets_Aggregate_Fields>;
  nodes: Array<Project_Assets>;
};

/** aggregate fields of "project_assets" */
export type Project_Assets_Aggregate_Fields = {
  __typename?: 'project_assets_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Assets_Max_Fields>;
  min?: Maybe<Project_Assets_Min_Fields>;
};


/** aggregate fields of "project_assets" */
export type Project_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_assets" */
export type Project_Assets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Assets_Max_Order_By>;
  min?: InputMaybe<Project_Assets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_assets" */
export type Project_Assets_Arr_Rel_Insert_Input = {
  data: Array<Project_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Assets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_assets". All fields are combined with a logical 'AND'. */
export type Project_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Assets_Bool_Exp>>;
  _not?: InputMaybe<Project_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Assets_Bool_Exp>>;
  asset_type?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_assets" */
export enum Project_Assets_Constraint {
  /** unique or primary key constraint on columns "project_id", "id", "file_name" */
  ProjectAssetsPkey = 'project_assets_pkey'
}

/** input type for inserting data into table "project_assets" */
export type Project_Assets_Insert_Input = {
  asset_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Assets_Max_Fields = {
  __typename?: 'project_assets_max_fields';
  asset_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_assets" */
export type Project_Assets_Max_Order_By = {
  asset_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Assets_Min_Fields = {
  __typename?: 'project_assets_min_fields';
  asset_type?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_assets" */
export type Project_Assets_Min_Order_By = {
  asset_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_assets" */
export type Project_Assets_Mutation_Response = {
  __typename?: 'project_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Assets>;
};

/** on_conflict condition type for table "project_assets" */
export type Project_Assets_On_Conflict = {
  constraint: Project_Assets_Constraint;
  update_columns?: Array<Project_Assets_Update_Column>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "project_assets". */
export type Project_Assets_Order_By = {
  asset_type?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_assets */
export type Project_Assets_Pk_Columns_Input = {
  file_name: Scalars['String'];
  id: Scalars['uuid'];
  project_id: Scalars['uuid'];
};

/** select columns of table "project_assets" */
export enum Project_Assets_Select_Column {
  /** column name */
  AssetType = 'asset_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "project_assets" */
export type Project_Assets_Set_Input = {
  asset_type?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_assets" */
export enum Project_Assets_Update_Column {
  /** column name */
  AssetType = 'asset_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type Project_Assets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Assets_Set_Input>;
  where: Project_Assets_Bool_Exp;
};

/** columns and relationships of "project_escalations" */
export type Project_Escalations = {
  __typename?: 'project_escalations';
  created_at: Scalars['timestamptz'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  /** An object relationship */
  project: Projects;
  project_cost: Scalars['String'];
  project_id: Scalars['uuid'];
};

/** aggregated selection of "project_escalations" */
export type Project_Escalations_Aggregate = {
  __typename?: 'project_escalations_aggregate';
  aggregate?: Maybe<Project_Escalations_Aggregate_Fields>;
  nodes: Array<Project_Escalations>;
};

/** aggregate fields of "project_escalations" */
export type Project_Escalations_Aggregate_Fields = {
  __typename?: 'project_escalations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Escalations_Max_Fields>;
  min?: Maybe<Project_Escalations_Min_Fields>;
};


/** aggregate fields of "project_escalations" */
export type Project_Escalations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_escalations" */
export type Project_Escalations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Escalations_Max_Order_By>;
  min?: InputMaybe<Project_Escalations_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_escalations" */
export type Project_Escalations_Arr_Rel_Insert_Input = {
  data: Array<Project_Escalations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Escalations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_escalations". All fields are combined with a logical 'AND'. */
export type Project_Escalations_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Escalations_Bool_Exp>>;
  _not?: InputMaybe<Project_Escalations_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Escalations_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_cost?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_escalations" */
export enum Project_Escalations_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectEscalationsPkey = 'project_escalations_pkey'
}

/** input type for inserting data into table "project_escalations" */
export type Project_Escalations_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_cost?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Project_Escalations_Max_Fields = {
  __typename?: 'project_escalations_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_cost?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "project_escalations" */
export type Project_Escalations_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_cost?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Escalations_Min_Fields = {
  __typename?: 'project_escalations_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_cost?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "project_escalations" */
export type Project_Escalations_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_cost?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_escalations" */
export type Project_Escalations_Mutation_Response = {
  __typename?: 'project_escalations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Escalations>;
};

/** on_conflict condition type for table "project_escalations" */
export type Project_Escalations_On_Conflict = {
  constraint: Project_Escalations_Constraint;
  update_columns?: Array<Project_Escalations_Update_Column>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};

/** Ordering options when selecting data from "project_escalations". */
export type Project_Escalations_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_cost?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_escalations */
export type Project_Escalations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_escalations" */
export enum Project_Escalations_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectCost = 'project_cost',
  /** column name */
  ProjectId = 'project_id'
}

/** input type for updating data in table "project_escalations" */
export type Project_Escalations_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_cost?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "project_escalations" */
export enum Project_Escalations_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectCost = 'project_cost',
  /** column name */
  ProjectId = 'project_id'
}

export type Project_Escalations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Escalations_Set_Input>;
  where: Project_Escalations_Bool_Exp;
};

/** columns and relationships of "project_images" */
export type Project_Images = {
  __typename?: 'project_images';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  /** An object relationship */
  project?: Maybe<Projects>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "project_images" */
export type Project_Images_Aggregate = {
  __typename?: 'project_images_aggregate';
  aggregate?: Maybe<Project_Images_Aggregate_Fields>;
  nodes: Array<Project_Images>;
};

/** aggregate fields of "project_images" */
export type Project_Images_Aggregate_Fields = {
  __typename?: 'project_images_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Images_Max_Fields>;
  min?: Maybe<Project_Images_Min_Fields>;
};


/** aggregate fields of "project_images" */
export type Project_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_images" */
export type Project_Images_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Images_Max_Order_By>;
  min?: InputMaybe<Project_Images_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_images" */
export type Project_Images_Arr_Rel_Insert_Input = {
  data: Array<Project_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Images_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_images". All fields are combined with a logical 'AND'. */
export type Project_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Images_Bool_Exp>>;
  _not?: InputMaybe<Project_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_images" */
export enum Project_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectImagesPkey = 'project_images_pkey'
}

/** input type for inserting data into table "project_images" */
export type Project_Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Project_Images_Max_Fields = {
  __typename?: 'project_images_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "project_images" */
export type Project_Images_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Images_Min_Fields = {
  __typename?: 'project_images_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "project_images" */
export type Project_Images_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_images" */
export type Project_Images_Mutation_Response = {
  __typename?: 'project_images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Images>;
};

/** on_conflict condition type for table "project_images" */
export type Project_Images_On_Conflict = {
  constraint: Project_Images_Constraint;
  update_columns?: Array<Project_Images_Update_Column>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "project_images". */
export type Project_Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_images */
export type Project_Images_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_images" */
export enum Project_Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "project_images" */
export type Project_Images_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "project_images" */
export enum Project_Images_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Project_Images_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Images_Set_Input>;
  where: Project_Images_Bool_Exp;
};

/** columns and relationships of "project_members" */
export type Project_Members = {
  __typename?: 'project_members';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  project_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
  user_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "project_members" */
export type Project_Members_Aggregate = {
  __typename?: 'project_members_aggregate';
  aggregate?: Maybe<Project_Members_Aggregate_Fields>;
  nodes: Array<Project_Members>;
};

/** aggregate fields of "project_members" */
export type Project_Members_Aggregate_Fields = {
  __typename?: 'project_members_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Members_Max_Fields>;
  min?: Maybe<Project_Members_Min_Fields>;
};


/** aggregate fields of "project_members" */
export type Project_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Members_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_members" */
export type Project_Members_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Members_Max_Order_By>;
  min?: InputMaybe<Project_Members_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_members" */
export type Project_Members_Arr_Rel_Insert_Input = {
  data: Array<Project_Members_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Members_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_members". All fields are combined with a logical 'AND'. */
export type Project_Members_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Members_Bool_Exp>>;
  _not?: InputMaybe<Project_Members_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Members_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_members" */
export enum Project_Members_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectMembersPkey = 'project_members_pkey',
  /** unique or primary key constraint on columns "project_id", "user_id" */
  ProjectMembersProjectIdUserIdKey = 'project_members_project_id_user_id_key'
}

/** input type for inserting data into table "project_members" */
export type Project_Members_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Project_Members_Max_Fields = {
  __typename?: 'project_members_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "project_members" */
export type Project_Members_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Members_Min_Fields = {
  __typename?: 'project_members_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "project_members" */
export type Project_Members_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_members" */
export type Project_Members_Mutation_Response = {
  __typename?: 'project_members_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Members>;
};

/** on_conflict condition type for table "project_members" */
export type Project_Members_On_Conflict = {
  constraint: Project_Members_Constraint;
  update_columns?: Array<Project_Members_Update_Column>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};

/** Ordering options when selecting data from "project_members". */
export type Project_Members_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_members */
export type Project_Members_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_members" */
export enum Project_Members_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "project_members" */
export type Project_Members_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "project_members" */
export enum Project_Members_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Project_Members_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Members_Set_Input>;
  where: Project_Members_Bool_Exp;
};

/** columns and relationships of "project_promotions" */
export type Project_Promotions = {
  __typename?: 'project_promotions';
  created_at?: Maybe<Scalars['timestamptz']>;
  message: Scalars['String'];
  /** An object relationship */
  project: Projects;
  project_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  user_id: Scalars['uuid'];
};

/** aggregated selection of "project_promotions" */
export type Project_Promotions_Aggregate = {
  __typename?: 'project_promotions_aggregate';
  aggregate?: Maybe<Project_Promotions_Aggregate_Fields>;
  nodes: Array<Project_Promotions>;
};

/** aggregate fields of "project_promotions" */
export type Project_Promotions_Aggregate_Fields = {
  __typename?: 'project_promotions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Promotions_Max_Fields>;
  min?: Maybe<Project_Promotions_Min_Fields>;
};


/** aggregate fields of "project_promotions" */
export type Project_Promotions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_promotions" */
export type Project_Promotions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Promotions_Max_Order_By>;
  min?: InputMaybe<Project_Promotions_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_promotions" */
export type Project_Promotions_Arr_Rel_Insert_Input = {
  data: Array<Project_Promotions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Promotions_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_promotions". All fields are combined with a logical 'AND'. */
export type Project_Promotions_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Promotions_Bool_Exp>>;
  _not?: InputMaybe<Project_Promotions_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Promotions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  project?: InputMaybe<Projects_Bool_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_promotions" */
export enum Project_Promotions_Constraint {
  /** unique or primary key constraint on columns "project_id", "user_id" */
  ProjectPromotionsPkey = 'project_promotions_pkey'
}

/** input type for inserting data into table "project_promotions" */
export type Project_Promotions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<Projects_Obj_Rel_Insert_Input>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Project_Promotions_Max_Fields = {
  __typename?: 'project_promotions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "project_promotions" */
export type Project_Promotions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Promotions_Min_Fields = {
  __typename?: 'project_promotions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  message?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "project_promotions" */
export type Project_Promotions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_promotions" */
export type Project_Promotions_Mutation_Response = {
  __typename?: 'project_promotions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Promotions>;
};

/** on_conflict condition type for table "project_promotions" */
export type Project_Promotions_On_Conflict = {
  constraint: Project_Promotions_Constraint;
  update_columns?: Array<Project_Promotions_Update_Column>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};

/** Ordering options when selecting data from "project_promotions". */
export type Project_Promotions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  project?: InputMaybe<Projects_Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_promotions */
export type Project_Promotions_Pk_Columns_Input = {
  project_id: Scalars['uuid'];
  user_id: Scalars['uuid'];
};

/** select columns of table "project_promotions" */
export enum Project_Promotions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "project_promotions" */
export type Project_Promotions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  message?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "project_promotions" */
export enum Project_Promotions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Message = 'message',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Project_Promotions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Promotions_Set_Input>;
  where: Project_Promotions_Bool_Exp;
};

/** columns and relationships of "project_question_answers" */
export type Project_Question_Answers = {
  __typename?: 'project_question_answers';
  answer: Scalars['String'];
  id: Scalars['uuid'];
  project_id: Scalars['uuid'];
  question: Scalars['String'];
};

/** aggregated selection of "project_question_answers" */
export type Project_Question_Answers_Aggregate = {
  __typename?: 'project_question_answers_aggregate';
  aggregate?: Maybe<Project_Question_Answers_Aggregate_Fields>;
  nodes: Array<Project_Question_Answers>;
};

/** aggregate fields of "project_question_answers" */
export type Project_Question_Answers_Aggregate_Fields = {
  __typename?: 'project_question_answers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Question_Answers_Max_Fields>;
  min?: Maybe<Project_Question_Answers_Min_Fields>;
};


/** aggregate fields of "project_question_answers" */
export type Project_Question_Answers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_question_answers" */
export type Project_Question_Answers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Question_Answers_Max_Order_By>;
  min?: InputMaybe<Project_Question_Answers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_question_answers" */
export type Project_Question_Answers_Arr_Rel_Insert_Input = {
  data: Array<Project_Question_Answers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Question_Answers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_question_answers". All fields are combined with a logical 'AND'. */
export type Project_Question_Answers_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Question_Answers_Bool_Exp>>;
  _not?: InputMaybe<Project_Question_Answers_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Question_Answers_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_question_answers" */
export enum Project_Question_Answers_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectQuestionAnswersPkey = 'project_question_answers_pkey'
}

/** input type for inserting data into table "project_question_answers" */
export type Project_Question_Answers_Insert_Input = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Question_Answers_Max_Fields = {
  __typename?: 'project_question_answers_max_fields';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_question_answers" */
export type Project_Question_Answers_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Question_Answers_Min_Fields = {
  __typename?: 'project_question_answers_min_fields';
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_question_answers" */
export type Project_Question_Answers_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_question_answers" */
export type Project_Question_Answers_Mutation_Response = {
  __typename?: 'project_question_answers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Question_Answers>;
};

/** on_conflict condition type for table "project_question_answers" */
export type Project_Question_Answers_On_Conflict = {
  constraint: Project_Question_Answers_Constraint;
  update_columns?: Array<Project_Question_Answers_Update_Column>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};

/** Ordering options when selecting data from "project_question_answers". */
export type Project_Question_Answers_Order_By = {
  answer?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_question_answers */
export type Project_Question_Answers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_question_answers" */
export enum Project_Question_Answers_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Question = 'question'
}

/** input type for updating data in table "project_question_answers" */
export type Project_Question_Answers_Set_Input = {
  answer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_question_answers" */
export enum Project_Question_Answers_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Question = 'question'
}

export type Project_Question_Answers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Question_Answers_Set_Input>;
  where: Project_Question_Answers_Bool_Exp;
};

/** columns and relationships of "project_severities" */
export type Project_Severities = {
  __typename?: 'project_severities';
  severity: Scalars['String'];
};

/** aggregated selection of "project_severities" */
export type Project_Severities_Aggregate = {
  __typename?: 'project_severities_aggregate';
  aggregate?: Maybe<Project_Severities_Aggregate_Fields>;
  nodes: Array<Project_Severities>;
};

/** aggregate fields of "project_severities" */
export type Project_Severities_Aggregate_Fields = {
  __typename?: 'project_severities_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Severities_Max_Fields>;
  min?: Maybe<Project_Severities_Min_Fields>;
};


/** aggregate fields of "project_severities" */
export type Project_Severities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Severities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "project_severities". All fields are combined with a logical 'AND'. */
export type Project_Severities_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Severities_Bool_Exp>>;
  _not?: InputMaybe<Project_Severities_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Severities_Bool_Exp>>;
  severity?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_severities" */
export enum Project_Severities_Constraint {
  /** unique or primary key constraint on columns "severity" */
  ProjectSeveritiesPkey = 'project_severities_pkey'
}

/** input type for inserting data into table "project_severities" */
export type Project_Severities_Insert_Input = {
  severity?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Severities_Max_Fields = {
  __typename?: 'project_severities_max_fields';
  severity?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Project_Severities_Min_Fields = {
  __typename?: 'project_severities_min_fields';
  severity?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "project_severities" */
export type Project_Severities_Mutation_Response = {
  __typename?: 'project_severities_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Severities>;
};

/** on_conflict condition type for table "project_severities" */
export type Project_Severities_On_Conflict = {
  constraint: Project_Severities_Constraint;
  update_columns?: Array<Project_Severities_Update_Column>;
  where?: InputMaybe<Project_Severities_Bool_Exp>;
};

/** Ordering options when selecting data from "project_severities". */
export type Project_Severities_Order_By = {
  severity?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_severities */
export type Project_Severities_Pk_Columns_Input = {
  severity: Scalars['String'];
};

/** select columns of table "project_severities" */
export enum Project_Severities_Select_Column {
  /** column name */
  Severity = 'severity'
}

/** input type for updating data in table "project_severities" */
export type Project_Severities_Set_Input = {
  severity?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_severities" */
export enum Project_Severities_Update_Column {
  /** column name */
  Severity = 'severity'
}

export type Project_Severities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Severities_Set_Input>;
  where: Project_Severities_Bool_Exp;
};

/** columns and relationships of "project_timelines" */
export type Project_Timelines = {
  __typename?: 'project_timelines';
  date: Scalars['timestamp'];
  description: Scalars['String'];
  id: Scalars['uuid'];
  project_id?: Maybe<Scalars['uuid']>;
  title: Scalars['String'];
};

/** aggregated selection of "project_timelines" */
export type Project_Timelines_Aggregate = {
  __typename?: 'project_timelines_aggregate';
  aggregate?: Maybe<Project_Timelines_Aggregate_Fields>;
  nodes: Array<Project_Timelines>;
};

/** aggregate fields of "project_timelines" */
export type Project_Timelines_Aggregate_Fields = {
  __typename?: 'project_timelines_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Project_Timelines_Max_Fields>;
  min?: Maybe<Project_Timelines_Min_Fields>;
};


/** aggregate fields of "project_timelines" */
export type Project_Timelines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "project_timelines" */
export type Project_Timelines_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Project_Timelines_Max_Order_By>;
  min?: InputMaybe<Project_Timelines_Min_Order_By>;
};

/** input type for inserting array relation for remote table "project_timelines" */
export type Project_Timelines_Arr_Rel_Insert_Input = {
  data: Array<Project_Timelines_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Project_Timelines_On_Conflict>;
};

/** Boolean expression to filter rows from the table "project_timelines". All fields are combined with a logical 'AND'. */
export type Project_Timelines_Bool_Exp = {
  _and?: InputMaybe<Array<Project_Timelines_Bool_Exp>>;
  _not?: InputMaybe<Project_Timelines_Bool_Exp>;
  _or?: InputMaybe<Array<Project_Timelines_Bool_Exp>>;
  date?: InputMaybe<Timestamp_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "project_timelines" */
export enum Project_Timelines_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectTimelinesPkey = 'project_timelines_pkey'
}

/** input type for inserting data into table "project_timelines" */
export type Project_Timelines_Insert_Input = {
  date?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Project_Timelines_Max_Fields = {
  __typename?: 'project_timelines_max_fields';
  date?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "project_timelines" */
export type Project_Timelines_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Project_Timelines_Min_Fields = {
  __typename?: 'project_timelines_min_fields';
  date?: Maybe<Scalars['timestamp']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  project_id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "project_timelines" */
export type Project_Timelines_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "project_timelines" */
export type Project_Timelines_Mutation_Response = {
  __typename?: 'project_timelines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Project_Timelines>;
};

/** on_conflict condition type for table "project_timelines" */
export type Project_Timelines_On_Conflict = {
  constraint: Project_Timelines_Constraint;
  update_columns?: Array<Project_Timelines_Update_Column>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};

/** Ordering options when selecting data from "project_timelines". */
export type Project_Timelines_Order_By = {
  date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
};

/** primary key columns input for table: project_timelines */
export type Project_Timelines_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "project_timelines" */
export enum Project_Timelines_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Title = 'title'
}

/** input type for updating data in table "project_timelines" */
export type Project_Timelines_Set_Input = {
  date?: InputMaybe<Scalars['timestamp']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
};

/** update columns of table "project_timelines" */
export enum Project_Timelines_Update_Column {
  /** column name */
  Date = 'date',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  Title = 'title'
}

export type Project_Timelines_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Project_Timelines_Set_Input>;
  where: Project_Timelines_Bool_Exp;
};

/** columns and relationships of "projects" */
export type Projects = {
  __typename?: 'projects';
  added_by?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  agency_contact?: Maybe<Scalars['String']>;
  agency_name?: Maybe<Scalars['String']>;
  approved_value?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  benefits?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  comments_count?: Maybe<Scalars['Int']>;
  conditions?: Maybe<Scalars['String']>;
  constituency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detailed_address?: Maybe<Scalars['String']>;
  edited_columns?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  embedded_youtube_video?: Maybe<Scalars['String']>;
  end_date: Scalars['String'];
  estimated_cost?: Maybe<Scalars['String']>;
  /** An array relationship */
  expressions: Array<Expressions>;
  /** An aggregate relationship */
  expressions_aggregate: Expressions_Aggregate;
  financial_description?: Maybe<Scalars['String']>;
  govt_authority_name?: Maybe<Scalars['String']>;
  /** A computed field, executes function "project_liked_by_user" */
  has_liked?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  /** An array relationship */
  images: Array<Project_Images>;
  /** An aggregate relationship */
  images_aggregate: Project_Images_Aggregate;
  impact_of_project?: Maybe<Scalars['String']>;
  investment_amount?: Maybe<Scalars['numeric']>;
  /** An array relationship */
  invites: Array<Invite_Links>;
  /** An aggregate relationship */
  invites_aggregate: Invite_Links_Aggregate;
  is_active?: Maybe<Scalars['Boolean']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_mahaprastham?: Maybe<Scalars['Boolean']>;
  is_published?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  likes: Array<Likes>;
  /** An aggregate relationship */
  likes_aggregate: Likes_Aggregate;
  likes_count: Scalars['Int'];
  location_coordinates?: Maybe<Scalars['geography']>;
  location_title?: Maybe<Scalars['String']>;
  merge_approval_status?: Maybe<Scalars['String']>;
  merge_into?: Maybe<Scalars['uuid']>;
  objective?: Maybe<Scalars['String']>;
  /** An array relationship */
  owner: Array<Users>;
  /** An aggregate relationship */
  owner_aggregate: Users_Aggregate;
  participant_type?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  problem?: Maybe<Scalars['String']>;
  /** An array relationship */
  project_assets: Array<Project_Assets>;
  /** An aggregate relationship */
  project_assets_aggregate: Project_Assets_Aggregate;
  /** An array relationship */
  project_escalations: Array<Project_Escalations>;
  /** An aggregate relationship */
  project_escalations_aggregate: Project_Escalations_Aggregate;
  /** An array relationship */
  project_members: Array<Project_Members>;
  /** An aggregate relationship */
  project_members_aggregate: Project_Members_Aggregate;
  project_profile_picture?: Maybe<Scalars['String']>;
  project_status?: Maybe<Scalars['String']>;
  /** An array relationship */
  question_answers: Array<Project_Question_Answers>;
  /** An aggregate relationship */
  question_answers_aggregate: Project_Question_Answers_Aggregate;
  requirements?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  secondary_category?: Maybe<Scalars['String']>;
  start_date: Scalars['String'];
  status?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
  /** An array relationship */
  timelines: Array<Project_Timelines>;
  /** An aggregate relationship */
  timelines_aggregate: Project_Timelines_Aggregate;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "projects" */
export type ProjectsCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsExpressionsArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsExpressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsImagesArgs = {
  distinct_on?: InputMaybe<Array<Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Images_Order_By>>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Images_Order_By>>;
  where?: InputMaybe<Project_Images_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsInvitesArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsInvites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsLikesArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsOwnerArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsOwner_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_AssetsArgs = {
  distinct_on?: InputMaybe<Array<Project_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Assets_Order_By>>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Assets_Order_By>>;
  where?: InputMaybe<Project_Assets_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_EscalationsArgs = {
  distinct_on?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Escalations_Order_By>>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_Escalations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Escalations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Escalations_Order_By>>;
  where?: InputMaybe<Project_Escalations_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_MembersArgs = {
  distinct_on?: InputMaybe<Array<Project_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Members_Order_By>>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsProject_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Members_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Members_Order_By>>;
  where?: InputMaybe<Project_Members_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsQuestion_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Question_Answers_Order_By>>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsQuestion_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Question_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Question_Answers_Order_By>>;
  where?: InputMaybe<Project_Question_Answers_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTimelinesArgs = {
  distinct_on?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Timelines_Order_By>>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};


/** columns and relationships of "projects" */
export type ProjectsTimelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Timelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Timelines_Order_By>>;
  where?: InputMaybe<Project_Timelines_Bool_Exp>;
};

/** aggregated selection of "projects" */
export type Projects_Aggregate = {
  __typename?: 'projects_aggregate';
  aggregate?: Maybe<Projects_Aggregate_Fields>;
  nodes: Array<Projects>;
};

/** aggregate fields of "projects" */
export type Projects_Aggregate_Fields = {
  __typename?: 'projects_aggregate_fields';
  avg?: Maybe<Projects_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Projects_Max_Fields>;
  min?: Maybe<Projects_Min_Fields>;
  stddev?: Maybe<Projects_Stddev_Fields>;
  stddev_pop?: Maybe<Projects_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Projects_Stddev_Samp_Fields>;
  sum?: Maybe<Projects_Sum_Fields>;
  var_pop?: Maybe<Projects_Var_Pop_Fields>;
  var_samp?: Maybe<Projects_Var_Samp_Fields>;
  variance?: Maybe<Projects_Variance_Fields>;
};


/** aggregate fields of "projects" */
export type Projects_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Projects_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "projects" */
export type Projects_Aggregate_Order_By = {
  avg?: InputMaybe<Projects_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Projects_Max_Order_By>;
  min?: InputMaybe<Projects_Min_Order_By>;
  stddev?: InputMaybe<Projects_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Projects_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Projects_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Projects_Sum_Order_By>;
  var_pop?: InputMaybe<Projects_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Projects_Var_Samp_Order_By>;
  variance?: InputMaybe<Projects_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "projects" */
export type Projects_Arr_Rel_Insert_Input = {
  data: Array<Projects_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** aggregate avg on columns */
export type Projects_Avg_Fields = {
  __typename?: 'projects_avg_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "projects" */
export type Projects_Avg_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "projects". All fields are combined with a logical 'AND'. */
export type Projects_Bool_Exp = {
  _and?: InputMaybe<Array<Projects_Bool_Exp>>;
  _not?: InputMaybe<Projects_Bool_Exp>;
  _or?: InputMaybe<Array<Projects_Bool_Exp>>;
  added_by?: InputMaybe<Uuid_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  approved_value?: InputMaybe<String_Comparison_Exp>;
  background?: InputMaybe<String_Comparison_Exp>;
  benefits?: InputMaybe<String_Comparison_Exp>;
  category?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  comments_count?: InputMaybe<Int_Comparison_Exp>;
  conditions?: InputMaybe<String_Comparison_Exp>;
  constituency?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  detailed_address?: InputMaybe<String_Comparison_Exp>;
  edited_columns?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  embedded_youtube_video?: InputMaybe<String_Comparison_Exp>;
  end_date?: InputMaybe<String_Comparison_Exp>;
  estimated_cost?: InputMaybe<String_Comparison_Exp>;
  expressions?: InputMaybe<Expressions_Bool_Exp>;
  financial_description?: InputMaybe<String_Comparison_Exp>;
  govt_authority_name?: InputMaybe<String_Comparison_Exp>;
  has_liked?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  images?: InputMaybe<Project_Images_Bool_Exp>;
  impact_of_project?: InputMaybe<String_Comparison_Exp>;
  investment_amount?: InputMaybe<Numeric_Comparison_Exp>;
  invites?: InputMaybe<Invite_Links_Bool_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_mahaprastham?: InputMaybe<Boolean_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  likes?: InputMaybe<Likes_Bool_Exp>;
  likes_count?: InputMaybe<Int_Comparison_Exp>;
  location_coordinates?: InputMaybe<Geography_Comparison_Exp>;
  location_title?: InputMaybe<String_Comparison_Exp>;
  merge_approval_status?: InputMaybe<String_Comparison_Exp>;
  merge_into?: InputMaybe<Uuid_Comparison_Exp>;
  objective?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  participant_type?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  problem?: InputMaybe<String_Comparison_Exp>;
  project_assets?: InputMaybe<Project_Assets_Bool_Exp>;
  project_escalations?: InputMaybe<Project_Escalations_Bool_Exp>;
  project_members?: InputMaybe<Project_Members_Bool_Exp>;
  project_profile_picture?: InputMaybe<String_Comparison_Exp>;
  project_status?: InputMaybe<String_Comparison_Exp>;
  question_answers?: InputMaybe<Project_Question_Answers_Bool_Exp>;
  requirements?: InputMaybe<String_Comparison_Exp>;
  scope?: InputMaybe<String_Comparison_Exp>;
  secondary_category?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Boolean_Comparison_Exp>;
  tag?: InputMaybe<String_Comparison_Exp>;
  timelines?: InputMaybe<Project_Timelines_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "projects" */
export enum Projects_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProjectsPkey = 'projects_pkey'
}

/** input type for incrementing numeric columns in table "projects" */
export type Projects_Inc_Input = {
  comments_count?: InputMaybe<Scalars['Int']>;
  investment_amount?: InputMaybe<Scalars['numeric']>;
  likes_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "projects" */
export type Projects_Insert_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  address?: InputMaybe<Scalars['String']>;
  agency_contact?: InputMaybe<Scalars['String']>;
  agency_name?: InputMaybe<Scalars['String']>;
  approved_value?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<Scalars['String']>;
  benefits?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  comments_count?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Scalars['String']>;
  constituency?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detailed_address?: InputMaybe<Scalars['String']>;
  edited_columns?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  embedded_youtube_video?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  estimated_cost?: InputMaybe<Scalars['String']>;
  expressions?: InputMaybe<Expressions_Arr_Rel_Insert_Input>;
  financial_description?: InputMaybe<Scalars['String']>;
  govt_authority_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  images?: InputMaybe<Project_Images_Arr_Rel_Insert_Input>;
  impact_of_project?: InputMaybe<Scalars['String']>;
  investment_amount?: InputMaybe<Scalars['numeric']>;
  invites?: InputMaybe<Invite_Links_Arr_Rel_Insert_Input>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_mahaprastham?: InputMaybe<Scalars['Boolean']>;
  is_published?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  likes?: InputMaybe<Likes_Arr_Rel_Insert_Input>;
  likes_count?: InputMaybe<Scalars['Int']>;
  location_coordinates?: InputMaybe<Scalars['geography']>;
  location_title?: InputMaybe<Scalars['String']>;
  merge_approval_status?: InputMaybe<Scalars['String']>;
  merge_into?: InputMaybe<Scalars['uuid']>;
  objective?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  participant_type?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  problem?: InputMaybe<Scalars['String']>;
  project_assets?: InputMaybe<Project_Assets_Arr_Rel_Insert_Input>;
  project_escalations?: InputMaybe<Project_Escalations_Arr_Rel_Insert_Input>;
  project_members?: InputMaybe<Project_Members_Arr_Rel_Insert_Input>;
  project_profile_picture?: InputMaybe<Scalars['String']>;
  project_status?: InputMaybe<Scalars['String']>;
  question_answers?: InputMaybe<Project_Question_Answers_Arr_Rel_Insert_Input>;
  requirements?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  secondary_category?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  timelines?: InputMaybe<Project_Timelines_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Projects_Max_Fields = {
  __typename?: 'projects_max_fields';
  added_by?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  agency_contact?: Maybe<Scalars['String']>;
  agency_name?: Maybe<Scalars['String']>;
  approved_value?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  benefits?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  comments_count?: Maybe<Scalars['Int']>;
  conditions?: Maybe<Scalars['String']>;
  constituency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detailed_address?: Maybe<Scalars['String']>;
  edited_columns?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  embedded_youtube_video?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  estimated_cost?: Maybe<Scalars['String']>;
  financial_description?: Maybe<Scalars['String']>;
  govt_authority_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  impact_of_project?: Maybe<Scalars['String']>;
  investment_amount?: Maybe<Scalars['numeric']>;
  likes_count?: Maybe<Scalars['Int']>;
  location_title?: Maybe<Scalars['String']>;
  merge_approval_status?: Maybe<Scalars['String']>;
  merge_into?: Maybe<Scalars['uuid']>;
  objective?: Maybe<Scalars['String']>;
  participant_type?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  problem?: Maybe<Scalars['String']>;
  project_profile_picture?: Maybe<Scalars['String']>;
  project_status?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  secondary_category?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "projects" */
export type Projects_Max_Order_By = {
  added_by?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  agency_contact?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  approved_value?: InputMaybe<Order_By>;
  background?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  comments_count?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  constituency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detailed_address?: InputMaybe<Order_By>;
  edited_columns?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  embedded_youtube_video?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  financial_description?: InputMaybe<Order_By>;
  govt_authority_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impact_of_project?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  location_title?: InputMaybe<Order_By>;
  merge_approval_status?: InputMaybe<Order_By>;
  merge_into?: InputMaybe<Order_By>;
  objective?: InputMaybe<Order_By>;
  participant_type?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  problem?: InputMaybe<Order_By>;
  project_profile_picture?: InputMaybe<Order_By>;
  project_status?: InputMaybe<Order_By>;
  requirements?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  secondary_category?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Projects_Min_Fields = {
  __typename?: 'projects_min_fields';
  added_by?: Maybe<Scalars['uuid']>;
  address?: Maybe<Scalars['String']>;
  agency_contact?: Maybe<Scalars['String']>;
  agency_name?: Maybe<Scalars['String']>;
  approved_value?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  benefits?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  comments_count?: Maybe<Scalars['Int']>;
  conditions?: Maybe<Scalars['String']>;
  constituency?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  detailed_address?: Maybe<Scalars['String']>;
  edited_columns?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  embedded_youtube_video?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  estimated_cost?: Maybe<Scalars['String']>;
  financial_description?: Maybe<Scalars['String']>;
  govt_authority_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  impact_of_project?: Maybe<Scalars['String']>;
  investment_amount?: Maybe<Scalars['numeric']>;
  likes_count?: Maybe<Scalars['Int']>;
  location_title?: Maybe<Scalars['String']>;
  merge_approval_status?: Maybe<Scalars['String']>;
  merge_into?: Maybe<Scalars['uuid']>;
  objective?: Maybe<Scalars['String']>;
  participant_type?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  problem?: Maybe<Scalars['String']>;
  project_profile_picture?: Maybe<Scalars['String']>;
  project_status?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  secondary_category?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "projects" */
export type Projects_Min_Order_By = {
  added_by?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  agency_contact?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  approved_value?: InputMaybe<Order_By>;
  background?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  comments_count?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  constituency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detailed_address?: InputMaybe<Order_By>;
  edited_columns?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  embedded_youtube_video?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  financial_description?: InputMaybe<Order_By>;
  govt_authority_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  impact_of_project?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
  location_title?: InputMaybe<Order_By>;
  merge_approval_status?: InputMaybe<Order_By>;
  merge_into?: InputMaybe<Order_By>;
  objective?: InputMaybe<Order_By>;
  participant_type?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  problem?: InputMaybe<Order_By>;
  project_profile_picture?: InputMaybe<Order_By>;
  project_status?: InputMaybe<Order_By>;
  requirements?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  secondary_category?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "projects" */
export type Projects_Mutation_Response = {
  __typename?: 'projects_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Projects>;
};

/** input type for inserting object relation for remote table "projects" */
export type Projects_Obj_Rel_Insert_Input = {
  data: Projects_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Projects_On_Conflict>;
};

/** on_conflict condition type for table "projects" */
export type Projects_On_Conflict = {
  constraint: Projects_Constraint;
  update_columns?: Array<Projects_Update_Column>;
  where?: InputMaybe<Projects_Bool_Exp>;
};

/** Ordering options when selecting data from "projects". */
export type Projects_Order_By = {
  added_by?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  agency_contact?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  approved_value?: InputMaybe<Order_By>;
  background?: InputMaybe<Order_By>;
  benefits?: InputMaybe<Order_By>;
  category?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  comments_count?: InputMaybe<Order_By>;
  conditions?: InputMaybe<Order_By>;
  constituency?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  detailed_address?: InputMaybe<Order_By>;
  edited_columns?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  embedded_youtube_video?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  estimated_cost?: InputMaybe<Order_By>;
  expressions_aggregate?: InputMaybe<Expressions_Aggregate_Order_By>;
  financial_description?: InputMaybe<Order_By>;
  govt_authority_name?: InputMaybe<Order_By>;
  has_liked?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Project_Images_Aggregate_Order_By>;
  impact_of_project?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  invites_aggregate?: InputMaybe<Invite_Links_Aggregate_Order_By>;
  is_active?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_mahaprastham?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  is_verified?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Likes_Aggregate_Order_By>;
  likes_count?: InputMaybe<Order_By>;
  location_coordinates?: InputMaybe<Order_By>;
  location_title?: InputMaybe<Order_By>;
  merge_approval_status?: InputMaybe<Order_By>;
  merge_into?: InputMaybe<Order_By>;
  objective?: InputMaybe<Order_By>;
  owner_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  participant_type?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  problem?: InputMaybe<Order_By>;
  project_assets_aggregate?: InputMaybe<Project_Assets_Aggregate_Order_By>;
  project_escalations_aggregate?: InputMaybe<Project_Escalations_Aggregate_Order_By>;
  project_members_aggregate?: InputMaybe<Project_Members_Aggregate_Order_By>;
  project_profile_picture?: InputMaybe<Order_By>;
  project_status?: InputMaybe<Order_By>;
  question_answers_aggregate?: InputMaybe<Project_Question_Answers_Aggregate_Order_By>;
  requirements?: InputMaybe<Order_By>;
  scope?: InputMaybe<Order_By>;
  secondary_category?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tag?: InputMaybe<Order_By>;
  timelines_aggregate?: InputMaybe<Project_Timelines_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: projects */
export type Projects_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "projects" */
export enum Projects_Select_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContact = 'agency_contact',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  ApprovedValue = 'approved_value',
  /** column name */
  Background = 'background',
  /** column name */
  Benefits = 'benefits',
  /** column name */
  Category = 'category',
  /** column name */
  CommentsCount = 'comments_count',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  Constituency = 'constituency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetailedAddress = 'detailed_address',
  /** column name */
  EditedColumns = 'edited_columns',
  /** column name */
  Email = 'email',
  /** column name */
  EmbeddedYoutubeVideo = 'embedded_youtube_video',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  FinancialDescription = 'financial_description',
  /** column name */
  GovtAuthorityName = 'govt_authority_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImpactOfProject = 'impact_of_project',
  /** column name */
  InvestmentAmount = 'investment_amount',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMahaprastham = 'is_mahaprastham',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LikesCount = 'likes_count',
  /** column name */
  LocationCoordinates = 'location_coordinates',
  /** column name */
  LocationTitle = 'location_title',
  /** column name */
  MergeApprovalStatus = 'merge_approval_status',
  /** column name */
  MergeInto = 'merge_into',
  /** column name */
  Objective = 'objective',
  /** column name */
  ParticipantType = 'participant_type',
  /** column name */
  Phone = 'phone',
  /** column name */
  Problem = 'problem',
  /** column name */
  ProjectProfilePicture = 'project_profile_picture',
  /** column name */
  ProjectStatus = 'project_status',
  /** column name */
  Requirements = 'requirements',
  /** column name */
  Scope = 'scope',
  /** column name */
  SecondaryCategory = 'secondary_category',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Tag = 'tag',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "projects" */
export type Projects_Set_Input = {
  added_by?: InputMaybe<Scalars['uuid']>;
  address?: InputMaybe<Scalars['String']>;
  agency_contact?: InputMaybe<Scalars['String']>;
  agency_name?: InputMaybe<Scalars['String']>;
  approved_value?: InputMaybe<Scalars['String']>;
  background?: InputMaybe<Scalars['String']>;
  benefits?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments_count?: InputMaybe<Scalars['Int']>;
  conditions?: InputMaybe<Scalars['String']>;
  constituency?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  detailed_address?: InputMaybe<Scalars['String']>;
  edited_columns?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  embedded_youtube_video?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['String']>;
  estimated_cost?: InputMaybe<Scalars['String']>;
  financial_description?: InputMaybe<Scalars['String']>;
  govt_authority_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  impact_of_project?: InputMaybe<Scalars['String']>;
  investment_amount?: InputMaybe<Scalars['numeric']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_mahaprastham?: InputMaybe<Scalars['Boolean']>;
  is_published?: InputMaybe<Scalars['Boolean']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  likes_count?: InputMaybe<Scalars['Int']>;
  location_coordinates?: InputMaybe<Scalars['geography']>;
  location_title?: InputMaybe<Scalars['String']>;
  merge_approval_status?: InputMaybe<Scalars['String']>;
  merge_into?: InputMaybe<Scalars['uuid']>;
  objective?: InputMaybe<Scalars['String']>;
  participant_type?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  problem?: InputMaybe<Scalars['String']>;
  project_profile_picture?: InputMaybe<Scalars['String']>;
  project_status?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  secondary_category?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Projects_Stddev_Fields = {
  __typename?: 'projects_stddev_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "projects" */
export type Projects_Stddev_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Projects_Stddev_Pop_Fields = {
  __typename?: 'projects_stddev_pop_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "projects" */
export type Projects_Stddev_Pop_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Projects_Stddev_Samp_Fields = {
  __typename?: 'projects_stddev_samp_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "projects" */
export type Projects_Stddev_Samp_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Projects_Sum_Fields = {
  __typename?: 'projects_sum_fields';
  comments_count?: Maybe<Scalars['Int']>;
  investment_amount?: Maybe<Scalars['numeric']>;
  likes_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "projects" */
export type Projects_Sum_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** update columns of table "projects" */
export enum Projects_Update_Column {
  /** column name */
  AddedBy = 'added_by',
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContact = 'agency_contact',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  ApprovedValue = 'approved_value',
  /** column name */
  Background = 'background',
  /** column name */
  Benefits = 'benefits',
  /** column name */
  Category = 'category',
  /** column name */
  CommentsCount = 'comments_count',
  /** column name */
  Conditions = 'conditions',
  /** column name */
  Constituency = 'constituency',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DetailedAddress = 'detailed_address',
  /** column name */
  EditedColumns = 'edited_columns',
  /** column name */
  Email = 'email',
  /** column name */
  EmbeddedYoutubeVideo = 'embedded_youtube_video',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EstimatedCost = 'estimated_cost',
  /** column name */
  FinancialDescription = 'financial_description',
  /** column name */
  GovtAuthorityName = 'govt_authority_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImpactOfProject = 'impact_of_project',
  /** column name */
  InvestmentAmount = 'investment_amount',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMahaprastham = 'is_mahaprastham',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  LikesCount = 'likes_count',
  /** column name */
  LocationCoordinates = 'location_coordinates',
  /** column name */
  LocationTitle = 'location_title',
  /** column name */
  MergeApprovalStatus = 'merge_approval_status',
  /** column name */
  MergeInto = 'merge_into',
  /** column name */
  Objective = 'objective',
  /** column name */
  ParticipantType = 'participant_type',
  /** column name */
  Phone = 'phone',
  /** column name */
  Problem = 'problem',
  /** column name */
  ProjectProfilePicture = 'project_profile_picture',
  /** column name */
  ProjectStatus = 'project_status',
  /** column name */
  Requirements = 'requirements',
  /** column name */
  Scope = 'scope',
  /** column name */
  SecondaryCategory = 'secondary_category',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Tag = 'tag',
  /** column name */
  Title = 'title',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Projects_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Projects_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Projects_Set_Input>;
  where: Projects_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Projects_Var_Pop_Fields = {
  __typename?: 'projects_var_pop_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "projects" */
export type Projects_Var_Pop_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Projects_Var_Samp_Fields = {
  __typename?: 'projects_var_samp_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "projects" */
export type Projects_Var_Samp_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Projects_Variance_Fields = {
  __typename?: 'projects_variance_fields';
  comments_count?: Maybe<Scalars['Float']>;
  investment_amount?: Maybe<Scalars['Float']>;
  likes_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "projects" */
export type Projects_Variance_Order_By = {
  comments_count?: InputMaybe<Order_By>;
  investment_amount?: InputMaybe<Order_By>;
  likes_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "regions" */
export type Regions = {
  __typename?: 'regions';
  created_at: Scalars['timestamptz'];
  host_name: Scalars['String'];
  id: Scalars['uuid'];
  title?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "regions" */
export type RegionsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "regions" */
export type RegionsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "regions" */
export type Regions_Aggregate = {
  __typename?: 'regions_aggregate';
  aggregate?: Maybe<Regions_Aggregate_Fields>;
  nodes: Array<Regions>;
};

/** aggregate fields of "regions" */
export type Regions_Aggregate_Fields = {
  __typename?: 'regions_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Regions_Max_Fields>;
  min?: Maybe<Regions_Min_Fields>;
};


/** aggregate fields of "regions" */
export type Regions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Regions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "regions". All fields are combined with a logical 'AND'. */
export type Regions_Bool_Exp = {
  _and?: InputMaybe<Array<Regions_Bool_Exp>>;
  _not?: InputMaybe<Regions_Bool_Exp>;
  _or?: InputMaybe<Array<Regions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  host_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "regions" */
export enum Regions_Constraint {
  /** unique or primary key constraint on columns "id" */
  RegionsPkey = 'regions_pkey'
}

/** input type for inserting data into table "regions" */
export type Regions_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  host_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Regions_Max_Fields = {
  __typename?: 'regions_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  host_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Regions_Min_Fields = {
  __typename?: 'regions_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  host_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "regions" */
export type Regions_Mutation_Response = {
  __typename?: 'regions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Regions>;
};

/** on_conflict condition type for table "regions" */
export type Regions_On_Conflict = {
  constraint: Regions_Constraint;
  update_columns?: Array<Regions_Update_Column>;
  where?: InputMaybe<Regions_Bool_Exp>;
};

/** Ordering options when selecting data from "regions". */
export type Regions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  host_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: regions */
export type Regions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "regions" */
export enum Regions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HostName = 'host_name',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "regions" */
export type Regions_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  host_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "regions" */
export enum Regions_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HostName = 'host_name',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Regions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Regions_Set_Input>;
  where: Regions_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float'];
  from: Scalars['geography'];
  use_spheroid?: InputMaybe<Scalars['Boolean']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float'];
  from: Scalars['geometry'];
};

/** columns and relationships of "suggest_project" */
export type Suggest_Project = {
  __typename?: 'suggest_project';
  address: Scalars['String'];
  constituency?: Maybe<Scalars['String']>;
  contact_number: Scalars['String'];
  created_at: Scalars['timestamptz'];
  email_id: Scalars['String'];
  id: Scalars['uuid'];
  /** An array relationship */
  images: Array<Suggest_Project_Images>;
  /** An aggregate relationship */
  images_aggregate: Suggest_Project_Images_Aggregate;
  is_verified?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  project_address?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Scalars['String']>;
  project_category?: Maybe<Scalars['String']>;
  project_description?: Maybe<Scalars['String']>;
  project_location?: Maybe<Scalars['String']>;
  project_photos?: Maybe<Scalars['String']>;
  project_requirements?: Maybe<Scalars['String']>;
  project_title?: Maybe<Scalars['String']>;
  project_type?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** columns and relationships of "suggest_project" */
export type Suggest_ProjectImagesArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Images_Order_By>>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};


/** columns and relationships of "suggest_project" */
export type Suggest_ProjectImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Suggest_Project_Images_Order_By>>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};

/** aggregated selection of "suggest_project" */
export type Suggest_Project_Aggregate = {
  __typename?: 'suggest_project_aggregate';
  aggregate?: Maybe<Suggest_Project_Aggregate_Fields>;
  nodes: Array<Suggest_Project>;
};

/** aggregate fields of "suggest_project" */
export type Suggest_Project_Aggregate_Fields = {
  __typename?: 'suggest_project_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Suggest_Project_Max_Fields>;
  min?: Maybe<Suggest_Project_Min_Fields>;
};


/** aggregate fields of "suggest_project" */
export type Suggest_Project_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Suggest_Project_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "suggest_project". All fields are combined with a logical 'AND'. */
export type Suggest_Project_Bool_Exp = {
  _and?: InputMaybe<Array<Suggest_Project_Bool_Exp>>;
  _not?: InputMaybe<Suggest_Project_Bool_Exp>;
  _or?: InputMaybe<Array<Suggest_Project_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  constituency?: InputMaybe<String_Comparison_Exp>;
  contact_number?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  images?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
  is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  project_address?: InputMaybe<String_Comparison_Exp>;
  project_budget?: InputMaybe<String_Comparison_Exp>;
  project_category?: InputMaybe<String_Comparison_Exp>;
  project_description?: InputMaybe<String_Comparison_Exp>;
  project_location?: InputMaybe<String_Comparison_Exp>;
  project_photos?: InputMaybe<String_Comparison_Exp>;
  project_requirements?: InputMaybe<String_Comparison_Exp>;
  project_title?: InputMaybe<String_Comparison_Exp>;
  project_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "suggest_project" */
export enum Suggest_Project_Constraint {
  /** unique or primary key constraint on columns "id" */
  SuggestProjectPkey = 'suggest_project_pkey'
}

/** columns and relationships of "suggest_project_images" */
export type Suggest_Project_Images = {
  __typename?: 'suggest_project_images';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  image_url?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "suggest_project_images" */
export type Suggest_Project_Images_Aggregate = {
  __typename?: 'suggest_project_images_aggregate';
  aggregate?: Maybe<Suggest_Project_Images_Aggregate_Fields>;
  nodes: Array<Suggest_Project_Images>;
};

/** aggregate fields of "suggest_project_images" */
export type Suggest_Project_Images_Aggregate_Fields = {
  __typename?: 'suggest_project_images_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Suggest_Project_Images_Max_Fields>;
  min?: Maybe<Suggest_Project_Images_Min_Fields>;
};


/** aggregate fields of "suggest_project_images" */
export type Suggest_Project_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Suggest_Project_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "suggest_project_images" */
export type Suggest_Project_Images_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Suggest_Project_Images_Max_Order_By>;
  min?: InputMaybe<Suggest_Project_Images_Min_Order_By>;
};

/** input type for inserting array relation for remote table "suggest_project_images" */
export type Suggest_Project_Images_Arr_Rel_Insert_Input = {
  data: Array<Suggest_Project_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Suggest_Project_Images_On_Conflict>;
};

/** Boolean expression to filter rows from the table "suggest_project_images". All fields are combined with a logical 'AND'. */
export type Suggest_Project_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Suggest_Project_Images_Bool_Exp>>;
  _not?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Suggest_Project_Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_url?: InputMaybe<String_Comparison_Exp>;
  project_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "suggest_project_images" */
export enum Suggest_Project_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  SuggestProjectImagesPkey = 'suggest_project_images_pkey'
}

/** input type for inserting data into table "suggest_project_images" */
export type Suggest_Project_Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Suggest_Project_Images_Max_Fields = {
  __typename?: 'suggest_project_images_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "suggest_project_images" */
export type Suggest_Project_Images_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Suggest_Project_Images_Min_Fields = {
  __typename?: 'suggest_project_images_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  image_url?: Maybe<Scalars['String']>;
  project_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "suggest_project_images" */
export type Suggest_Project_Images_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "suggest_project_images" */
export type Suggest_Project_Images_Mutation_Response = {
  __typename?: 'suggest_project_images_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Suggest_Project_Images>;
};

/** on_conflict condition type for table "suggest_project_images" */
export type Suggest_Project_Images_On_Conflict = {
  constraint: Suggest_Project_Images_Constraint;
  update_columns?: Array<Suggest_Project_Images_Update_Column>;
  where?: InputMaybe<Suggest_Project_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "suggest_project_images". */
export type Suggest_Project_Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_url?: InputMaybe<Order_By>;
  project_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: suggest_project_images */
export type Suggest_Project_Images_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "suggest_project_images" */
export enum Suggest_Project_Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "suggest_project_images" */
export type Suggest_Project_Images_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  image_url?: InputMaybe<Scalars['String']>;
  project_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "suggest_project_images" */
export enum Suggest_Project_Images_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'image_url',
  /** column name */
  ProjectId = 'project_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Suggest_Project_Images_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Suggest_Project_Images_Set_Input>;
  where: Suggest_Project_Images_Bool_Exp;
};

/** input type for inserting data into table "suggest_project" */
export type Suggest_Project_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  constituency?: InputMaybe<Scalars['String']>;
  contact_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  images?: InputMaybe<Suggest_Project_Images_Arr_Rel_Insert_Input>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  project_address?: InputMaybe<Scalars['String']>;
  project_budget?: InputMaybe<Scalars['String']>;
  project_category?: InputMaybe<Scalars['String']>;
  project_description?: InputMaybe<Scalars['String']>;
  project_location?: InputMaybe<Scalars['String']>;
  project_photos?: InputMaybe<Scalars['String']>;
  project_requirements?: InputMaybe<Scalars['String']>;
  project_title?: InputMaybe<Scalars['String']>;
  project_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Suggest_Project_Max_Fields = {
  __typename?: 'suggest_project_max_fields';
  address?: Maybe<Scalars['String']>;
  constituency?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  project_address?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Scalars['String']>;
  project_category?: Maybe<Scalars['String']>;
  project_description?: Maybe<Scalars['String']>;
  project_location?: Maybe<Scalars['String']>;
  project_photos?: Maybe<Scalars['String']>;
  project_requirements?: Maybe<Scalars['String']>;
  project_title?: Maybe<Scalars['String']>;
  project_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Suggest_Project_Min_Fields = {
  __typename?: 'suggest_project_min_fields';
  address?: Maybe<Scalars['String']>;
  constituency?: Maybe<Scalars['String']>;
  contact_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  project_address?: Maybe<Scalars['String']>;
  project_budget?: Maybe<Scalars['String']>;
  project_category?: Maybe<Scalars['String']>;
  project_description?: Maybe<Scalars['String']>;
  project_location?: Maybe<Scalars['String']>;
  project_photos?: Maybe<Scalars['String']>;
  project_requirements?: Maybe<Scalars['String']>;
  project_title?: Maybe<Scalars['String']>;
  project_type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "suggest_project" */
export type Suggest_Project_Mutation_Response = {
  __typename?: 'suggest_project_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Suggest_Project>;
};

/** on_conflict condition type for table "suggest_project" */
export type Suggest_Project_On_Conflict = {
  constraint: Suggest_Project_Constraint;
  update_columns?: Array<Suggest_Project_Update_Column>;
  where?: InputMaybe<Suggest_Project_Bool_Exp>;
};

/** Ordering options when selecting data from "suggest_project". */
export type Suggest_Project_Order_By = {
  address?: InputMaybe<Order_By>;
  constituency?: InputMaybe<Order_By>;
  contact_number?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Suggest_Project_Images_Aggregate_Order_By>;
  is_verified?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  project_address?: InputMaybe<Order_By>;
  project_budget?: InputMaybe<Order_By>;
  project_category?: InputMaybe<Order_By>;
  project_description?: InputMaybe<Order_By>;
  project_location?: InputMaybe<Order_By>;
  project_photos?: InputMaybe<Order_By>;
  project_requirements?: InputMaybe<Order_By>;
  project_title?: InputMaybe<Order_By>;
  project_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: suggest_project */
export type Suggest_Project_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "suggest_project" */
export enum Suggest_Project_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Constituency = 'constituency',
  /** column name */
  ContactNumber = 'contact_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectAddress = 'project_address',
  /** column name */
  ProjectBudget = 'project_budget',
  /** column name */
  ProjectCategory = 'project_category',
  /** column name */
  ProjectDescription = 'project_description',
  /** column name */
  ProjectLocation = 'project_location',
  /** column name */
  ProjectPhotos = 'project_photos',
  /** column name */
  ProjectRequirements = 'project_requirements',
  /** column name */
  ProjectTitle = 'project_title',
  /** column name */
  ProjectType = 'project_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "suggest_project" */
export type Suggest_Project_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  constituency?: InputMaybe<Scalars['String']>;
  contact_number?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  project_address?: InputMaybe<Scalars['String']>;
  project_budget?: InputMaybe<Scalars['String']>;
  project_category?: InputMaybe<Scalars['String']>;
  project_description?: InputMaybe<Scalars['String']>;
  project_location?: InputMaybe<Scalars['String']>;
  project_photos?: InputMaybe<Scalars['String']>;
  project_requirements?: InputMaybe<Scalars['String']>;
  project_title?: InputMaybe<Scalars['String']>;
  project_type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "suggest_project" */
export enum Suggest_Project_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Constituency = 'constituency',
  /** column name */
  ContactNumber = 'contact_number',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsVerified = 'is_verified',
  /** column name */
  Name = 'name',
  /** column name */
  ProjectAddress = 'project_address',
  /** column name */
  ProjectBudget = 'project_budget',
  /** column name */
  ProjectCategory = 'project_category',
  /** column name */
  ProjectDescription = 'project_description',
  /** column name */
  ProjectLocation = 'project_location',
  /** column name */
  ProjectPhotos = 'project_photos',
  /** column name */
  ProjectRequirements = 'project_requirements',
  /** column name */
  ProjectTitle = 'project_title',
  /** column name */
  ProjectType = 'project_type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Suggest_Project_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Suggest_Project_Set_Input>;
  where: Suggest_Project_Bool_Exp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_assets" */
export type User_Assets = {
  __typename?: 'user_assets';
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  url?: Maybe<Scalars['String']>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_assets" */
export type User_Assets_Aggregate = {
  __typename?: 'user_assets_aggregate';
  aggregate?: Maybe<User_Assets_Aggregate_Fields>;
  nodes: Array<User_Assets>;
};

/** aggregate fields of "user_assets" */
export type User_Assets_Aggregate_Fields = {
  __typename?: 'user_assets_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Assets_Max_Fields>;
  min?: Maybe<User_Assets_Min_Fields>;
};


/** aggregate fields of "user_assets" */
export type User_Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_assets" */
export type User_Assets_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Assets_Max_Order_By>;
  min?: InputMaybe<User_Assets_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_assets" */
export type User_Assets_Arr_Rel_Insert_Input = {
  data: Array<User_Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Assets_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_assets". All fields are combined with a logical 'AND'. */
export type User_Assets_Bool_Exp = {
  _and?: InputMaybe<Array<User_Assets_Bool_Exp>>;
  _not?: InputMaybe<User_Assets_Bool_Exp>;
  _or?: InputMaybe<Array<User_Assets_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_assets" */
export enum User_Assets_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAssetsPkey = 'user_assets_pkey'
}

/** input type for inserting data into table "user_assets" */
export type User_Assets_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Assets_Max_Fields = {
  __typename?: 'user_assets_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_assets" */
export type User_Assets_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Assets_Min_Fields = {
  __typename?: 'user_assets_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  url?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_assets" */
export type User_Assets_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_assets" */
export type User_Assets_Mutation_Response = {
  __typename?: 'user_assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Assets>;
};

/** on_conflict condition type for table "user_assets" */
export type User_Assets_On_Conflict = {
  constraint: User_Assets_Constraint;
  update_columns?: Array<User_Assets_Update_Column>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "user_assets". */
export type User_Assets_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_assets */
export type User_Assets_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_assets" */
export enum User_Assets_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_assets" */
export type User_Assets_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  url?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "user_assets" */
export enum User_Assets_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UserId = 'user_id'
}

export type User_Assets_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Assets_Set_Input>;
  where: User_Assets_Bool_Exp;
};

/** columns and relationships of "user_roles" */
export type User_Roles = {
  __typename?: 'user_roles';
  role: Scalars['String'];
};

/** aggregated selection of "user_roles" */
export type User_Roles_Aggregate = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<User_Roles_Aggregate_Fields>;
  nodes: Array<User_Roles>;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_Fields = {
  __typename?: 'user_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Roles_Max_Fields>;
  min?: Maybe<User_Roles_Min_Fields>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  _not?: InputMaybe<User_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_Constraint {
  /** unique or primary key constraint on columns "role" */
  UserRolesPkey = 'user_roles_pkey'
}

export enum User_Roles_Enum {
  Admin = 'admin',
  Marquee = 'marquee',
  Sme = 'sme',
  User = 'user'
}

/** Boolean expression to compare columns of type "user_roles_enum". All fields are combined with logical 'AND'. */
export type User_Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Roles_Enum>;
  _in?: InputMaybe<Array<User_Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Roles_Enum>;
  _nin?: InputMaybe<Array<User_Roles_Enum>>;
};

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_Input = {
  role?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Roles_Max_Fields = {
  __typename?: 'user_roles_max_fields';
  role?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Roles_Min_Fields = {
  __typename?: 'user_roles_min_fields';
  role?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_Response = {
  __typename?: 'user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Roles>;
};

/** on_conflict condition type for table "user_roles" */
export type User_Roles_On_Conflict = {
  constraint: User_Roles_Constraint;
  update_columns?: Array<User_Roles_Update_Column>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_roles". */
export type User_Roles_Order_By = {
  role?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_roles */
export type User_Roles_Pk_Columns_Input = {
  role: Scalars['String'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_Column {
  /** column name */
  Role = 'role'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_Input = {
  role?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_Column {
  /** column name */
  Role = 'role'
}

export type User_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  /** An array relationship */
  comments: Array<Comments>;
  /** An aggregate relationship */
  comments_aggregate: Comments_Aggregate;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  /** A computed field, executes function "effective_invite_links" */
  effective_invite_links?: Maybe<Scalars['bigint']>;
  /** A computed field, executes function "effective_users_count" */
  effective_users_count?: Maybe<Scalars['bigint']>;
  email_id: Scalars['String'];
  email_verified?: Maybe<Scalars['Boolean']>;
  embedded_youtube_video?: Maybe<Scalars['String']>;
  /** An array relationship */
  expressions: Array<Expressions>;
  /** An aggregate relationship */
  expressions_aggregate: Expressions_Aggregate;
  facebook_link?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  forgot_token?: Maybe<Scalars['String']>;
  forgot_token_creation_time?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** An array relationship */
  invite_links: Array<Invite_Links>;
  /** An aggregate relationship */
  invite_links_aggregate: Invite_Links_Aggregate;
  /** An array relationship */
  invited_by: Array<Invite_Links>;
  /** An aggregate relationship */
  invited_by_aggregate: Invite_Links_Aggregate;
  is_deleted?: Maybe<Scalars['Boolean']>;
  is_invited_to_all_projects?: Maybe<Scalars['Boolean']>;
  is_phone_number_verified?: Maybe<Scalars['Boolean']>;
  is_private?: Maybe<Scalars['Boolean']>;
  kyc_file_name?: Maybe<Scalars['String']>;
  kyc_status?: Maybe<Kyc_Status_Enum>;
  kyc_submission_date?: Maybe<Scalars['timestamptz']>;
  kyc_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  likes: Array<Likes>;
  /** An aggregate relationship */
  likes_aggregate: Likes_Aggregate;
  linkedin_link?: Maybe<Scalars['String']>;
  location_coordinates?: Maybe<Scalars['geography']>;
  location_title?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  other_link?: Maybe<Scalars['String']>;
  page_name?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  password_updated_at?: Maybe<Scalars['date']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  portfolio?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  profile_updated?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  projects: Array<Projects>;
  /** An aggregate relationship */
  projects_aggregate: Projects_Aggregate;
  /** An array relationship */
  promotions: Array<Project_Promotions>;
  /** An aggregate relationship */
  promotions_aggregate: Project_Promotions_Aggregate;
  region_id?: Maybe<Scalars['uuid']>;
  representing_authority?: Maybe<Scalars['String']>;
  role?: Maybe<User_Roles_Enum>;
  sector?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
  /** A computed field, executes function "total_invite_links" */
  total_invite_links?: Maybe<Scalars['bigint']>;
  twitter_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  user_assets: Array<User_Assets>;
  /** An aggregate relationship */
  user_assets_aggregate: User_Assets_Aggregate;
  user_name?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  user_type_details?: Maybe<Scalars['jsonb']>;
  verification_token?: Maybe<Scalars['String']>;
  verification_token_creation_time?: Maybe<Scalars['date']>;
};


/** columns and relationships of "users" */
export type UsersCommentsArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersComments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Comments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Comments_Order_By>>;
  where?: InputMaybe<Comments_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersExpressionsArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersExpressions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expressions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expressions_Order_By>>;
  where?: InputMaybe<Expressions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvite_LinksArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvite_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvited_ByArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersInvited_By_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invite_Links_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Invite_Links_Order_By>>;
  where?: InputMaybe<Invite_Links_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLikesArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersLikes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Likes_Order_By>>;
  where?: InputMaybe<Likes_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProjectsArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersProjects_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Projects_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Projects_Order_By>>;
  where?: InputMaybe<Projects_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPromotionsArgs = {
  distinct_on?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Promotions_Order_By>>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPromotions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Project_Promotions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Project_Promotions_Order_By>>;
  where?: InputMaybe<Project_Promotions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_AssetsArgs = {
  distinct_on?: InputMaybe<Array<User_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assets_Order_By>>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Assets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Assets_Order_By>>;
  where?: InputMaybe<User_Assets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Type_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  user_type_details?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  about?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  comments?: InputMaybe<Comments_Bool_Exp>;
  company_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  designation?: InputMaybe<String_Comparison_Exp>;
  effective_invite_links?: InputMaybe<Bigint_Comparison_Exp>;
  effective_users_count?: InputMaybe<Bigint_Comparison_Exp>;
  email_id?: InputMaybe<String_Comparison_Exp>;
  email_verified?: InputMaybe<Boolean_Comparison_Exp>;
  embedded_youtube_video?: InputMaybe<String_Comparison_Exp>;
  expressions?: InputMaybe<Expressions_Bool_Exp>;
  facebook_link?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  forgot_token?: InputMaybe<String_Comparison_Exp>;
  forgot_token_creation_time?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invite_links?: InputMaybe<Invite_Links_Bool_Exp>;
  invited_by?: InputMaybe<Invite_Links_Bool_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_invited_to_all_projects?: InputMaybe<Boolean_Comparison_Exp>;
  is_phone_number_verified?: InputMaybe<Boolean_Comparison_Exp>;
  is_private?: InputMaybe<Boolean_Comparison_Exp>;
  kyc_file_name?: InputMaybe<String_Comparison_Exp>;
  kyc_status?: InputMaybe<Kyc_Status_Enum_Comparison_Exp>;
  kyc_submission_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  kyc_url?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  likes?: InputMaybe<Likes_Bool_Exp>;
  linkedin_link?: InputMaybe<String_Comparison_Exp>;
  location_coordinates?: InputMaybe<Geography_Comparison_Exp>;
  location_title?: InputMaybe<String_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  other_link?: InputMaybe<String_Comparison_Exp>;
  page_name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  password_updated_at?: InputMaybe<Date_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  photo?: InputMaybe<String_Comparison_Exp>;
  portfolio?: InputMaybe<String_Comparison_Exp>;
  profession?: InputMaybe<String_Comparison_Exp>;
  profile_picture?: InputMaybe<String_Comparison_Exp>;
  profile_updated?: InputMaybe<Boolean_Comparison_Exp>;
  projects?: InputMaybe<Projects_Bool_Exp>;
  promotions?: InputMaybe<Project_Promotions_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  representing_authority?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<User_Roles_Enum_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Boolean_Comparison_Exp>;
  total_invite_links?: InputMaybe<Bigint_Comparison_Exp>;
  twitter_link?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_assets?: InputMaybe<User_Assets_Bool_Exp>;
  user_name?: InputMaybe<String_Comparison_Exp>;
  user_type?: InputMaybe<String_Comparison_Exp>;
  user_type_details?: InputMaybe<Jsonb_Comparison_Exp>;
  verification_token?: InputMaybe<String_Comparison_Exp>;
  verification_token_creation_time?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email_id" */
  UsersEmailIdKey = 'users_email_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  user_type_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  user_type_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  user_type_details?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  about?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Comments_Arr_Rel_Insert_Input>;
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  designation?: InputMaybe<Scalars['String']>;
  email_id?: InputMaybe<Scalars['String']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  embedded_youtube_video?: InputMaybe<Scalars['String']>;
  expressions?: InputMaybe<Expressions_Arr_Rel_Insert_Input>;
  facebook_link?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  forgot_token?: InputMaybe<Scalars['String']>;
  forgot_token_creation_time?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  invite_links?: InputMaybe<Invite_Links_Arr_Rel_Insert_Input>;
  invited_by?: InputMaybe<Invite_Links_Arr_Rel_Insert_Input>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_invited_to_all_projects?: InputMaybe<Scalars['Boolean']>;
  is_phone_number_verified?: InputMaybe<Scalars['Boolean']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  kyc_file_name?: InputMaybe<Scalars['String']>;
  kyc_status?: InputMaybe<Kyc_Status_Enum>;
  kyc_submission_date?: InputMaybe<Scalars['timestamptz']>;
  kyc_url?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  likes?: InputMaybe<Likes_Arr_Rel_Insert_Input>;
  linkedin_link?: InputMaybe<Scalars['String']>;
  location_coordinates?: InputMaybe<Scalars['geography']>;
  location_title?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  other_link?: InputMaybe<Scalars['String']>;
  page_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  password_updated_at?: InputMaybe<Scalars['date']>;
  phone_number?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  portfolio?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<Scalars['String']>;
  profile_picture?: InputMaybe<Scalars['String']>;
  profile_updated?: InputMaybe<Scalars['Boolean']>;
  projects?: InputMaybe<Projects_Arr_Rel_Insert_Input>;
  promotions?: InputMaybe<Project_Promotions_Arr_Rel_Insert_Input>;
  region_id?: InputMaybe<Scalars['uuid']>;
  representing_authority?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<User_Roles_Enum>;
  sector?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  twitter_link?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_assets?: InputMaybe<User_Assets_Arr_Rel_Insert_Input>;
  user_name?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<Scalars['String']>;
  user_type_details?: InputMaybe<Scalars['jsonb']>;
  verification_token?: InputMaybe<Scalars['String']>;
  verification_token_creation_time?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  embedded_youtube_video?: Maybe<Scalars['String']>;
  facebook_link?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  forgot_token?: Maybe<Scalars['String']>;
  forgot_token_creation_time?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  kyc_file_name?: Maybe<Scalars['String']>;
  kyc_submission_date?: Maybe<Scalars['timestamptz']>;
  kyc_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  linkedin_link?: Maybe<Scalars['String']>;
  location_title?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  other_link?: Maybe<Scalars['String']>;
  page_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  password_updated_at?: Maybe<Scalars['date']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  portfolio?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['uuid']>;
  representing_authority?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  twitter_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_name?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  verification_token?: Maybe<Scalars['String']>;
  verification_token_creation_time?: Maybe<Scalars['date']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  about?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designation?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  embedded_youtube_video?: InputMaybe<Order_By>;
  facebook_link?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  forgot_token?: InputMaybe<Order_By>;
  forgot_token_creation_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_file_name?: InputMaybe<Order_By>;
  kyc_submission_date?: InputMaybe<Order_By>;
  kyc_url?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linkedin_link?: InputMaybe<Order_By>;
  location_title?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  other_link?: InputMaybe<Order_By>;
  page_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  password_updated_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  portfolio?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  profile_picture?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  representing_authority?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  twitter_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  verification_token?: InputMaybe<Order_By>;
  verification_token_creation_time?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  email_id?: Maybe<Scalars['String']>;
  embedded_youtube_video?: Maybe<Scalars['String']>;
  facebook_link?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  forgot_token?: Maybe<Scalars['String']>;
  forgot_token_creation_time?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  kyc_file_name?: Maybe<Scalars['String']>;
  kyc_submission_date?: Maybe<Scalars['timestamptz']>;
  kyc_url?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  linkedin_link?: Maybe<Scalars['String']>;
  location_title?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  other_link?: Maybe<Scalars['String']>;
  page_name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  password_updated_at?: Maybe<Scalars['date']>;
  phone_number?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  portfolio?: Maybe<Scalars['String']>;
  profession?: Maybe<Scalars['String']>;
  profile_picture?: Maybe<Scalars['String']>;
  region_id?: Maybe<Scalars['uuid']>;
  representing_authority?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  twitter_link?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_name?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  verification_token?: Maybe<Scalars['String']>;
  verification_token_creation_time?: Maybe<Scalars['date']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  about?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  company_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designation?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  embedded_youtube_video?: InputMaybe<Order_By>;
  facebook_link?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  forgot_token?: InputMaybe<Order_By>;
  forgot_token_creation_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kyc_file_name?: InputMaybe<Order_By>;
  kyc_submission_date?: InputMaybe<Order_By>;
  kyc_url?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linkedin_link?: InputMaybe<Order_By>;
  location_title?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  other_link?: InputMaybe<Order_By>;
  page_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  password_updated_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  portfolio?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  profile_picture?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  representing_authority?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  twitter_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  verification_token?: InputMaybe<Order_By>;
  verification_token_creation_time?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  about?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  comments_aggregate?: InputMaybe<Comments_Aggregate_Order_By>;
  company_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  designation?: InputMaybe<Order_By>;
  effective_invite_links?: InputMaybe<Order_By>;
  effective_users_count?: InputMaybe<Order_By>;
  email_id?: InputMaybe<Order_By>;
  email_verified?: InputMaybe<Order_By>;
  embedded_youtube_video?: InputMaybe<Order_By>;
  expressions_aggregate?: InputMaybe<Expressions_Aggregate_Order_By>;
  facebook_link?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  forgot_token?: InputMaybe<Order_By>;
  forgot_token_creation_time?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_links_aggregate?: InputMaybe<Invite_Links_Aggregate_Order_By>;
  invited_by_aggregate?: InputMaybe<Invite_Links_Aggregate_Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_invited_to_all_projects?: InputMaybe<Order_By>;
  is_phone_number_verified?: InputMaybe<Order_By>;
  is_private?: InputMaybe<Order_By>;
  kyc_file_name?: InputMaybe<Order_By>;
  kyc_status?: InputMaybe<Order_By>;
  kyc_submission_date?: InputMaybe<Order_By>;
  kyc_url?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  likes_aggregate?: InputMaybe<Likes_Aggregate_Order_By>;
  linkedin_link?: InputMaybe<Order_By>;
  location_coordinates?: InputMaybe<Order_By>;
  location_title?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  other_link?: InputMaybe<Order_By>;
  page_name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  password_updated_at?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  photo?: InputMaybe<Order_By>;
  portfolio?: InputMaybe<Order_By>;
  profession?: InputMaybe<Order_By>;
  profile_picture?: InputMaybe<Order_By>;
  profile_updated?: InputMaybe<Order_By>;
  projects_aggregate?: InputMaybe<Projects_Aggregate_Order_By>;
  promotions_aggregate?: InputMaybe<Project_Promotions_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  representing_authority?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  total_invite_links?: InputMaybe<Order_By>;
  twitter_link?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_assets_aggregate?: InputMaybe<User_Assets_Aggregate_Order_By>;
  user_name?: InputMaybe<Order_By>;
  user_type?: InputMaybe<Order_By>;
  user_type_details?: InputMaybe<Order_By>;
  verification_token?: InputMaybe<Order_By>;
  verification_token_creation_time?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  user_type_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  About = 'about',
  /** column name */
  Address = 'address',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Designation = 'designation',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  EmbeddedYoutubeVideo = 'embedded_youtube_video',
  /** column name */
  FacebookLink = 'facebook_link',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  ForgotToken = 'forgot_token',
  /** column name */
  ForgotTokenCreationTime = 'forgot_token_creation_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsInvitedToAllProjects = 'is_invited_to_all_projects',
  /** column name */
  IsPhoneNumberVerified = 'is_phone_number_verified',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  KycFileName = 'kyc_file_name',
  /** column name */
  KycStatus = 'kyc_status',
  /** column name */
  KycSubmissionDate = 'kyc_submission_date',
  /** column name */
  KycUrl = 'kyc_url',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedinLink = 'linkedin_link',
  /** column name */
  LocationCoordinates = 'location_coordinates',
  /** column name */
  LocationTitle = 'location_title',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  Name = 'name',
  /** column name */
  OtherLink = 'other_link',
  /** column name */
  PageName = 'page_name',
  /** column name */
  Password = 'password',
  /** column name */
  PasswordUpdatedAt = 'password_updated_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Photo = 'photo',
  /** column name */
  Portfolio = 'portfolio',
  /** column name */
  Profession = 'profession',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  ProfileUpdated = 'profile_updated',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RepresentingAuthority = 'representing_authority',
  /** column name */
  Role = 'role',
  /** column name */
  Sector = 'sector',
  /** column name */
  Status = 'status',
  /** column name */
  TwitterLink = 'twitter_link',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserName = 'user_name',
  /** column name */
  UserType = 'user_type',
  /** column name */
  UserTypeDetails = 'user_type_details',
  /** column name */
  VerificationToken = 'verification_token',
  /** column name */
  VerificationTokenCreationTime = 'verification_token_creation_time'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  about?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  designation?: InputMaybe<Scalars['String']>;
  email_id?: InputMaybe<Scalars['String']>;
  email_verified?: InputMaybe<Scalars['Boolean']>;
  embedded_youtube_video?: InputMaybe<Scalars['String']>;
  facebook_link?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  forgot_token?: InputMaybe<Scalars['String']>;
  forgot_token_creation_time?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_deleted?: InputMaybe<Scalars['Boolean']>;
  is_invited_to_all_projects?: InputMaybe<Scalars['Boolean']>;
  is_phone_number_verified?: InputMaybe<Scalars['Boolean']>;
  is_private?: InputMaybe<Scalars['Boolean']>;
  kyc_file_name?: InputMaybe<Scalars['String']>;
  kyc_status?: InputMaybe<Kyc_Status_Enum>;
  kyc_submission_date?: InputMaybe<Scalars['timestamptz']>;
  kyc_url?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  linkedin_link?: InputMaybe<Scalars['String']>;
  location_coordinates?: InputMaybe<Scalars['geography']>;
  location_title?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  other_link?: InputMaybe<Scalars['String']>;
  page_name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  password_updated_at?: InputMaybe<Scalars['date']>;
  phone_number?: InputMaybe<Scalars['String']>;
  photo?: InputMaybe<Scalars['String']>;
  portfolio?: InputMaybe<Scalars['String']>;
  profession?: InputMaybe<Scalars['String']>;
  profile_picture?: InputMaybe<Scalars['String']>;
  profile_updated?: InputMaybe<Scalars['Boolean']>;
  region_id?: InputMaybe<Scalars['uuid']>;
  representing_authority?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<User_Roles_Enum>;
  sector?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  twitter_link?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_name?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<Scalars['String']>;
  user_type_details?: InputMaybe<Scalars['jsonb']>;
  verification_token?: InputMaybe<Scalars['String']>;
  verification_token_creation_time?: InputMaybe<Scalars['date']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  About = 'about',
  /** column name */
  Address = 'address',
  /** column name */
  CompanyName = 'company_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Designation = 'designation',
  /** column name */
  EmailId = 'email_id',
  /** column name */
  EmailVerified = 'email_verified',
  /** column name */
  EmbeddedYoutubeVideo = 'embedded_youtube_video',
  /** column name */
  FacebookLink = 'facebook_link',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  ForgotToken = 'forgot_token',
  /** column name */
  ForgotTokenCreationTime = 'forgot_token_creation_time',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsInvitedToAllProjects = 'is_invited_to_all_projects',
  /** column name */
  IsPhoneNumberVerified = 'is_phone_number_verified',
  /** column name */
  IsPrivate = 'is_private',
  /** column name */
  KycFileName = 'kyc_file_name',
  /** column name */
  KycStatus = 'kyc_status',
  /** column name */
  KycSubmissionDate = 'kyc_submission_date',
  /** column name */
  KycUrl = 'kyc_url',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedinLink = 'linkedin_link',
  /** column name */
  LocationCoordinates = 'location_coordinates',
  /** column name */
  LocationTitle = 'location_title',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  Name = 'name',
  /** column name */
  OtherLink = 'other_link',
  /** column name */
  PageName = 'page_name',
  /** column name */
  Password = 'password',
  /** column name */
  PasswordUpdatedAt = 'password_updated_at',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Photo = 'photo',
  /** column name */
  Portfolio = 'portfolio',
  /** column name */
  Profession = 'profession',
  /** column name */
  ProfilePicture = 'profile_picture',
  /** column name */
  ProfileUpdated = 'profile_updated',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RepresentingAuthority = 'representing_authority',
  /** column name */
  Role = 'role',
  /** column name */
  Sector = 'sector',
  /** column name */
  Status = 'status',
  /** column name */
  TwitterLink = 'twitter_link',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserName = 'user_name',
  /** column name */
  UserType = 'user_type',
  /** column name */
  UserTypeDetails = 'user_type_details',
  /** column name */
  VerificationToken = 'verification_token',
  /** column name */
  VerificationTokenCreationTime = 'verification_token_creation_time'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type AcceptInviteMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AcceptInviteMutation = { __typename?: 'Mutation', acceptInvite: string };

export type AddLikesMutationVariables = Exact<{
  object: Likes_Insert_Input;
}>;


export type AddLikesMutation = { __typename?: 'Mutation', insert_likes_one?: { __typename?: 'likes', project: { __typename?: 'projects', id: any, likes_count: number, has_liked?: boolean | null } } | null };

export type AddSuggestProjectMutationVariables = Exact<{
  object: Suggest_Project_Insert_Input;
}>;


export type AddSuggestProjectMutation = { __typename?: 'Mutation', insert_suggest_project_one?: { __typename?: 'suggest_project', id: any } | null };

export type CheckUserExistsMutationVariables = Exact<{
  email: Scalars['String'];
  phone_number: Scalars['String'];
}>;


export type CheckUserExistsMutation = { __typename?: 'Mutation', checkUserExists?: boolean | null };

export type CountClickedInviteLinksMutationVariables = Exact<{
  inviteId: Scalars['uuid'];
}>;


export type CountClickedInviteLinksMutation = { __typename?: 'Mutation', update_invite_links?: { __typename?: 'invite_links_mutation_response', affected_rows: number } | null };

export type CreateProjectMutationVariables = Exact<{
  object: Projects_Insert_Input;
}>;


export type CreateProjectMutation = { __typename?: 'Mutation', insert_projects_one?: { __typename?: 'projects', id: any } | null };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  user_name: Scalars['String'];
  user_type: Scalars['String'];
  mobile: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: boolean | null };

export type DeleteCommentMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', delete_comments?: { __typename?: 'comments_mutation_response', returning: Array<{ __typename?: 'comments', id: any }> } | null };

export type DeleteExpressionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type DeleteExpressionMutation = { __typename?: 'Mutation', delete_expressions?: { __typename?: 'expressions_mutation_response', returning: Array<{ __typename?: 'expressions', id: any }> } | null };

export type DeleteLikesMutationVariables = Exact<{
  project_id: Scalars['uuid'];
}>;


export type DeleteLikesMutation = { __typename?: 'Mutation', delete_likes?: { __typename?: 'likes_mutation_response', returning: Array<{ __typename?: 'likes', project: { __typename?: 'projects', id: any, likes_count: number, has_liked?: boolean | null } }> } | null };

export type EditProfileMutationVariables = Exact<{
  _set?: InputMaybe<Users_Set_Input>;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type EditProfileMutation = { __typename?: 'Mutation', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: any, is_private?: boolean | null }> } | null };

export type ForgotPasswordMutationVariables = Exact<{
  phone_number: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: boolean | null };

export type GetEncyptedPasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type GetEncyptedPasswordMutation = { __typename?: 'Mutation', generatePassword: string };

export type GetUploadUrlMutationVariables = Exact<{
  fileName: Scalars['String'];
  fileSize: Scalars['Int'];
  path: Scalars['String'];
  uploadType: Scalars['String'];
}>;


export type GetUploadUrlMutation = { __typename?: 'Mutation', getUploadURL?: { __typename?: 'UploadFilePayload', downloadUrl: string, uploadParams: string, success: boolean } | null };

export type AddCommentMutationVariables = Exact<{
  project_id: Scalars['uuid'];
  comment: Scalars['String'];
  added_by: Scalars['uuid'];
  parent_comment_id?: InputMaybe<Scalars['uuid']>;
  is_verified?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', insert_comments_one?: { __typename?: 'comments', id: any, status?: boolean | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  commentId: Scalars['String'];
  comment: Scalars['String'];
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: string };

export type AddExpressionMutationVariables = Exact<{
  project_id: Scalars['uuid'];
  added_by: Scalars['uuid'];
  expressionMessage: Scalars['String'];
  investmentAmount: Scalars['numeric'];
}>;


export type AddExpressionMutation = { __typename?: 'Mutation', insert_expressions_one?: { __typename?: 'expressions', id: any, status?: boolean | null } | null };

export type InviteLinkMutationVariables = Exact<{
  user_id: Scalars['String'];
  project_id?: InputMaybe<Scalars['String']>;
  is_all?: InputMaybe<Scalars['Boolean']>;
}>;


export type InviteLinkMutation = { __typename?: 'Mutation', inviteLink?: string | null };

export type LoginMutationVariables = Exact<{
  phone_number: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: string | null };

export type UpdateProjectBackgroundMutationVariables = Exact<{
  url: Scalars['String'];
  id: Scalars['uuid'];
}>;


export type UpdateProjectBackgroundMutation = { __typename?: 'Mutation', update_projects?: { __typename?: 'projects_mutation_response', returning: Array<{ __typename?: 'projects', background?: string | null }> } | null };

export type PromoteProjectMutationVariables = Exact<{
  project_id: Scalars['uuid'];
  message: Scalars['String'];
  user_id: Scalars['uuid'];
}>;


export type PromoteProjectMutation = { __typename?: 'Mutation', insert_project_promotions_one?: { __typename?: 'project_promotions', project_id: any, user_id: any, message: string } | null };

export type RegisterMutationVariables = Exact<{
  email: Scalars['String'];
  phone_number: Scalars['String'];
  password: Scalars['String'];
  userType?: InputMaybe<Scalars['String']>;
  userTypeFieldsDetails: Scalars['String'];
  userName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: boolean | null };

export type ResendOtpMutationVariables = Exact<{
  phone_number: Scalars['String'];
}>;


export type ResendOtpMutation = { __typename?: 'Mutation', resendOtp?: boolean | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone_number: Scalars['String'];
  otp: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type ShareProjectMutationVariables = Exact<{
  email: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type ShareProjectMutation = { __typename?: 'Mutation', shareProject: boolean };

export type UpdateActiveProjectMutationVariables = Exact<{
  id: Scalars['uuid'];
  set?: InputMaybe<Projects_Set_Input>;
  images: Array<Project_Images_Insert_Input> | Project_Images_Insert_Input;
}>;


export type UpdateActiveProjectMutation = { __typename?: 'Mutation', update_projects?: { __typename?: 'projects_mutation_response', affected_rows: number } | null, delete_project_images?: { __typename?: 'project_images_mutation_response', affected_rows: number } | null, insert_project_images?: { __typename?: 'project_images_mutation_response', affected_rows: number } | null };

export type UpdateAssetsMutationVariables = Exact<{
  _set?: InputMaybe<Project_Assets_Set_Input>;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateAssetsMutation = { __typename?: 'Mutation', update_project_assets?: { __typename?: 'project_assets_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'project_assets', id: any, file_name: string, description?: string | null, asset_type?: string | null, created_at: any, project_id: any, updated_at: any, url: string }> } | null };

export type UpdateCommentStatusMutationVariables = Exact<{
  _set?: InputMaybe<Comments_Set_Input>;
  id: Scalars['uuid'];
}>;


export type UpdateCommentStatusMutation = { __typename?: 'Mutation', response?: { __typename?: 'comments', id: any, status?: boolean | null, project_id: any, updated_at?: any | null, is_verified?: boolean | null, parent_comment_id?: any | null } | null };

export type UpdateExpressionMutationVariables = Exact<{
  _set?: InputMaybe<Expressions_Set_Input>;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateExpressionMutation = { __typename?: 'Mutation', update_expressions?: { __typename?: 'expressions_mutation_response', returning: Array<{ __typename?: 'expressions', id: any, is_verified?: boolean | null }> } | null };

export type UpdateExpressionStatusMutationVariables = Exact<{
  _set?: InputMaybe<Expressions_Set_Input>;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateExpressionStatusMutation = { __typename?: 'Mutation', update_expressions?: { __typename?: 'expressions_mutation_response', returning: Array<{ __typename?: 'expressions', id: any, is_verified?: boolean | null }> } | null };

export type UpdateProjectsMutationVariables = Exact<{
  _set?: InputMaybe<Projects_Set_Input>;
  timelines: Array<Project_Timelines_Insert_Input> | Project_Timelines_Insert_Input;
  timelinesId: Array<Scalars['uuid']> | Scalars['uuid'];
  assetsId: Array<Scalars['uuid']> | Scalars['uuid'];
  assets: Array<Project_Assets_Insert_Input> | Project_Assets_Insert_Input;
  question_answers: Array<Project_Question_Answers_Insert_Input> | Project_Question_Answers_Insert_Input;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateProjectsMutation = { __typename?: 'Mutation', update_projects?: { __typename?: 'projects_mutation_response', returning: Array<{ __typename?: 'projects', id: any }> } | null, insert_project_timelines?: { __typename?: 'project_timelines_mutation_response', returning: Array<{ __typename?: 'project_timelines', id: any, title: string }> } | null, delete_project_timelines?: { __typename?: 'project_timelines_mutation_response', returning: Array<{ __typename?: 'project_timelines', title: string }> } | null, insert_project_assets?: { __typename?: 'project_assets_mutation_response', returning: Array<{ __typename?: 'project_assets', id: any }> } | null, delete_project_assets?: { __typename?: 'project_assets_mutation_response', returning: Array<{ __typename?: 'project_assets', id: any }> } | null, insert_project_question_answers?: { __typename?: 'project_question_answers_mutation_response', returning: Array<{ __typename?: 'project_question_answers', id: any }> } | null };

export type UpdateProjectProfileMutationVariables = Exact<{
  url: Scalars['String'];
  id: Scalars['uuid'];
}>;


export type UpdateProjectProfileMutation = { __typename?: 'Mutation', update_projects?: { __typename?: 'projects_mutation_response', returning: Array<{ __typename?: 'projects', project_profile_picture?: string | null }> } | null };

export type UpdateProjectStatusMutationVariables = Exact<{
  _set?: InputMaybe<Projects_Set_Input>;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateProjectStatusMutation = { __typename?: 'Mutation', update_projects?: { __typename?: 'projects_mutation_response', returning: Array<{ __typename?: 'projects', id: any, is_verified?: boolean | null, is_active?: boolean | null }> } | null };

export type UpdateUserKycStatusMutationVariables = Exact<{
  _set?: InputMaybe<Users_Set_Input>;
  id?: InputMaybe<Scalars['uuid']>;
}>;


export type UpdateUserKycStatusMutation = { __typename?: 'Mutation', update_users?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: any, kyc_status?: Kyc_Status_Enum | null }> } | null };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: string };

export type VerifyOtpMutationVariables = Exact<{
  otp: Scalars['String'];
  phone_number: Scalars['String'];
}>;


export type VerifyOtpMutation = { __typename?: 'Mutation', verifyOtp: string };

export type SendChangeEmailOtpMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendChangeEmailOtpMutation = { __typename?: 'Mutation', sendChangeEmailOtp: boolean };

export type VerifyChangeEmailOtpMutationVariables = Exact<{
  email: Scalars['String'];
  otp: Scalars['String'];
}>;


export type VerifyChangeEmailOtpMutation = { __typename?: 'Mutation', verifyChangeEmailOtp: boolean };

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteProjectMutation = { __typename?: 'Mutation', delete_comments?: { __typename?: 'comments_mutation_response', returning: Array<{ __typename?: 'comments', id: any }> } | null, delete_expressions?: { __typename?: 'expressions_mutation_response', returning: Array<{ __typename?: 'expressions', id: any }> } | null, delete_likes?: { __typename?: 'likes_mutation_response', returning: Array<{ __typename?: 'likes', project_id: any }> } | null, delete_project_assets?: { __typename?: 'project_assets_mutation_response', returning: Array<{ __typename?: 'project_assets', project_id: any }> } | null, delete_project_promotions?: { __typename?: 'project_promotions_mutation_response', returning: Array<{ __typename?: 'project_promotions', project_id: any }> } | null, delete_project_question_answers?: { __typename?: 'project_question_answers_mutation_response', returning: Array<{ __typename?: 'project_question_answers', project_id: any }> } | null, delete_project_timelines?: { __typename?: 'project_timelines_mutation_response', returning: Array<{ __typename?: 'project_timelines', project_id?: any | null }> } | null, delete_projects?: { __typename?: 'projects_mutation_response', returning: Array<{ __typename?: 'projects', id: any }> } | null };

export type GetAllLocationCoordinatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLocationCoordinatesQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'projects', location_coordinates?: any | null, id: any }> };

export type CommonCommentsFragmentFragment = { __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } };

export type VerifiedActiveProjectFragmentFragment = { __typename?: 'projects', id: any, added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, secondary_category?: string | null, participant_type?: string | null, location_title?: string | null, project_status?: string | null, created_at?: any | null, has_liked?: boolean | null, project_profile_picture?: string | null, is_active?: boolean | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, govt_authority_name?: string | null, impact_of_project?: string | null, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, likes_count: number, objective?: string | null, scope?: string | null, start_date: string, status?: boolean | null, title: string, type?: string | null, location_coordinates?: any | null, comments: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, replies: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } }>, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } }>, owner: Array<{ __typename?: 'users', user_name?: string | null, user_type?: string | null }>, likes: Array<{ __typename?: 'likes', created_at: any, project_id: any, user_id: any, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, likes_count: number, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, impact_of_project?: string | null, govt_authority_name?: string | null, id: any, type?: string | null, title: string, status?: boolean | null, start_date: string, scope?: string | null, objective?: string | null } }>, project_assets: Array<{ __typename?: 'project_assets', id: any, asset_type?: string | null, file_name: string, description?: string | null, url: string }>, expressions: Array<{ __typename?: 'expressions', status?: boolean | null, project_id: any, updated_at: any, is_verified?: boolean | null, investment_amount?: any | null, participation_type?: string | null, expression_message: string, added_by: any, created_at: any, investment_type?: string | null, is_deleted?: boolean | null, id: any, user: { __typename?: 'users', id: any, user_name?: string | null, name?: string | null, profile_picture?: string | null } }>, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', sum?: { __typename?: 'expressions_sum_fields', investment_amount?: any | null } | null } | null } };

export type GetAllVerifiedActiveProjectQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  comments_where?: InputMaybe<Comments_Bool_Exp>;
  and?: InputMaybe<Array<Projects_Bool_Exp> | Projects_Bool_Exp>;
}>;


export type GetAllVerifiedActiveProjectQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'projects', id: any, added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, secondary_category?: string | null, participant_type?: string | null, location_title?: string | null, project_status?: string | null, created_at?: any | null, has_liked?: boolean | null, project_profile_picture?: string | null, is_active?: boolean | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, govt_authority_name?: string | null, impact_of_project?: string | null, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, likes_count: number, objective?: string | null, scope?: string | null, start_date: string, status?: boolean | null, title: string, type?: string | null, location_coordinates?: any | null, comments: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, replies: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } }>, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } }>, owner: Array<{ __typename?: 'users', user_name?: string | null, user_type?: string | null }>, likes: Array<{ __typename?: 'likes', created_at: any, project_id: any, user_id: any, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, likes_count: number, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, impact_of_project?: string | null, govt_authority_name?: string | null, id: any, type?: string | null, title: string, status?: boolean | null, start_date: string, scope?: string | null, objective?: string | null } }>, project_assets: Array<{ __typename?: 'project_assets', id: any, asset_type?: string | null, file_name: string, description?: string | null, url: string }>, expressions: Array<{ __typename?: 'expressions', status?: boolean | null, project_id: any, updated_at: any, is_verified?: boolean | null, investment_amount?: any | null, participation_type?: string | null, expression_message: string, added_by: any, created_at: any, investment_type?: string | null, is_deleted?: boolean | null, id: any, user: { __typename?: 'users', id: any, user_name?: string | null, name?: string | null, profile_picture?: string | null } }>, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', sum?: { __typename?: 'expressions_sum_fields', investment_amount?: any | null } | null } | null } }> };

export type GetAllVerifiedActiveProjectForCurrentUserQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
  added_by: Scalars['uuid'];
  comments_where?: InputMaybe<Comments_Bool_Exp>;
  and?: InputMaybe<Array<Projects_Bool_Exp> | Projects_Bool_Exp>;
}>;


export type GetAllVerifiedActiveProjectForCurrentUserQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'projects', id: any, added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, secondary_category?: string | null, participant_type?: string | null, location_title?: string | null, project_status?: string | null, created_at?: any | null, has_liked?: boolean | null, project_profile_picture?: string | null, is_active?: boolean | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, govt_authority_name?: string | null, impact_of_project?: string | null, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, likes_count: number, objective?: string | null, scope?: string | null, start_date: string, status?: boolean | null, title: string, type?: string | null, location_coordinates?: any | null, comments: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, replies: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } }>, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, email_id: string, profile_picture?: string | null } }>, owner: Array<{ __typename?: 'users', user_name?: string | null, user_type?: string | null }>, likes: Array<{ __typename?: 'likes', created_at: any, project_id: any, user_id: any, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, likes_count: number, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, impact_of_project?: string | null, govt_authority_name?: string | null, id: any, type?: string | null, title: string, status?: boolean | null, start_date: string, scope?: string | null, objective?: string | null } }>, project_assets: Array<{ __typename?: 'project_assets', id: any, asset_type?: string | null, file_name: string, description?: string | null, url: string }>, expressions: Array<{ __typename?: 'expressions', status?: boolean | null, project_id: any, updated_at: any, is_verified?: boolean | null, investment_amount?: any | null, participation_type?: string | null, expression_message: string, added_by: any, created_at: any, investment_type?: string | null, is_deleted?: boolean | null, id: any, user: { __typename?: 'users', id: any, user_name?: string | null, name?: string | null, profile_picture?: string | null } }>, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', sum?: { __typename?: 'expressions_sum_fields', investment_amount?: any | null } | null } | null } }> };

export type GetCommentQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCommentQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'comments', comment: string, created_at?: any | null, id: any, is_deleted?: boolean | null, is_verified?: boolean | null, project_id: any, status?: boolean | null, added_by: any, parent_comment_id?: any | null, updated_at?: any | null, user: { __typename?: 'users', user_name?: string | null, user_type?: string | null, kyc_status?: Kyc_Status_Enum | null, email_id: string, role?: User_Roles_Enum | null, profile_picture?: string | null, id: any, name?: string | null, user_type_details?: any | null }, project: { __typename?: 'projects', title: string, created_at?: any | null } }> };

export type GetCommentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'comments', comment: string, created_at?: any | null, id: any, is_deleted?: boolean | null, is_verified?: boolean | null, project_id: any, status?: boolean | null, parent_comment_id?: any | null, added_by: any, user: { __typename?: 'users', email_id: string, role?: User_Roles_Enum | null, profile_picture?: string | null, name?: string | null, user_name?: string | null, id: any }, project: { __typename?: 'projects', title: string } }> };

export type GetConstituencyQueryVariables = Exact<{
  district: Scalars['String'];
}>;


export type GetConstituencyQuery = { __typename?: 'Query', districts: Array<{ __typename?: 'districts', constituency?: string | null }> };

export type GetCurrentUserQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetCurrentUserQuery = { __typename?: 'Query', users_by_pk?: { __typename?: 'users', id: any, user_name?: string | null, user_type?: string | null, user_type_details?: any | null, name?: string | null, first_name?: string | null, last_name?: string | null, description?: string | null, twitter_link?: string | null, facebook_link?: string | null, linkedin_link?: string | null, phone_number?: string | null, other_link?: string | null, profile_picture?: string | null, profession?: string | null, location_coordinates?: any | null, kyc_status?: Kyc_Status_Enum | null, kyc_url?: string | null, kyc_file_name?: string | null, kyc_submission_date?: any | null, location_title?: string | null, email_id: string, is_private?: boolean | null, role?: User_Roles_Enum | null, commentedProjects: Array<{ __typename?: 'comments', added_by: any, comment: string, created_at?: any | null, id: any, is_deleted?: boolean | null, is_verified?: boolean | null, status?: boolean | null, project_id: any, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, category?: string | null, created_at?: any | null, background?: string | null, email?: string | null, is_verified?: boolean | null, id: any, location_title?: string | null, location_coordinates?: any | null, likes_count: number, objective?: string | null, status?: boolean | null, is_active?: boolean | null, start_date: string, type?: string | null, title: string, project_profile_picture?: string | null, estimated_cost?: string | null } }>, likedProjects: Array<{ __typename?: 'likes', created_at: any, project_id: any, user_id: any, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, category?: string | null, secondary_category?: string | null, created_at?: any | null, background?: string | null, id: any, location_coordinates?: any | null, title: string, objective?: string | null, location_title?: string | null, project_profile_picture?: string | null, estimated_cost?: string | null } }>, promotedProjects: Array<{ __typename?: 'project_promotions', message: string, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, status?: boolean | null, is_active?: boolean | null, category?: string | null, secondary_category?: string | null, created_at?: any | null, background?: string | null, id: any, location_coordinates?: any | null, title: string, objective?: string | null, location_title?: string | null, project_profile_picture?: string | null, estimated_cost?: string | null } }>, initiatedProjects: Array<{ __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, status?: boolean | null, is_active?: boolean | null, category?: string | null, secondary_category?: string | null, created_at?: any | null, background?: string | null, id: any, location_coordinates?: any | null, title: string, objective?: string | null, location_title?: string | null, project_profile_picture?: string | null, estimated_cost?: string | null }>, expressedProjects: Array<{ __typename?: 'expressions', investment_amount?: any | null, investment_type?: string | null, expression_message: string, participation_type?: string | null, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, is_verified?: boolean | null, status?: boolean | null, is_active?: boolean | null, agency_name?: string | null, category?: string | null, secondary_category?: string | null, created_at?: any | null, background?: string | null, id: any, location_coordinates?: any | null, title: string, objective?: string | null, location_title?: string | null, project_profile_picture?: string | null, estimated_cost?: string | null } }> } | null };

export type GetCurrentUserExpressesProjectQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetCurrentUserExpressesProjectQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'projects', title: string, location_coordinates?: any | null, location_title?: string | null, created_at?: any | null, project_profile_picture?: string | null, comments: Array<{ __typename?: 'comments', id: any, comment: string, created_at?: any | null, parent_comment_id?: any | null }>, expressions: Array<{ __typename?: 'expressions', id: any, expression_message: string, created_at: any, investment_amount?: any | null }>, user?: { __typename?: 'users', id: any, user_name?: string | null } | null }> };

export type GetDashboardValuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardValuesQuery = { __typename?: 'Query', pending_users_count: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null }, all_users_count: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null }, pending_project_count: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, approve_project_count: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, total_projects_count: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, active_project_count: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, inactive_project_count: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, unique_users_comments_count: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, unique_users_expression_count: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, total_expression_count: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, total_comments_count: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, pending_comments: Array<{ __typename?: 'comments', comment: string }>, approved_comments: Array<{ __typename?: 'comments', comment: string }>, rejected_comments: Array<{ __typename?: 'comments', comment: string }>, recent_project_expressions: Array<{ __typename?: 'expressions', created_at: any, user: { __typename?: 'users', user_name?: string | null }, project: { __typename?: 'projects', title: string } }>, recent_project_comments: Array<{ __typename?: 'comments', created_at?: any | null, user: { __typename?: 'users', user_name?: string | null }, project: { __typename?: 'projects', title: string } }> };

export type GetDistrictsQueryVariables = Exact<{
  state: Scalars['String'];
}>;


export type GetDistrictsQuery = { __typename?: 'Query', districts: Array<{ __typename?: 'districts', id: any, district?: string | null }>, districts_aggregate: { __typename?: 'districts_aggregate', aggregate?: { __typename?: 'districts_aggregate_fields', count: number } | null } };

export type GetExpressionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExpressionQuery = { __typename?: 'Query', expressions: Array<{ __typename?: 'expressions', expression_message: string, investment_amount?: any | null, investment_type?: string | null, is_deleted?: boolean | null, is_verified?: boolean | null, participation_type?: string | null, project_id: any, status?: boolean | null, id: any, added_by: any, created_at: any, user: { __typename?: 'users', email_id: string, user_name?: string | null }, project: { __typename?: 'projects', title: string, investment_amount?: any | null } }> };

export type GetKycStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKycStatusQuery = { __typename?: 'Query', users: Array<{ __typename?: 'users', email_id: string, kyc_status?: Kyc_Status_Enum | null, kyc_url?: string | null, id: any, user_name?: string | null, kyc_submission_date?: any | null }> };

export type GetProjectQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProjectQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'projects', id: any, added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, address?: string | null, detailed_address?: string | null, category?: string | null, secondary_category?: string | null, participant_type?: string | null, conditions?: string | null, background?: string | null, requirements?: string | null, benefits?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, govt_authority_name?: string | null, impact_of_project?: string | null, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, is_active?: boolean | null, likes_count: number, objective?: string | null, scope?: string | null, start_date: string, project_status?: string | null, status?: boolean | null, title: string, type?: string | null, project_profile_picture?: string | null, problem?: string | null, phone?: string | null, email?: string | null, location_coordinates?: any | null, location_title?: string | null, created_at?: any | null, project_members: Array<{ __typename?: 'project_members', id: any }>, comments: Array<{ __typename?: 'comments', updated_at?: any | null, status?: boolean | null, project_id: any, is_verified?: boolean | null, created_at?: any | null, added_by: any, comment: string, id: any, is_deleted?: boolean | null, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, kyc_status?: Kyc_Status_Enum | null, email_id: string, role?: User_Roles_Enum | null } }>, likes: Array<{ __typename?: 'likes', user_id: any, project_id: any, created_at: any }>, expressions: Array<{ __typename?: 'expressions', added_by: any, created_at: any, expression_message: string, id: any, investment_amount?: any | null, investment_type?: string | null, participation_type?: string | null, is_verified?: boolean | null, is_deleted?: boolean | null, project_id: any, status?: boolean | null, updated_at: any, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, kyc_status?: Kyc_Status_Enum | null, email_id: string } }>, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', sum?: { __typename?: 'expressions_sum_fields', investment_amount?: any | null } | null } | null }, question_answers: Array<{ __typename?: 'project_question_answers', id: any, question: string, answer: string, project_id: any }>, timelines: Array<{ __typename?: 'project_timelines', date: any, id: any, project_id?: any | null, title: string, description: string }>, project_assets: Array<{ __typename?: 'project_assets', url: string, file_name: string, project_id: any, id: any, description?: string | null, created_at: any, updated_at: any, asset_type?: string | null }>, user?: { __typename?: 'users', location_title?: string | null, email_id: string, mobile?: string | null, name?: string | null, user_name?: string | null, kyc_status?: Kyc_Status_Enum | null } | null, images: Array<{ __typename?: 'project_images', image_url?: string | null }> }> };

export type GetProjectAnalyticsQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type GetProjectAnalyticsQuery = { __typename?: 'Query', projects_by_pk?: { __typename?: 'projects', id: any, title: string, project_status?: string | null, estimated_cost?: string | null, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null } } | null };

export type GetTotalInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalInvitesQuery = { __typename?: 'Query', invite_links_aggregate: { __typename?: 'invite_links_aggregate', aggregate?: { __typename?: 'invite_links_aggregate_fields', count: number } | null } };

export type GetProjectAnalyticsChartQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['uuid']>;
}>;


export type GetProjectAnalyticsChartQuery = { __typename?: 'Query', expressions: Array<{ __typename?: 'expressions', investment_amount?: any | null, id: any, created_at: any }> };

export type GetProjectsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset: Scalars['Int'];
}>;


export type GetProjectsQuery = { __typename?: 'Query', projects: Array<{ __typename?: 'projects', id: any, added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, secondary_category?: string | null, participant_type?: string | null, location_title?: string | null, has_liked?: boolean | null, project_profile_picture?: string | null, is_active?: boolean | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, govt_authority_name?: string | null, impact_of_project?: string | null, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, likes_count: number, objective?: string | null, scope?: string | null, start_date: string, status?: boolean | null, title: string, type?: string | null, location_coordinates?: any | null, comments: Array<{ __typename?: 'comments', is_verified?: boolean | null, is_deleted?: boolean | null, id: any, comment: string, added_by: any, created_at?: any | null, project_id: any, status?: boolean | null, updated_at?: any | null, user: { __typename?: 'users', id: any, name?: string | null, user_name?: string | null, kyc_status?: Kyc_Status_Enum | null, email_id: string } }>, owner: Array<{ __typename?: 'users', user_name?: string | null }>, likes: Array<{ __typename?: 'likes', created_at: any, project_id: any, user_id: any, project: { __typename?: 'projects', added_by?: any | null, agency_contact?: string | null, agency_name?: string | null, approved_value?: string | null, category?: string | null, conditions?: string | null, background?: string | null, embedded_youtube_video?: string | null, end_date: string, estimated_cost?: string | null, likes_count: number, investment_amount?: any | null, is_deleted?: boolean | null, is_verified?: boolean | null, impact_of_project?: string | null, govt_authority_name?: string | null, id: any, type?: string | null, title: string, status?: boolean | null, start_date: string, scope?: string | null, objective?: string | null } }>, project_assets: Array<{ __typename?: 'project_assets', id: any, asset_type?: string | null, file_name: string, description?: string | null, url: string }>, expressions: Array<{ __typename?: 'expressions', status?: boolean | null, project_id: any, updated_at: any, is_verified?: boolean | null, investment_amount?: any | null, participation_type?: string | null, expression_message: string, added_by: any, created_at: any, investment_type?: string | null, is_deleted?: boolean | null, id: any }>, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', sum?: { __typename?: 'expressions_sum_fields', investment_amount?: any | null } | null } | null } }> };

export type GetProjectsAggregationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsAggregationQuery = { __typename?: 'Query', projects_aggregate: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null }, distinct_aggregate: { __typename?: 'projects_aggregate', aggregate?: { __typename?: 'projects_aggregate_fields', count: number } | null } };

export type GetPromotedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromotedProjectsQuery = { __typename?: 'Query', project_promotions: Array<{ __typename?: 'project_promotions', project_id: any, message: string, project: { __typename?: 'projects', id: any, title: string, location_title?: string | null, project_profile_picture?: string | null } }> };

export type GetRegionAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionAdminQuery = { __typename?: 'Query', users: Array<{ __typename?: 'users', id: any }> };

export type GetUserFragmentFragment = { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, user_type_details?: any | null, profile_picture?: string | null, role?: User_Roles_Enum | null, created_at?: any | null, effective_invite_links?: any | null, effective_users_count?: any | null, total_invite_links?: any | null, invited_by: Array<{ __typename?: 'invite_links', id: any }>, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null } } | null }> } | null }> };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, user_type_details?: any | null, profile_picture?: string | null, role?: User_Roles_Enum | null, created_at?: any | null, effective_invite_links?: any | null, effective_users_count?: any | null, total_invite_links?: any | null, invited_by: Array<{ __typename?: 'invite_links', id: any }>, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null } } | null }> } | null }> }> };

export type GetUserQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type GetUserQuery = { __typename?: 'Query', users_by_pk?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, user_type_details?: any | null, profile_picture?: string | null, role?: User_Roles_Enum | null, created_at?: any | null, effective_invite_links?: any | null, effective_users_count?: any | null, total_invite_links?: any | null, invited_by: Array<{ __typename?: 'invite_links', id: any }>, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null } } | null }> } | null }> } | null };

export type GetUsersWhoJoinedWithoutInviteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersWhoJoinedWithoutInviteQuery = { __typename?: 'Query', users: Array<{ __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, user_type_details?: any | null, profile_picture?: string | null, role?: User_Roles_Enum | null, created_at?: any | null, effective_invite_links?: any | null, effective_users_count?: any | null, total_invite_links?: any | null, invited_by: Array<{ __typename?: 'invite_links', id: any }>, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null }, invite_links: Array<{ __typename?: 'invite_links', is_clicked?: boolean | null, invited_user?: { __typename?: 'users', id: any, name?: string | null, email_id: string, user_name?: string | null, user_type?: string | null, created_at?: any | null, user_type_details?: any | null, role?: User_Roles_Enum | null, effective_invite_links?: any | null, effective_users_count?: any | null, expressions_aggregate: { __typename?: 'expressions_aggregate', aggregate?: { __typename?: 'expressions_aggregate_fields', count: number } | null }, comments_aggregate: { __typename?: 'comments_aggregate', aggregate?: { __typename?: 'comments_aggregate_fields', count: number } | null } } | null }> } | null }> }> };

export type GetInviteLinksGeneratedByIndividualUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInviteLinksGeneratedByIndividualUsersQuery = { __typename?: 'Query', invite_links_aggregate: { __typename?: 'invite_links_aggregate', aggregate?: { __typename?: 'invite_links_aggregate_fields', count: number } | null } };

export type GetUsersWhoJoinedWithoutInviteCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersWhoJoinedWithoutInviteCountQuery = { __typename?: 'Query', users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type MeQueryVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type MeQuery = { __typename?: 'Query', users_by_pk?: { __typename?: 'users', id: any, name?: string | null, role?: User_Roles_Enum | null, is_invited_to_all_projects?: boolean | null, profile_picture?: string | null } | null };

export const CommonCommentsFragmentFragmentDoc = gql`
    fragment CommonCommentsFragment on comments {
  is_verified
  is_deleted
  id
  comment
  added_by
  created_at
  project_id
  status
  updated_at
  user {
    id
    name
    user_name
    email_id
    profile_picture
  }
}
    `;
export const VerifiedActiveProjectFragmentFragmentDoc = gql`
    fragment VerifiedActiveProjectFragment on projects {
  id
  added_by
  agency_contact
  agency_name
  approved_value
  category
  secondary_category
  participant_type
  location_title
  project_status
  created_at
  has_liked
  project_profile_picture
  is_active
  comments(where: $comments_where, order_by: {created_at: desc}) {
    ...CommonCommentsFragment
    replies {
      ...CommonCommentsFragment
    }
  }
  conditions
  background
  embedded_youtube_video
  participant_type
  end_date
  estimated_cost
  govt_authority_name
  impact_of_project
  investment_amount
  is_deleted
  is_verified
  likes_count
  owner {
    user_name
    user_type
  }
  likes {
    created_at
    project_id
    project {
      added_by
      agency_contact
      agency_name
      approved_value
      category
      conditions
      background
      embedded_youtube_video
      end_date
      estimated_cost
      likes_count
      investment_amount
      is_deleted
      is_verified
      impact_of_project
      govt_authority_name
      id
      type
      title
      status
      start_date
      scope
      objective
    }
    user_id
  }
  project_assets {
    id
    asset_type
    file_name
    description
    url
  }
  objective
  scope
  start_date
  status
  title
  type
  expressions {
    status
    project_id
    updated_at
    is_verified
    investment_amount
    participation_type
    expression_message
    added_by
    created_at
    participation_type
    investment_type
    is_deleted
    id
    created_at
    user {
      id
      user_name
      name
      profile_picture
    }
  }
  expressions_aggregate {
    aggregate {
      sum {
        investment_amount
      }
    }
  }
  location_coordinates
  location_title
}
    ${CommonCommentsFragmentFragmentDoc}`;
export const GetUserFragmentFragmentDoc = gql`
    fragment GetUserFragment on users {
  id
  name
  email_id
  user_name
  user_type
  user_type_details
  profile_picture
  role
  created_at
  effective_invite_links
  effective_users_count
  total_invite_links
  invited_by {
    id
  }
  invite_links {
    is_clicked
    invited_user {
      id
      name
      email_id
      user_name
      user_type
      created_at
      user_type_details
      role
      effective_invite_links
      effective_users_count
      expressions_aggregate {
        aggregate {
          count
        }
      }
      comments_aggregate {
        aggregate {
          count
        }
      }
      invite_links {
        is_clicked
        invited_user {
          id
          name
          email_id
          user_name
          user_type
          created_at
          user_type_details
          role
          effective_invite_links
          effective_users_count
          expressions_aggregate {
            aggregate {
              count
            }
          }
          comments_aggregate {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
}
    `;
export const AcceptInviteDocument = gql`
    mutation acceptInvite($id: String!) {
  acceptInvite(id: $id)
}
    `;
export type AcceptInviteMutationFn = Apollo.MutationFunction<AcceptInviteMutation, AcceptInviteMutationVariables>;

/**
 * __useAcceptInviteMutation__
 *
 * To run a mutation, you first call `useAcceptInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInviteMutation, { data, loading, error }] = useAcceptInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInviteMutation, AcceptInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInviteMutation, AcceptInviteMutationVariables>(AcceptInviteDocument, options);
      }
export type AcceptInviteMutationHookResult = ReturnType<typeof useAcceptInviteMutation>;
export type AcceptInviteMutationResult = Apollo.MutationResult<AcceptInviteMutation>;
export type AcceptInviteMutationOptions = Apollo.BaseMutationOptions<AcceptInviteMutation, AcceptInviteMutationVariables>;
export const AddLikesDocument = gql`
    mutation addLikes($object: likes_insert_input!) {
  insert_likes_one(object: $object) {
    project {
      id
      likes_count
      has_liked
    }
  }
}
    `;
export type AddLikesMutationFn = Apollo.MutationFunction<AddLikesMutation, AddLikesMutationVariables>;

/**
 * __useAddLikesMutation__
 *
 * To run a mutation, you first call `useAddLikesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLikesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLikesMutation, { data, loading, error }] = useAddLikesMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddLikesMutation(baseOptions?: Apollo.MutationHookOptions<AddLikesMutation, AddLikesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLikesMutation, AddLikesMutationVariables>(AddLikesDocument, options);
      }
export type AddLikesMutationHookResult = ReturnType<typeof useAddLikesMutation>;
export type AddLikesMutationResult = Apollo.MutationResult<AddLikesMutation>;
export type AddLikesMutationOptions = Apollo.BaseMutationOptions<AddLikesMutation, AddLikesMutationVariables>;
export const AddSuggestProjectDocument = gql`
    mutation addSuggestProject($object: suggest_project_insert_input!) {
  insert_suggest_project_one(object: $object) {
    id
  }
}
    `;
export type AddSuggestProjectMutationFn = Apollo.MutationFunction<AddSuggestProjectMutation, AddSuggestProjectMutationVariables>;

/**
 * __useAddSuggestProjectMutation__
 *
 * To run a mutation, you first call `useAddSuggestProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSuggestProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSuggestProjectMutation, { data, loading, error }] = useAddSuggestProjectMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddSuggestProjectMutation(baseOptions?: Apollo.MutationHookOptions<AddSuggestProjectMutation, AddSuggestProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSuggestProjectMutation, AddSuggestProjectMutationVariables>(AddSuggestProjectDocument, options);
      }
export type AddSuggestProjectMutationHookResult = ReturnType<typeof useAddSuggestProjectMutation>;
export type AddSuggestProjectMutationResult = Apollo.MutationResult<AddSuggestProjectMutation>;
export type AddSuggestProjectMutationOptions = Apollo.BaseMutationOptions<AddSuggestProjectMutation, AddSuggestProjectMutationVariables>;
export const CheckUserExistsDocument = gql`
    mutation checkUserExists($email: String!, $phone_number: String!) {
  checkUserExists(email: $email, phone_number: $phone_number)
}
    `;
export type CheckUserExistsMutationFn = Apollo.MutationFunction<CheckUserExistsMutation, CheckUserExistsMutationVariables>;

/**
 * __useCheckUserExistsMutation__
 *
 * To run a mutation, you first call `useCheckUserExistsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckUserExistsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkUserExistsMutation, { data, loading, error }] = useCheckUserExistsMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useCheckUserExistsMutation(baseOptions?: Apollo.MutationHookOptions<CheckUserExistsMutation, CheckUserExistsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckUserExistsMutation, CheckUserExistsMutationVariables>(CheckUserExistsDocument, options);
      }
export type CheckUserExistsMutationHookResult = ReturnType<typeof useCheckUserExistsMutation>;
export type CheckUserExistsMutationResult = Apollo.MutationResult<CheckUserExistsMutation>;
export type CheckUserExistsMutationOptions = Apollo.BaseMutationOptions<CheckUserExistsMutation, CheckUserExistsMutationVariables>;
export const CountClickedInviteLinksDocument = gql`
    mutation countClickedInviteLinks($inviteId: uuid!) {
  update_invite_links(where: {id: {_eq: $inviteId}}, _set: {is_clicked: true}) {
    affected_rows
  }
}
    `;
export type CountClickedInviteLinksMutationFn = Apollo.MutationFunction<CountClickedInviteLinksMutation, CountClickedInviteLinksMutationVariables>;

/**
 * __useCountClickedInviteLinksMutation__
 *
 * To run a mutation, you first call `useCountClickedInviteLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCountClickedInviteLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [countClickedInviteLinksMutation, { data, loading, error }] = useCountClickedInviteLinksMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useCountClickedInviteLinksMutation(baseOptions?: Apollo.MutationHookOptions<CountClickedInviteLinksMutation, CountClickedInviteLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CountClickedInviteLinksMutation, CountClickedInviteLinksMutationVariables>(CountClickedInviteLinksDocument, options);
      }
export type CountClickedInviteLinksMutationHookResult = ReturnType<typeof useCountClickedInviteLinksMutation>;
export type CountClickedInviteLinksMutationResult = Apollo.MutationResult<CountClickedInviteLinksMutation>;
export type CountClickedInviteLinksMutationOptions = Apollo.BaseMutationOptions<CountClickedInviteLinksMutation, CountClickedInviteLinksMutationVariables>;
export const CreateProjectDocument = gql`
    mutation createProject($object: projects_insert_input!) {
  insert_projects_one(object: $object) {
    id
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $first_name: String!, $last_name: String!, $user_name: String!, $user_type: String!, $mobile: String!, $password: String!) {
  createUser(
    email: $email
    first_name: $first_name
    last_name: $last_name
    user_name: $user_name
    user_type: $user_type
    mobile: $mobile
    password: $password
  )
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      user_name: // value for 'user_name'
 *      user_type: // value for 'user_type'
 *      mobile: // value for 'mobile'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($id: uuid) {
  delete_comments(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteExpressionDocument = gql`
    mutation deleteExpression($id: uuid) {
  delete_expressions(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteExpressionMutationFn = Apollo.MutationFunction<DeleteExpressionMutation, DeleteExpressionMutationVariables>;

/**
 * __useDeleteExpressionMutation__
 *
 * To run a mutation, you first call `useDeleteExpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpressionMutation, { data, loading, error }] = useDeleteExpressionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteExpressionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpressionMutation, DeleteExpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpressionMutation, DeleteExpressionMutationVariables>(DeleteExpressionDocument, options);
      }
export type DeleteExpressionMutationHookResult = ReturnType<typeof useDeleteExpressionMutation>;
export type DeleteExpressionMutationResult = Apollo.MutationResult<DeleteExpressionMutation>;
export type DeleteExpressionMutationOptions = Apollo.BaseMutationOptions<DeleteExpressionMutation, DeleteExpressionMutationVariables>;
export const DeleteLikesDocument = gql`
    mutation deleteLikes($project_id: uuid!) {
  delete_likes(where: {project_id: {_eq: $project_id}}) {
    returning {
      project {
        id
        likes_count
        has_liked
      }
    }
  }
}
    `;
export type DeleteLikesMutationFn = Apollo.MutationFunction<DeleteLikesMutation, DeleteLikesMutationVariables>;

/**
 * __useDeleteLikesMutation__
 *
 * To run a mutation, you first call `useDeleteLikesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLikesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLikesMutation, { data, loading, error }] = useDeleteLikesMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useDeleteLikesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLikesMutation, DeleteLikesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLikesMutation, DeleteLikesMutationVariables>(DeleteLikesDocument, options);
      }
export type DeleteLikesMutationHookResult = ReturnType<typeof useDeleteLikesMutation>;
export type DeleteLikesMutationResult = Apollo.MutationResult<DeleteLikesMutation>;
export type DeleteLikesMutationOptions = Apollo.BaseMutationOptions<DeleteLikesMutation, DeleteLikesMutationVariables>;
export const EditProfileDocument = gql`
    mutation editProfile($_set: users_set_input, $id: uuid) {
  update_users(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
      is_private
    }
  }
}
    `;
export type EditProfileMutationFn = Apollo.MutationFunction<EditProfileMutation, EditProfileMutationVariables>;

/**
 * __useEditProfileMutation__
 *
 * To run a mutation, you first call `useEditProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProfileMutation, { data, loading, error }] = useEditProfileMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditProfileMutation(baseOptions?: Apollo.MutationHookOptions<EditProfileMutation, EditProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProfileMutation, EditProfileMutationVariables>(EditProfileDocument, options);
      }
export type EditProfileMutationHookResult = ReturnType<typeof useEditProfileMutation>;
export type EditProfileMutationResult = Apollo.MutationResult<EditProfileMutation>;
export type EditProfileMutationOptions = Apollo.BaseMutationOptions<EditProfileMutation, EditProfileMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($phone_number: String!) {
  forgotPassword(phone_number: $phone_number)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const GetEncyptedPasswordDocument = gql`
    mutation getEncyptedPassword($password: String!) {
  generatePassword(password: $password)
}
    `;
export type GetEncyptedPasswordMutationFn = Apollo.MutationFunction<GetEncyptedPasswordMutation, GetEncyptedPasswordMutationVariables>;

/**
 * __useGetEncyptedPasswordMutation__
 *
 * To run a mutation, you first call `useGetEncyptedPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEncyptedPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEncyptedPasswordMutation, { data, loading, error }] = useGetEncyptedPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useGetEncyptedPasswordMutation(baseOptions?: Apollo.MutationHookOptions<GetEncyptedPasswordMutation, GetEncyptedPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetEncyptedPasswordMutation, GetEncyptedPasswordMutationVariables>(GetEncyptedPasswordDocument, options);
      }
export type GetEncyptedPasswordMutationHookResult = ReturnType<typeof useGetEncyptedPasswordMutation>;
export type GetEncyptedPasswordMutationResult = Apollo.MutationResult<GetEncyptedPasswordMutation>;
export type GetEncyptedPasswordMutationOptions = Apollo.BaseMutationOptions<GetEncyptedPasswordMutation, GetEncyptedPasswordMutationVariables>;
export const GetUploadUrlDocument = gql`
    mutation getUploadURL($fileName: String!, $fileSize: Int!, $path: String!, $uploadType: String!) {
  getUploadURL(
    fileName: $fileName
    fileSize: $fileSize
    path: $path
    uploadType: $uploadType
  ) {
    downloadUrl
    uploadParams
    success
  }
}
    `;
export type GetUploadUrlMutationFn = Apollo.MutationFunction<GetUploadUrlMutation, GetUploadUrlMutationVariables>;

/**
 * __useGetUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUploadUrlMutation, { data, loading, error }] = useGetUploadUrlMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      fileSize: // value for 'fileSize'
 *      path: // value for 'path'
 *      uploadType: // value for 'uploadType'
 *   },
 * });
 */
export function useGetUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetUploadUrlMutation, GetUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetUploadUrlMutation, GetUploadUrlMutationVariables>(GetUploadUrlDocument, options);
      }
export type GetUploadUrlMutationHookResult = ReturnType<typeof useGetUploadUrlMutation>;
export type GetUploadUrlMutationResult = Apollo.MutationResult<GetUploadUrlMutation>;
export type GetUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetUploadUrlMutation, GetUploadUrlMutationVariables>;
export const AddCommentDocument = gql`
    mutation addComment($project_id: uuid!, $comment: String!, $added_by: uuid!, $parent_comment_id: uuid, $is_verified: Boolean) {
  insert_comments_one(
    object: {project_id: $project_id, comment: $comment, added_by: $added_by, parent_comment_id: $parent_comment_id, is_verified: $is_verified}
  ) {
    id
    status
  }
}
    `;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      comment: // value for 'comment'
 *      added_by: // value for 'added_by'
 *      parent_comment_id: // value for 'parent_comment_id'
 *      is_verified: // value for 'is_verified'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation updateComment($commentId: String!, $comment: String!) {
  updateComment(commentId: $commentId, comment: $comment)
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const AddExpressionDocument = gql`
    mutation addExpression($project_id: uuid!, $added_by: uuid!, $expressionMessage: String!, $investmentAmount: numeric!) {
  insert_expressions_one(
    object: {project_id: $project_id, added_by: $added_by, expression_message: $expressionMessage, investment_amount: $investmentAmount}
  ) {
    id
    status
  }
}
    `;
export type AddExpressionMutationFn = Apollo.MutationFunction<AddExpressionMutation, AddExpressionMutationVariables>;

/**
 * __useAddExpressionMutation__
 *
 * To run a mutation, you first call `useAddExpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExpressionMutation, { data, loading, error }] = useAddExpressionMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      added_by: // value for 'added_by'
 *      expressionMessage: // value for 'expressionMessage'
 *      investmentAmount: // value for 'investmentAmount'
 *   },
 * });
 */
export function useAddExpressionMutation(baseOptions?: Apollo.MutationHookOptions<AddExpressionMutation, AddExpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExpressionMutation, AddExpressionMutationVariables>(AddExpressionDocument, options);
      }
export type AddExpressionMutationHookResult = ReturnType<typeof useAddExpressionMutation>;
export type AddExpressionMutationResult = Apollo.MutationResult<AddExpressionMutation>;
export type AddExpressionMutationOptions = Apollo.BaseMutationOptions<AddExpressionMutation, AddExpressionMutationVariables>;
export const InviteLinkDocument = gql`
    mutation inviteLink($user_id: String!, $project_id: String, $is_all: Boolean) {
  inviteLink(user_id: $user_id, project_id: $project_id, is_all: $is_all)
}
    `;
export type InviteLinkMutationFn = Apollo.MutationFunction<InviteLinkMutation, InviteLinkMutationVariables>;

/**
 * __useInviteLinkMutation__
 *
 * To run a mutation, you first call `useInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteLinkMutation, { data, loading, error }] = useInviteLinkMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      project_id: // value for 'project_id'
 *      is_all: // value for 'is_all'
 *   },
 * });
 */
export function useInviteLinkMutation(baseOptions?: Apollo.MutationHookOptions<InviteLinkMutation, InviteLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteLinkMutation, InviteLinkMutationVariables>(InviteLinkDocument, options);
      }
export type InviteLinkMutationHookResult = ReturnType<typeof useInviteLinkMutation>;
export type InviteLinkMutationResult = Apollo.MutationResult<InviteLinkMutation>;
export type InviteLinkMutationOptions = Apollo.BaseMutationOptions<InviteLinkMutation, InviteLinkMutationVariables>;
export const LoginDocument = gql`
    mutation Login($phone_number: String!, $password: String!) {
  login(phone_number: $phone_number, password: $password)
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const UpdateProjectBackgroundDocument = gql`
    mutation updateProjectBackground($url: String!, $id: uuid!) {
  update_projects(where: {id: {_eq: $id}}, _set: {background: $url}) {
    returning {
      background
    }
  }
}
    `;
export type UpdateProjectBackgroundMutationFn = Apollo.MutationFunction<UpdateProjectBackgroundMutation, UpdateProjectBackgroundMutationVariables>;

/**
 * __useUpdateProjectBackgroundMutation__
 *
 * To run a mutation, you first call `useUpdateProjectBackgroundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectBackgroundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectBackgroundMutation, { data, loading, error }] = useUpdateProjectBackgroundMutation({
 *   variables: {
 *      url: // value for 'url'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProjectBackgroundMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectBackgroundMutation, UpdateProjectBackgroundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectBackgroundMutation, UpdateProjectBackgroundMutationVariables>(UpdateProjectBackgroundDocument, options);
      }
export type UpdateProjectBackgroundMutationHookResult = ReturnType<typeof useUpdateProjectBackgroundMutation>;
export type UpdateProjectBackgroundMutationResult = Apollo.MutationResult<UpdateProjectBackgroundMutation>;
export type UpdateProjectBackgroundMutationOptions = Apollo.BaseMutationOptions<UpdateProjectBackgroundMutation, UpdateProjectBackgroundMutationVariables>;
export const PromoteProjectDocument = gql`
    mutation promoteProject($project_id: uuid!, $message: String!, $user_id: uuid!) {
  insert_project_promotions_one(
    object: {project_id: $project_id, message: $message, user_id: $user_id}
    on_conflict: {constraint: project_promotions_pkey, update_columns: [message]}
  ) {
    project_id
    user_id
    message
  }
}
    `;
export type PromoteProjectMutationFn = Apollo.MutationFunction<PromoteProjectMutation, PromoteProjectMutationVariables>;

/**
 * __usePromoteProjectMutation__
 *
 * To run a mutation, you first call `usePromoteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteProjectMutation, { data, loading, error }] = usePromoteProjectMutation({
 *   variables: {
 *      project_id: // value for 'project_id'
 *      message: // value for 'message'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function usePromoteProjectMutation(baseOptions?: Apollo.MutationHookOptions<PromoteProjectMutation, PromoteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteProjectMutation, PromoteProjectMutationVariables>(PromoteProjectDocument, options);
      }
export type PromoteProjectMutationHookResult = ReturnType<typeof usePromoteProjectMutation>;
export type PromoteProjectMutationResult = Apollo.MutationResult<PromoteProjectMutation>;
export type PromoteProjectMutationOptions = Apollo.BaseMutationOptions<PromoteProjectMutation, PromoteProjectMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($email: String!, $phone_number: String!, $password: String!, $userType: String, $userTypeFieldsDetails: String!, $userName: String!, $firstName: String!, $lastName: String!) {
  register(
    email: $email
    phone_number: $phone_number
    password: $password
    user_type: $userType
    user_type_details: $userTypeFieldsDetails
    user_name: $userName
    first_name: $firstName
    last_name: $lastName
  )
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      phone_number: // value for 'phone_number'
 *      password: // value for 'password'
 *      userType: // value for 'userType'
 *      userTypeFieldsDetails: // value for 'userTypeFieldsDetails'
 *      userName: // value for 'userName'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const ResendOtpDocument = gql`
    mutation resendOtp($phone_number: String!) {
  resendOtp(phone_number: $phone_number)
}
    `;
export type ResendOtpMutationFn = Apollo.MutationFunction<ResendOtpMutation, ResendOtpMutationVariables>;

/**
 * __useResendOtpMutation__
 *
 * To run a mutation, you first call `useResendOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendOtpMutation, { data, loading, error }] = useResendOtpMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useResendOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResendOtpMutation, ResendOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendOtpMutation, ResendOtpMutationVariables>(ResendOtpDocument, options);
      }
export type ResendOtpMutationHookResult = ReturnType<typeof useResendOtpMutation>;
export type ResendOtpMutationResult = Apollo.MutationResult<ResendOtpMutation>;
export type ResendOtpMutationOptions = Apollo.BaseMutationOptions<ResendOtpMutation, ResendOtpMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail($email: String!) {
  resendVerificationEmail(email: $email)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String, $password: String!, $phone_number: String!, $otp: String!) {
  resetPassword(
    token: $token
    password: $password
    phone_number: $phone_number
    otp: $otp
  )
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      phone_number: // value for 'phone_number'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ShareProjectDocument = gql`
    mutation shareProject($email: String!, $project_id: String!) {
  shareProject(email: $email, project_id: $project_id)
}
    `;
export type ShareProjectMutationFn = Apollo.MutationFunction<ShareProjectMutation, ShareProjectMutationVariables>;

/**
 * __useShareProjectMutation__
 *
 * To run a mutation, you first call `useShareProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareProjectMutation, { data, loading, error }] = useShareProjectMutation({
 *   variables: {
 *      email: // value for 'email'
 *      project_id: // value for 'project_id'
 *   },
 * });
 */
export function useShareProjectMutation(baseOptions?: Apollo.MutationHookOptions<ShareProjectMutation, ShareProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareProjectMutation, ShareProjectMutationVariables>(ShareProjectDocument, options);
      }
export type ShareProjectMutationHookResult = ReturnType<typeof useShareProjectMutation>;
export type ShareProjectMutationResult = Apollo.MutationResult<ShareProjectMutation>;
export type ShareProjectMutationOptions = Apollo.BaseMutationOptions<ShareProjectMutation, ShareProjectMutationVariables>;
export const UpdateActiveProjectDocument = gql`
    mutation UpdateActiveProject($id: uuid!, $set: projects_set_input, $images: [project_images_insert_input!]!) {
  update_projects(where: {id: {_eq: $id}}, _set: $set) {
    affected_rows
  }
  delete_project_images(where: {project_id: {_eq: $id}}) {
    affected_rows
  }
  insert_project_images(objects: $images) {
    affected_rows
  }
}
    `;
export type UpdateActiveProjectMutationFn = Apollo.MutationFunction<UpdateActiveProjectMutation, UpdateActiveProjectMutationVariables>;

/**
 * __useUpdateActiveProjectMutation__
 *
 * To run a mutation, you first call `useUpdateActiveProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActiveProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActiveProjectMutation, { data, loading, error }] = useUpdateActiveProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useUpdateActiveProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActiveProjectMutation, UpdateActiveProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActiveProjectMutation, UpdateActiveProjectMutationVariables>(UpdateActiveProjectDocument, options);
      }
export type UpdateActiveProjectMutationHookResult = ReturnType<typeof useUpdateActiveProjectMutation>;
export type UpdateActiveProjectMutationResult = Apollo.MutationResult<UpdateActiveProjectMutation>;
export type UpdateActiveProjectMutationOptions = Apollo.BaseMutationOptions<UpdateActiveProjectMutation, UpdateActiveProjectMutationVariables>;
export const UpdateAssetsDocument = gql`
    mutation updateAssets($_set: project_assets_set_input, $id: uuid) {
  update_project_assets(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
      file_name
      description
      asset_type
      created_at
      project_id
      updated_at
      url
    }
    affected_rows
  }
}
    `;
export type UpdateAssetsMutationFn = Apollo.MutationFunction<UpdateAssetsMutation, UpdateAssetsMutationVariables>;

/**
 * __useUpdateAssetsMutation__
 *
 * To run a mutation, you first call `useUpdateAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssetsMutation, { data, loading, error }] = useUpdateAssetsMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAssetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssetsMutation, UpdateAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssetsMutation, UpdateAssetsMutationVariables>(UpdateAssetsDocument, options);
      }
export type UpdateAssetsMutationHookResult = ReturnType<typeof useUpdateAssetsMutation>;
export type UpdateAssetsMutationResult = Apollo.MutationResult<UpdateAssetsMutation>;
export type UpdateAssetsMutationOptions = Apollo.BaseMutationOptions<UpdateAssetsMutation, UpdateAssetsMutationVariables>;
export const UpdateCommentStatusDocument = gql`
    mutation updateCommentStatus($_set: comments_set_input, $id: uuid!) {
  response: update_comments_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
    status
    project_id
    updated_at
    is_verified
    parent_comment_id
  }
}
    `;
export type UpdateCommentStatusMutationFn = Apollo.MutationFunction<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>;

/**
 * __useUpdateCommentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCommentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentStatusMutation, { data, loading, error }] = useUpdateCommentStatusMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCommentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>(UpdateCommentStatusDocument, options);
      }
export type UpdateCommentStatusMutationHookResult = ReturnType<typeof useUpdateCommentStatusMutation>;
export type UpdateCommentStatusMutationResult = Apollo.MutationResult<UpdateCommentStatusMutation>;
export type UpdateCommentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCommentStatusMutation, UpdateCommentStatusMutationVariables>;
export const UpdateExpressionDocument = gql`
    mutation updateExpression($_set: expressions_set_input, $id: uuid) {
  update_expressions(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
      is_verified
    }
  }
}
    `;
export type UpdateExpressionMutationFn = Apollo.MutationFunction<UpdateExpressionMutation, UpdateExpressionMutationVariables>;

/**
 * __useUpdateExpressionMutation__
 *
 * To run a mutation, you first call `useUpdateExpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpressionMutation, { data, loading, error }] = useUpdateExpressionMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateExpressionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpressionMutation, UpdateExpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpressionMutation, UpdateExpressionMutationVariables>(UpdateExpressionDocument, options);
      }
export type UpdateExpressionMutationHookResult = ReturnType<typeof useUpdateExpressionMutation>;
export type UpdateExpressionMutationResult = Apollo.MutationResult<UpdateExpressionMutation>;
export type UpdateExpressionMutationOptions = Apollo.BaseMutationOptions<UpdateExpressionMutation, UpdateExpressionMutationVariables>;
export const UpdateExpressionStatusDocument = gql`
    mutation updateExpressionStatus($_set: expressions_set_input, $id: uuid) {
  update_expressions(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
      is_verified
    }
  }
}
    `;
export type UpdateExpressionStatusMutationFn = Apollo.MutationFunction<UpdateExpressionStatusMutation, UpdateExpressionStatusMutationVariables>;

/**
 * __useUpdateExpressionStatusMutation__
 *
 * To run a mutation, you first call `useUpdateExpressionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpressionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpressionStatusMutation, { data, loading, error }] = useUpdateExpressionStatusMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateExpressionStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExpressionStatusMutation, UpdateExpressionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExpressionStatusMutation, UpdateExpressionStatusMutationVariables>(UpdateExpressionStatusDocument, options);
      }
export type UpdateExpressionStatusMutationHookResult = ReturnType<typeof useUpdateExpressionStatusMutation>;
export type UpdateExpressionStatusMutationResult = Apollo.MutationResult<UpdateExpressionStatusMutation>;
export type UpdateExpressionStatusMutationOptions = Apollo.BaseMutationOptions<UpdateExpressionStatusMutation, UpdateExpressionStatusMutationVariables>;
export const UpdateProjectsDocument = gql`
    mutation updateProjects($_set: projects_set_input, $timelines: [project_timelines_insert_input!]!, $timelinesId: [uuid!]!, $assetsId: [uuid!]!, $assets: [project_assets_insert_input!]!, $question_answers: [project_question_answers_insert_input!]!, $id: uuid) {
  update_projects(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
    }
  }
  insert_project_timelines(
    objects: $timelines
    on_conflict: {constraint: project_timelines_pkey, update_columns: [title, description, date]}
  ) {
    returning {
      id
      title
    }
  }
  delete_project_timelines(where: {id: {_in: $timelinesId}}) {
    returning {
      title
    }
  }
  insert_project_assets(
    objects: $assets
    on_conflict: {constraint: project_assets_pkey, update_columns: []}
  ) {
    returning {
      id
    }
  }
  delete_project_assets(where: {id: {_in: $assetsId}}) {
    returning {
      id
    }
  }
  insert_project_question_answers(
    objects: $question_answers
    on_conflict: {constraint: project_question_answers_pkey, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpdateProjectsMutationFn = Apollo.MutationFunction<UpdateProjectsMutation, UpdateProjectsMutationVariables>;

/**
 * __useUpdateProjectsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectsMutation, { data, loading, error }] = useUpdateProjectsMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      timelines: // value for 'timelines'
 *      timelinesId: // value for 'timelinesId'
 *      assetsId: // value for 'assetsId'
 *      assets: // value for 'assets'
 *      question_answers: // value for 'question_answers'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProjectsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectsMutation, UpdateProjectsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectsMutation, UpdateProjectsMutationVariables>(UpdateProjectsDocument, options);
      }
export type UpdateProjectsMutationHookResult = ReturnType<typeof useUpdateProjectsMutation>;
export type UpdateProjectsMutationResult = Apollo.MutationResult<UpdateProjectsMutation>;
export type UpdateProjectsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectsMutation, UpdateProjectsMutationVariables>;
export const UpdateProjectProfileDocument = gql`
    mutation updateProjectProfile($url: String!, $id: uuid!) {
  update_projects(where: {id: {_eq: $id}}, _set: {project_profile_picture: $url}) {
    returning {
      project_profile_picture
    }
  }
}
    `;
export type UpdateProjectProfileMutationFn = Apollo.MutationFunction<UpdateProjectProfileMutation, UpdateProjectProfileMutationVariables>;

/**
 * __useUpdateProjectProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProjectProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectProfileMutation, { data, loading, error }] = useUpdateProjectProfileMutation({
 *   variables: {
 *      url: // value for 'url'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProjectProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectProfileMutation, UpdateProjectProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectProfileMutation, UpdateProjectProfileMutationVariables>(UpdateProjectProfileDocument, options);
      }
export type UpdateProjectProfileMutationHookResult = ReturnType<typeof useUpdateProjectProfileMutation>;
export type UpdateProjectProfileMutationResult = Apollo.MutationResult<UpdateProjectProfileMutation>;
export type UpdateProjectProfileMutationOptions = Apollo.BaseMutationOptions<UpdateProjectProfileMutation, UpdateProjectProfileMutationVariables>;
export const UpdateProjectStatusDocument = gql`
    mutation updateProjectStatus($_set: projects_set_input, $id: uuid) {
  update_projects(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
      is_verified
      is_active
    }
  }
}
    `;
export type UpdateProjectStatusMutationFn = Apollo.MutationFunction<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;

/**
 * __useUpdateProjectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatusMutation, { data, loading, error }] = useUpdateProjectStatusMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProjectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>(UpdateProjectStatusDocument, options);
      }
export type UpdateProjectStatusMutationHookResult = ReturnType<typeof useUpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationResult = Apollo.MutationResult<UpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const UpdateUserKycStatusDocument = gql`
    mutation updateUserKycStatus($_set: users_set_input, $id: uuid) {
  update_users(where: {id: {_eq: $id}}, _set: $_set) {
    returning {
      id
      kyc_status
    }
  }
}
    `;
export type UpdateUserKycStatusMutationFn = Apollo.MutationFunction<UpdateUserKycStatusMutation, UpdateUserKycStatusMutationVariables>;

/**
 * __useUpdateUserKycStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserKycStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserKycStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserKycStatusMutation, { data, loading, error }] = useUpdateUserKycStatusMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserKycStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserKycStatusMutation, UpdateUserKycStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserKycStatusMutation, UpdateUserKycStatusMutationVariables>(UpdateUserKycStatusDocument, options);
      }
export type UpdateUserKycStatusMutationHookResult = ReturnType<typeof useUpdateUserKycStatusMutation>;
export type UpdateUserKycStatusMutationResult = Apollo.MutationResult<UpdateUserKycStatusMutation>;
export type UpdateUserKycStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserKycStatusMutation, UpdateUserKycStatusMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($token: String!) {
  verifyEmail(token: $token)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const VerifyOtpDocument = gql`
    mutation verifyOtp($otp: String!, $phone_number: String!) {
  verifyOtp(otp: $otp, phone_number: $phone_number)
}
    `;
export type VerifyOtpMutationFn = Apollo.MutationFunction<VerifyOtpMutation, VerifyOtpMutationVariables>;

/**
 * __useVerifyOtpMutation__
 *
 * To run a mutation, you first call `useVerifyOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOtpMutation, { data, loading, error }] = useVerifyOtpMutation({
 *   variables: {
 *      otp: // value for 'otp'
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useVerifyOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOtpMutation, VerifyOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOtpMutation, VerifyOtpMutationVariables>(VerifyOtpDocument, options);
      }
export type VerifyOtpMutationHookResult = ReturnType<typeof useVerifyOtpMutation>;
export type VerifyOtpMutationResult = Apollo.MutationResult<VerifyOtpMutation>;
export type VerifyOtpMutationOptions = Apollo.BaseMutationOptions<VerifyOtpMutation, VerifyOtpMutationVariables>;
export const SendChangeEmailOtpDocument = gql`
    mutation SendChangeEmailOtp($email: String!) {
  sendChangeEmailOtp(email: $email)
}
    `;
export type SendChangeEmailOtpMutationFn = Apollo.MutationFunction<SendChangeEmailOtpMutation, SendChangeEmailOtpMutationVariables>;

/**
 * __useSendChangeEmailOtpMutation__
 *
 * To run a mutation, you first call `useSendChangeEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChangeEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChangeEmailOtpMutation, { data, loading, error }] = useSendChangeEmailOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendChangeEmailOtpMutation(baseOptions?: Apollo.MutationHookOptions<SendChangeEmailOtpMutation, SendChangeEmailOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendChangeEmailOtpMutation, SendChangeEmailOtpMutationVariables>(SendChangeEmailOtpDocument, options);
      }
export type SendChangeEmailOtpMutationHookResult = ReturnType<typeof useSendChangeEmailOtpMutation>;
export type SendChangeEmailOtpMutationResult = Apollo.MutationResult<SendChangeEmailOtpMutation>;
export type SendChangeEmailOtpMutationOptions = Apollo.BaseMutationOptions<SendChangeEmailOtpMutation, SendChangeEmailOtpMutationVariables>;
export const VerifyChangeEmailOtpDocument = gql`
    mutation VerifyChangeEmailOtp($email: String!, $otp: String!) {
  verifyChangeEmailOtp(email: $email, otp: $otp)
}
    `;
export type VerifyChangeEmailOtpMutationFn = Apollo.MutationFunction<VerifyChangeEmailOtpMutation, VerifyChangeEmailOtpMutationVariables>;

/**
 * __useVerifyChangeEmailOtpMutation__
 *
 * To run a mutation, you first call `useVerifyChangeEmailOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyChangeEmailOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyChangeEmailOtpMutation, { data, loading, error }] = useVerifyChangeEmailOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useVerifyChangeEmailOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyChangeEmailOtpMutation, VerifyChangeEmailOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyChangeEmailOtpMutation, VerifyChangeEmailOtpMutationVariables>(VerifyChangeEmailOtpDocument, options);
      }
export type VerifyChangeEmailOtpMutationHookResult = ReturnType<typeof useVerifyChangeEmailOtpMutation>;
export type VerifyChangeEmailOtpMutationResult = Apollo.MutationResult<VerifyChangeEmailOtpMutation>;
export type VerifyChangeEmailOtpMutationOptions = Apollo.BaseMutationOptions<VerifyChangeEmailOtpMutation, VerifyChangeEmailOtpMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation deleteProject($id: uuid!) {
  delete_comments(where: {project_id: {_eq: $id}}) {
    returning {
      id
    }
  }
  delete_expressions(where: {project_id: {_eq: $id}}) {
    returning {
      id
    }
  }
  delete_likes(where: {project_id: {_eq: $id}}) {
    returning {
      project_id
    }
  }
  delete_project_assets(where: {project_id: {_eq: $id}}) {
    returning {
      project_id
    }
  }
  delete_project_promotions(where: {project_id: {_eq: $id}}) {
    returning {
      project_id
    }
  }
  delete_project_question_answers(where: {project_id: {_eq: $id}}) {
    returning {
      project_id
    }
  }
  delete_project_timelines(where: {project_id: {_eq: $id}}) {
    returning {
      project_id
    }
  }
  delete_projects(where: {id: {_eq: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const GetAllLocationCoordinatesDocument = gql`
    query getAllLocationCoordinates {
  projects(
    where: {is_active: {_eq: true}, is_deleted: {_eq: false}, is_verified: {_eq: true}}
  ) {
    location_coordinates
    id
  }
}
    `;

/**
 * __useGetAllLocationCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetAllLocationCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationCoordinatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllLocationCoordinatesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationCoordinatesQuery, GetAllLocationCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationCoordinatesQuery, GetAllLocationCoordinatesQueryVariables>(GetAllLocationCoordinatesDocument, options);
      }
export function useGetAllLocationCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationCoordinatesQuery, GetAllLocationCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationCoordinatesQuery, GetAllLocationCoordinatesQueryVariables>(GetAllLocationCoordinatesDocument, options);
        }
export type GetAllLocationCoordinatesQueryHookResult = ReturnType<typeof useGetAllLocationCoordinatesQuery>;
export type GetAllLocationCoordinatesLazyQueryHookResult = ReturnType<typeof useGetAllLocationCoordinatesLazyQuery>;
export type GetAllLocationCoordinatesQueryResult = Apollo.QueryResult<GetAllLocationCoordinatesQuery, GetAllLocationCoordinatesQueryVariables>;
export const GetAllVerifiedActiveProjectDocument = gql`
    query getAllVerifiedActiveProject($limit: Int, $offset: Int!, $comments_where: comments_bool_exp, $and: [projects_bool_exp!]) {
  projects(
    limit: $limit
    offset: $offset
    order_by: {start_date: desc_nulls_last}
    where: {is_active: {_eq: true}, is_deleted: {_eq: false}, is_verified: {_eq: true}, _and: $and}
  ) {
    ...VerifiedActiveProjectFragment
  }
}
    ${VerifiedActiveProjectFragmentFragmentDoc}`;

/**
 * __useGetAllVerifiedActiveProjectQuery__
 *
 * To run a query within a React component, call `useGetAllVerifiedActiveProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVerifiedActiveProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVerifiedActiveProjectQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      comments_where: // value for 'comments_where'
 *      and: // value for 'and'
 *   },
 * });
 */
export function useGetAllVerifiedActiveProjectQuery(baseOptions: Apollo.QueryHookOptions<GetAllVerifiedActiveProjectQuery, GetAllVerifiedActiveProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVerifiedActiveProjectQuery, GetAllVerifiedActiveProjectQueryVariables>(GetAllVerifiedActiveProjectDocument, options);
      }
export function useGetAllVerifiedActiveProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVerifiedActiveProjectQuery, GetAllVerifiedActiveProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVerifiedActiveProjectQuery, GetAllVerifiedActiveProjectQueryVariables>(GetAllVerifiedActiveProjectDocument, options);
        }
export type GetAllVerifiedActiveProjectQueryHookResult = ReturnType<typeof useGetAllVerifiedActiveProjectQuery>;
export type GetAllVerifiedActiveProjectLazyQueryHookResult = ReturnType<typeof useGetAllVerifiedActiveProjectLazyQuery>;
export type GetAllVerifiedActiveProjectQueryResult = Apollo.QueryResult<GetAllVerifiedActiveProjectQuery, GetAllVerifiedActiveProjectQueryVariables>;
export const GetAllVerifiedActiveProjectForCurrentUserDocument = gql`
    query getAllVerifiedActiveProjectForCurrentUser($limit: Int, $offset: Int!, $added_by: uuid!, $comments_where: comments_bool_exp, $and: [projects_bool_exp!]) {
  projects(
    limit: $limit
    offset: $offset
    order_by: {start_date: desc_nulls_last}
    where: {is_active: {_eq: true}, is_deleted: {_eq: false}, is_verified: {_eq: true}, added_by: {_eq: $added_by}, _and: $and}
  ) {
    ...VerifiedActiveProjectFragment
  }
}
    ${VerifiedActiveProjectFragmentFragmentDoc}`;

/**
 * __useGetAllVerifiedActiveProjectForCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetAllVerifiedActiveProjectForCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllVerifiedActiveProjectForCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllVerifiedActiveProjectForCurrentUserQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      added_by: // value for 'added_by'
 *      comments_where: // value for 'comments_where'
 *      and: // value for 'and'
 *   },
 * });
 */
export function useGetAllVerifiedActiveProjectForCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetAllVerifiedActiveProjectForCurrentUserQuery, GetAllVerifiedActiveProjectForCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllVerifiedActiveProjectForCurrentUserQuery, GetAllVerifiedActiveProjectForCurrentUserQueryVariables>(GetAllVerifiedActiveProjectForCurrentUserDocument, options);
      }
export function useGetAllVerifiedActiveProjectForCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllVerifiedActiveProjectForCurrentUserQuery, GetAllVerifiedActiveProjectForCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllVerifiedActiveProjectForCurrentUserQuery, GetAllVerifiedActiveProjectForCurrentUserQueryVariables>(GetAllVerifiedActiveProjectForCurrentUserDocument, options);
        }
export type GetAllVerifiedActiveProjectForCurrentUserQueryHookResult = ReturnType<typeof useGetAllVerifiedActiveProjectForCurrentUserQuery>;
export type GetAllVerifiedActiveProjectForCurrentUserLazyQueryHookResult = ReturnType<typeof useGetAllVerifiedActiveProjectForCurrentUserLazyQuery>;
export type GetAllVerifiedActiveProjectForCurrentUserQueryResult = Apollo.QueryResult<GetAllVerifiedActiveProjectForCurrentUserQuery, GetAllVerifiedActiveProjectForCurrentUserQueryVariables>;
export const GetCommentDocument = gql`
    query getComment($id: uuid!) {
  comments(
    where: {project_id: {_eq: $id}, status: {_eq: true}}
    order_by: {created_at: desc, added_by: asc}
  ) {
    comment
    created_at
    id
    is_deleted
    is_verified
    project_id
    status
    added_by
    parent_comment_id
    user {
      user_name
      user_type
      kyc_status
      email_id
      role
      profile_picture
      id
      name
      user_type_details
    }
    project {
      title
      created_at
    }
    updated_at
  }
}
    `;

/**
 * __useGetCommentQuery__
 *
 * To run a query within a React component, call `useGetCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommentQuery(baseOptions: Apollo.QueryHookOptions<GetCommentQuery, GetCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
      }
export function useGetCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentQuery, GetCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentQuery, GetCommentQueryVariables>(GetCommentDocument, options);
        }
export type GetCommentQueryHookResult = ReturnType<typeof useGetCommentQuery>;
export type GetCommentLazyQueryHookResult = ReturnType<typeof useGetCommentLazyQuery>;
export type GetCommentQueryResult = Apollo.QueryResult<GetCommentQuery, GetCommentQueryVariables>;
export const GetCommentsDocument = gql`
    query getComments {
  comments(order_by: {created_at: desc}) {
    comment
    created_at
    id
    is_deleted
    is_verified
    project_id
    status
    parent_comment_id
    added_by
    user {
      email_id
      role
      profile_picture
      name
      user_name
      id
    }
    project {
      title
    }
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const GetConstituencyDocument = gql`
    query getConstituency($district: String!) {
  districts(where: {district: {_eq: $district}}) {
    constituency
  }
}
    `;

/**
 * __useGetConstituencyQuery__
 *
 * To run a query within a React component, call `useGetConstituencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstituencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstituencyQuery({
 *   variables: {
 *      district: // value for 'district'
 *   },
 * });
 */
export function useGetConstituencyQuery(baseOptions: Apollo.QueryHookOptions<GetConstituencyQuery, GetConstituencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConstituencyQuery, GetConstituencyQueryVariables>(GetConstituencyDocument, options);
      }
export function useGetConstituencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConstituencyQuery, GetConstituencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConstituencyQuery, GetConstituencyQueryVariables>(GetConstituencyDocument, options);
        }
export type GetConstituencyQueryHookResult = ReturnType<typeof useGetConstituencyQuery>;
export type GetConstituencyLazyQueryHookResult = ReturnType<typeof useGetConstituencyLazyQuery>;
export type GetConstituencyQueryResult = Apollo.QueryResult<GetConstituencyQuery, GetConstituencyQueryVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser($id: uuid!) {
  users_by_pk(id: $id) {
    id
    user_name
    user_type
    user_type_details
    name
    first_name
    last_name
    description
    twitter_link
    facebook_link
    linkedin_link
    phone_number
    other_link
    profile_picture
    profession
    location_coordinates
    kyc_status
    kyc_url
    kyc_file_name
    kyc_submission_date
    location_title
    email_id
    is_private
    role
    commentedProjects: comments {
      added_by
      comment
      created_at
      id
      is_deleted
      is_verified
      status
      project_id
      project {
        added_by
        agency_contact
        agency_name
        category
        created_at
        background
        email
        is_verified
        id
        location_title
        location_coordinates
        likes_count
        objective
        status
        is_active
        start_date
        type
        title
        project_profile_picture
        estimated_cost
      }
    }
    likedProjects: likes {
      created_at
      project_id
      user_id
      project {
        added_by
        agency_contact
        agency_name
        category
        secondary_category
        created_at
        background
        id
        location_coordinates
        title
        objective
        location_title
        project_profile_picture
        estimated_cost
      }
    }
    promotedProjects: promotions {
      message
      project {
        added_by
        agency_contact
        agency_name
        status
        is_active
        category
        secondary_category
        created_at
        background
        id
        location_coordinates
        title
        objective
        location_title
        project_profile_picture
        estimated_cost
      }
    }
    initiatedProjects: projects {
      added_by
      agency_contact
      agency_name
      status
      is_active
      category
      secondary_category
      created_at
      background
      id
      location_coordinates
      title
      objective
      location_title
      project_profile_picture
      estimated_cost
    }
    expressedProjects: expressions {
      investment_amount
      investment_type
      expression_message
      participation_type
      project {
        added_by
        agency_contact
        is_verified
        status
        is_active
        agency_name
        category
        secondary_category
        created_at
        background
        id
        location_coordinates
        title
        objective
        location_title
        project_profile_picture
        estimated_cost
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCurrentUserExpressesProjectDocument = gql`
    query getCurrentUserExpressesProject($user_id: uuid!) {
  projects(
    where: {_or: [{comments: {added_by: {_eq: $user_id}}, is_verified: {_eq: true}}, {expressions: {added_by: {_eq: $user_id}}, is_verified: {_eq: true}}]}
    order_by: {created_at: asc}
  ) {
    title
    location_coordinates
    location_title
    created_at
    project_profile_picture
    comments(order_by: {created_at: asc}) {
      id
      comment
      created_at
      parent_comment_id
    }
    expressions(order_by: {created_at: asc}) {
      id
      expression_message
      created_at
      investment_amount
    }
    user {
      id
      user_name
    }
  }
}
    `;

/**
 * __useGetCurrentUserExpressesProjectQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserExpressesProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserExpressesProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserExpressesProjectQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetCurrentUserExpressesProjectQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserExpressesProjectQuery, GetCurrentUserExpressesProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserExpressesProjectQuery, GetCurrentUserExpressesProjectQueryVariables>(GetCurrentUserExpressesProjectDocument, options);
      }
export function useGetCurrentUserExpressesProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserExpressesProjectQuery, GetCurrentUserExpressesProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserExpressesProjectQuery, GetCurrentUserExpressesProjectQueryVariables>(GetCurrentUserExpressesProjectDocument, options);
        }
export type GetCurrentUserExpressesProjectQueryHookResult = ReturnType<typeof useGetCurrentUserExpressesProjectQuery>;
export type GetCurrentUserExpressesProjectLazyQueryHookResult = ReturnType<typeof useGetCurrentUserExpressesProjectLazyQuery>;
export type GetCurrentUserExpressesProjectQueryResult = Apollo.QueryResult<GetCurrentUserExpressesProjectQuery, GetCurrentUserExpressesProjectQueryVariables>;
export const GetDashboardValuesDocument = gql`
    query getDashboardValues {
  pending_users_count: users_aggregate(where: {kyc_status: {_eq: pending}}) {
    aggregate {
      count
    }
  }
  all_users_count: users_aggregate {
    aggregate {
      count
    }
  }
  pending_project_count: projects_aggregate(where: {is_verified: {_eq: false}}) {
    aggregate {
      count
    }
  }
  approve_project_count: projects_aggregate(where: {is_verified: {_eq: true}}) {
    aggregate {
      count
    }
  }
  total_projects_count: projects_aggregate {
    aggregate {
      count
    }
  }
  active_project_count: projects_aggregate(where: {is_active: {_eq: true}}) {
    aggregate {
      count
    }
  }
  inactive_project_count: projects_aggregate(where: {is_active: {_eq: false}}) {
    aggregate {
      count
    }
  }
  unique_users_comments_count: comments_aggregate(
    distinct_on: added_by
    where: {is_deleted: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
  unique_users_expression_count: expressions_aggregate(
    distinct_on: added_by
    where: {is_deleted: {_eq: false}}
  ) {
    aggregate {
      count
    }
  }
  total_expression_count: expressions_aggregate {
    aggregate {
      count
    }
  }
  total_comments_count: comments_aggregate {
    aggregate {
      count
    }
  }
  pending_comments: comments(
    order_by: {created_at: desc}
    limit: 5
    where: {is_verified: {_eq: false}}
  ) {
    comment
  }
  approved_comments: comments(
    order_by: {created_at: desc}
    limit: 5
    where: {is_verified: {_eq: true}}
  ) {
    comment
  }
  rejected_comments: comments(
    limit: 5
    order_by: {created_at: desc}
    where: {is_deleted: {_eq: true}}
  ) {
    comment
  }
  recent_project_expressions: expressions(limit: 3, order_by: {created_at: desc}) {
    user {
      user_name
    }
    created_at
    project {
      title
    }
  }
  recent_project_comments: comments(limit: 3, order_by: {created_at: desc}) {
    user {
      user_name
    }
    created_at
    project {
      title
    }
  }
}
    `;

/**
 * __useGetDashboardValuesQuery__
 *
 * To run a query within a React component, call `useGetDashboardValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardValuesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardValuesQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardValuesQuery, GetDashboardValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardValuesQuery, GetDashboardValuesQueryVariables>(GetDashboardValuesDocument, options);
      }
export function useGetDashboardValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardValuesQuery, GetDashboardValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardValuesQuery, GetDashboardValuesQueryVariables>(GetDashboardValuesDocument, options);
        }
export type GetDashboardValuesQueryHookResult = ReturnType<typeof useGetDashboardValuesQuery>;
export type GetDashboardValuesLazyQueryHookResult = ReturnType<typeof useGetDashboardValuesLazyQuery>;
export type GetDashboardValuesQueryResult = Apollo.QueryResult<GetDashboardValuesQuery, GetDashboardValuesQueryVariables>;
export const GetDistrictsDocument = gql`
    query getDistricts($state: String!) {
  districts(distinct_on: district, where: {state: {_eq: $state}}) {
    id
    district
  }
  districts_aggregate(where: {state: {_eq: $state}}) {
    aggregate {
      count(columns: constituency)
    }
  }
}
    `;

/**
 * __useGetDistrictsQuery__
 *
 * To run a query within a React component, call `useGetDistrictsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistrictsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistrictsQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDistrictsQuery(baseOptions: Apollo.QueryHookOptions<GetDistrictsQuery, GetDistrictsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistrictsQuery, GetDistrictsQueryVariables>(GetDistrictsDocument, options);
      }
export function useGetDistrictsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistrictsQuery, GetDistrictsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistrictsQuery, GetDistrictsQueryVariables>(GetDistrictsDocument, options);
        }
export type GetDistrictsQueryHookResult = ReturnType<typeof useGetDistrictsQuery>;
export type GetDistrictsLazyQueryHookResult = ReturnType<typeof useGetDistrictsLazyQuery>;
export type GetDistrictsQueryResult = Apollo.QueryResult<GetDistrictsQuery, GetDistrictsQueryVariables>;
export const GetExpressionDocument = gql`
    query getExpression {
  expressions(order_by: {created_at: desc}) {
    expression_message
    investment_amount
    investment_type
    is_deleted
    is_verified
    participation_type
    project_id
    status
    id
    added_by
    created_at
    user {
      email_id
      user_name
    }
    project {
      title
      investment_amount
    }
  }
}
    `;

/**
 * __useGetExpressionQuery__
 *
 * To run a query within a React component, call `useGetExpressionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExpressionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExpressionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExpressionQuery(baseOptions?: Apollo.QueryHookOptions<GetExpressionQuery, GetExpressionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExpressionQuery, GetExpressionQueryVariables>(GetExpressionDocument, options);
      }
export function useGetExpressionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExpressionQuery, GetExpressionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExpressionQuery, GetExpressionQueryVariables>(GetExpressionDocument, options);
        }
export type GetExpressionQueryHookResult = ReturnType<typeof useGetExpressionQuery>;
export type GetExpressionLazyQueryHookResult = ReturnType<typeof useGetExpressionLazyQuery>;
export type GetExpressionQueryResult = Apollo.QueryResult<GetExpressionQuery, GetExpressionQueryVariables>;
export const GetKycStatusDocument = gql`
    query getKycStatus {
  users(
    where: {is_deleted: {_eq: false}, email_verified: {_eq: true}, kyc_status: {_is_null: false, _neq: rejected}}
    order_by: {kyc_submission_date: desc_nulls_last}
  ) {
    email_id
    kyc_status
    kyc_url
    id
    user_name
    kyc_submission_date
  }
}
    `;

/**
 * __useGetKycStatusQuery__
 *
 * To run a query within a React component, call `useGetKycStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKycStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKycStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKycStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetKycStatusQuery, GetKycStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKycStatusQuery, GetKycStatusQueryVariables>(GetKycStatusDocument, options);
      }
export function useGetKycStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKycStatusQuery, GetKycStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKycStatusQuery, GetKycStatusQueryVariables>(GetKycStatusDocument, options);
        }
export type GetKycStatusQueryHookResult = ReturnType<typeof useGetKycStatusQuery>;
export type GetKycStatusLazyQueryHookResult = ReturnType<typeof useGetKycStatusLazyQuery>;
export type GetKycStatusQueryResult = Apollo.QueryResult<GetKycStatusQuery, GetKycStatusQueryVariables>;
export const GetProjectDocument = gql`
    query getProject($id: uuid!) {
  projects(where: {id: {_eq: $id}}, order_by: {created_at: desc}) {
    id
    added_by
    agency_contact
    agency_name
    approved_value
    address
    detailed_address
    category
    secondary_category
    participant_type
    conditions
    background
    requirements
    benefits
    embedded_youtube_video
    participant_type
    end_date
    estimated_cost
    govt_authority_name
    impact_of_project
    investment_amount
    is_deleted
    is_verified
    is_active
    likes_count
    objective
    scope
    start_date
    project_status
    status
    title
    type
    project_profile_picture
    problem
    project_members {
      id
    }
    comments(order_by: {created_at: desc_nulls_last}) {
      updated_at
      status
      project_id
      is_verified
      created_at
      added_by
      comment
      id
      is_deleted
      user {
        id
        name
        user_name
        kyc_status
        email_id
        role
      }
    }
    likes {
      user_id
      project_id
      created_at
    }
    expressions(order_by: {created_at: desc_nulls_last}) {
      added_by
      created_at
      expression_message
      id
      investment_amount
      investment_type
      participation_type
      is_verified
      is_deleted
      project_id
      status
      updated_at
      user {
        id
        name
        user_name
        kyc_status
        email_id
      }
    }
    expressions_aggregate {
      aggregate {
        sum {
          investment_amount
        }
      }
    }
    question_answers {
      id
      question
      answer
      project_id
    }
    phone
    email
    location_coordinates
    location_title
    timelines(order_by: {date: desc_nulls_last}) {
      date
      id
      project_id
      title
      description
    }
    created_at
    project_assets {
      url
      file_name
      project_id
      id
      description
      created_at
      updated_at
      asset_type
    }
    user {
      location_title
      email_id
      mobile
      name
      user_name
      kyc_status
    }
    images {
      image_url
    }
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectAnalyticsDocument = gql`
    query getProjectAnalytics($id: uuid!) {
  projects_by_pk(id: $id) {
    id
    title
    project_status
    estimated_cost
    comments_aggregate {
      aggregate {
        count
      }
    }
    expressions_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetProjectAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetProjectAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAnalyticsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectAnalyticsQuery, GetProjectAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAnalyticsQuery, GetProjectAnalyticsQueryVariables>(GetProjectAnalyticsDocument, options);
      }
export function useGetProjectAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAnalyticsQuery, GetProjectAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAnalyticsQuery, GetProjectAnalyticsQueryVariables>(GetProjectAnalyticsDocument, options);
        }
export type GetProjectAnalyticsQueryHookResult = ReturnType<typeof useGetProjectAnalyticsQuery>;
export type GetProjectAnalyticsLazyQueryHookResult = ReturnType<typeof useGetProjectAnalyticsLazyQuery>;
export type GetProjectAnalyticsQueryResult = Apollo.QueryResult<GetProjectAnalyticsQuery, GetProjectAnalyticsQueryVariables>;
export const GetTotalInvitesDocument = gql`
    query getTotalInvites {
  invite_links_aggregate(where: {is_all: {_eq: true}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetTotalInvitesQuery__
 *
 * To run a query within a React component, call `useGetTotalInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTotalInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTotalInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTotalInvitesQuery(baseOptions?: Apollo.QueryHookOptions<GetTotalInvitesQuery, GetTotalInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTotalInvitesQuery, GetTotalInvitesQueryVariables>(GetTotalInvitesDocument, options);
      }
export function useGetTotalInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTotalInvitesQuery, GetTotalInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTotalInvitesQuery, GetTotalInvitesQueryVariables>(GetTotalInvitesDocument, options);
        }
export type GetTotalInvitesQueryHookResult = ReturnType<typeof useGetTotalInvitesQuery>;
export type GetTotalInvitesLazyQueryHookResult = ReturnType<typeof useGetTotalInvitesLazyQuery>;
export type GetTotalInvitesQueryResult = Apollo.QueryResult<GetTotalInvitesQuery, GetTotalInvitesQueryVariables>;
export const GetProjectAnalyticsChartDocument = gql`
    query getProjectAnalyticsChart($projectId: uuid = "") {
  expressions(order_by: {created_at: asc}, where: {project_id: {_eq: $projectId}}) {
    investment_amount
    id
    created_at
  }
}
    `;

/**
 * __useGetProjectAnalyticsChartQuery__
 *
 * To run a query within a React component, call `useGetProjectAnalyticsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAnalyticsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAnalyticsChartQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectAnalyticsChartQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectAnalyticsChartQuery, GetProjectAnalyticsChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAnalyticsChartQuery, GetProjectAnalyticsChartQueryVariables>(GetProjectAnalyticsChartDocument, options);
      }
export function useGetProjectAnalyticsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAnalyticsChartQuery, GetProjectAnalyticsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAnalyticsChartQuery, GetProjectAnalyticsChartQueryVariables>(GetProjectAnalyticsChartDocument, options);
        }
export type GetProjectAnalyticsChartQueryHookResult = ReturnType<typeof useGetProjectAnalyticsChartQuery>;
export type GetProjectAnalyticsChartLazyQueryHookResult = ReturnType<typeof useGetProjectAnalyticsChartLazyQuery>;
export type GetProjectAnalyticsChartQueryResult = Apollo.QueryResult<GetProjectAnalyticsChartQuery, GetProjectAnalyticsChartQueryVariables>;
export const GetProjectsDocument = gql`
    query getProjects($limit: Int, $offset: Int!) {
  projects(limit: $limit, offset: $offset) {
    id
    added_by
    agency_contact
    agency_name
    approved_value
    category
    secondary_category
    participant_type
    location_title
    has_liked
    project_profile_picture
    is_active
    comments {
      is_verified
      is_deleted
      id
      comment
      added_by
      created_at
      project_id
      status
      updated_at
      user {
        id
        name
        user_name
        kyc_status
        email_id
      }
    }
    conditions
    background
    embedded_youtube_video
    participant_type
    end_date
    estimated_cost
    govt_authority_name
    impact_of_project
    investment_amount
    is_deleted
    is_verified
    likes_count
    owner {
      user_name
    }
    likes {
      created_at
      project_id
      project {
        added_by
        agency_contact
        agency_name
        approved_value
        category
        conditions
        background
        embedded_youtube_video
        end_date
        estimated_cost
        likes_count
        investment_amount
        is_deleted
        is_verified
        impact_of_project
        govt_authority_name
        id
        type
        title
        status
        start_date
        scope
        objective
      }
      user_id
    }
    project_assets {
      id
      asset_type
      file_name
      description
      url
    }
    objective
    scope
    start_date
    status
    title
    type
    expressions {
      status
      project_id
      updated_at
      is_verified
      investment_amount
      participation_type
      expression_message
      added_by
      created_at
      participation_type
      investment_type
      is_deleted
      id
    }
    expressions_aggregate {
      aggregate {
        sum {
          investment_amount
        }
      }
    }
    location_coordinates
    location_title
  }
}
    `;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetProjectsAggregationDocument = gql`
    query getProjectsAggregation {
  projects_aggregate {
    aggregate {
      count
    }
  }
  distinct_aggregate: projects_aggregate(distinct_on: added_by) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetProjectsAggregationQuery__
 *
 * To run a query within a React component, call `useGetProjectsAggregationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsAggregationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsAggregationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsAggregationQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsAggregationQuery, GetProjectsAggregationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsAggregationQuery, GetProjectsAggregationQueryVariables>(GetProjectsAggregationDocument, options);
      }
export function useGetProjectsAggregationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsAggregationQuery, GetProjectsAggregationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsAggregationQuery, GetProjectsAggregationQueryVariables>(GetProjectsAggregationDocument, options);
        }
export type GetProjectsAggregationQueryHookResult = ReturnType<typeof useGetProjectsAggregationQuery>;
export type GetProjectsAggregationLazyQueryHookResult = ReturnType<typeof useGetProjectsAggregationLazyQuery>;
export type GetProjectsAggregationQueryResult = Apollo.QueryResult<GetProjectsAggregationQuery, GetProjectsAggregationQueryVariables>;
export const GetPromotedProjectsDocument = gql`
    query getPromotedProjects {
  project_promotions {
    project {
      id
      title
      location_title
      project_profile_picture
    }
    project_id
    message
  }
}
    `;

/**
 * __useGetPromotedProjectsQuery__
 *
 * To run a query within a React component, call `useGetPromotedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPromotedProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetPromotedProjectsQuery, GetPromotedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPromotedProjectsQuery, GetPromotedProjectsQueryVariables>(GetPromotedProjectsDocument, options);
      }
export function useGetPromotedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPromotedProjectsQuery, GetPromotedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPromotedProjectsQuery, GetPromotedProjectsQueryVariables>(GetPromotedProjectsDocument, options);
        }
export type GetPromotedProjectsQueryHookResult = ReturnType<typeof useGetPromotedProjectsQuery>;
export type GetPromotedProjectsLazyQueryHookResult = ReturnType<typeof useGetPromotedProjectsLazyQuery>;
export type GetPromotedProjectsQueryResult = Apollo.QueryResult<GetPromotedProjectsQuery, GetPromotedProjectsQueryVariables>;
export const GetRegionAdminDocument = gql`
    query getRegionAdmin {
  users(limit: 1, where: {role: {_eq: admin}}) {
    id
  }
}
    `;

/**
 * __useGetRegionAdminQuery__
 *
 * To run a query within a React component, call `useGetRegionAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionAdminQuery, GetRegionAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionAdminQuery, GetRegionAdminQueryVariables>(GetRegionAdminDocument, options);
      }
export function useGetRegionAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionAdminQuery, GetRegionAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionAdminQuery, GetRegionAdminQueryVariables>(GetRegionAdminDocument, options);
        }
export type GetRegionAdminQueryHookResult = ReturnType<typeof useGetRegionAdminQuery>;
export type GetRegionAdminLazyQueryHookResult = ReturnType<typeof useGetRegionAdminLazyQuery>;
export type GetRegionAdminQueryResult = Apollo.QueryResult<GetRegionAdminQuery, GetRegionAdminQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  users(order_by: {created_at: asc}) {
    ...GetUserFragment
  }
}
    ${GetUserFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
    query getUser($user_id: uuid!) {
  users_by_pk(id: $user_id) {
    ...GetUserFragment
  }
}
    ${GetUserFragmentFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersWhoJoinedWithoutInviteDocument = gql`
    query getUsersWhoJoinedWithoutInvite {
  users(where: {_not: {invited_by: {id: {_is_null: false}}}}) {
    ...GetUserFragment
  }
}
    ${GetUserFragmentFragmentDoc}`;

/**
 * __useGetUsersWhoJoinedWithoutInviteQuery__
 *
 * To run a query within a React component, call `useGetUsersWhoJoinedWithoutInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWhoJoinedWithoutInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWhoJoinedWithoutInviteQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersWhoJoinedWithoutInviteQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersWhoJoinedWithoutInviteQuery, GetUsersWhoJoinedWithoutInviteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersWhoJoinedWithoutInviteQuery, GetUsersWhoJoinedWithoutInviteQueryVariables>(GetUsersWhoJoinedWithoutInviteDocument, options);
      }
export function useGetUsersWhoJoinedWithoutInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWhoJoinedWithoutInviteQuery, GetUsersWhoJoinedWithoutInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersWhoJoinedWithoutInviteQuery, GetUsersWhoJoinedWithoutInviteQueryVariables>(GetUsersWhoJoinedWithoutInviteDocument, options);
        }
export type GetUsersWhoJoinedWithoutInviteQueryHookResult = ReturnType<typeof useGetUsersWhoJoinedWithoutInviteQuery>;
export type GetUsersWhoJoinedWithoutInviteLazyQueryHookResult = ReturnType<typeof useGetUsersWhoJoinedWithoutInviteLazyQuery>;
export type GetUsersWhoJoinedWithoutInviteQueryResult = Apollo.QueryResult<GetUsersWhoJoinedWithoutInviteQuery, GetUsersWhoJoinedWithoutInviteQueryVariables>;
export const GetInviteLinksGeneratedByIndividualUsersDocument = gql`
    query getInviteLinksGeneratedByIndividualUsers {
  invite_links_aggregate(
    where: {user: {_not: {invited_by: {id: {_is_null: false}}}, role: {_neq: admin}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetInviteLinksGeneratedByIndividualUsersQuery__
 *
 * To run a query within a React component, call `useGetInviteLinksGeneratedByIndividualUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInviteLinksGeneratedByIndividualUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInviteLinksGeneratedByIndividualUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInviteLinksGeneratedByIndividualUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetInviteLinksGeneratedByIndividualUsersQuery, GetInviteLinksGeneratedByIndividualUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInviteLinksGeneratedByIndividualUsersQuery, GetInviteLinksGeneratedByIndividualUsersQueryVariables>(GetInviteLinksGeneratedByIndividualUsersDocument, options);
      }
export function useGetInviteLinksGeneratedByIndividualUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInviteLinksGeneratedByIndividualUsersQuery, GetInviteLinksGeneratedByIndividualUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInviteLinksGeneratedByIndividualUsersQuery, GetInviteLinksGeneratedByIndividualUsersQueryVariables>(GetInviteLinksGeneratedByIndividualUsersDocument, options);
        }
export type GetInviteLinksGeneratedByIndividualUsersQueryHookResult = ReturnType<typeof useGetInviteLinksGeneratedByIndividualUsersQuery>;
export type GetInviteLinksGeneratedByIndividualUsersLazyQueryHookResult = ReturnType<typeof useGetInviteLinksGeneratedByIndividualUsersLazyQuery>;
export type GetInviteLinksGeneratedByIndividualUsersQueryResult = Apollo.QueryResult<GetInviteLinksGeneratedByIndividualUsersQuery, GetInviteLinksGeneratedByIndividualUsersQueryVariables>;
export const GetUsersWhoJoinedWithoutInviteCountDocument = gql`
    query getUsersWhoJoinedWithoutInviteCount {
  users_aggregate(where: {_not: {invited_by: {id: {_is_null: false}}}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetUsersWhoJoinedWithoutInviteCountQuery__
 *
 * To run a query within a React component, call `useGetUsersWhoJoinedWithoutInviteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersWhoJoinedWithoutInviteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersWhoJoinedWithoutInviteCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersWhoJoinedWithoutInviteCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersWhoJoinedWithoutInviteCountQuery, GetUsersWhoJoinedWithoutInviteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersWhoJoinedWithoutInviteCountQuery, GetUsersWhoJoinedWithoutInviteCountQueryVariables>(GetUsersWhoJoinedWithoutInviteCountDocument, options);
      }
export function useGetUsersWhoJoinedWithoutInviteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersWhoJoinedWithoutInviteCountQuery, GetUsersWhoJoinedWithoutInviteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersWhoJoinedWithoutInviteCountQuery, GetUsersWhoJoinedWithoutInviteCountQueryVariables>(GetUsersWhoJoinedWithoutInviteCountDocument, options);
        }
export type GetUsersWhoJoinedWithoutInviteCountQueryHookResult = ReturnType<typeof useGetUsersWhoJoinedWithoutInviteCountQuery>;
export type GetUsersWhoJoinedWithoutInviteCountLazyQueryHookResult = ReturnType<typeof useGetUsersWhoJoinedWithoutInviteCountLazyQuery>;
export type GetUsersWhoJoinedWithoutInviteCountQueryResult = Apollo.QueryResult<GetUsersWhoJoinedWithoutInviteCountQuery, GetUsersWhoJoinedWithoutInviteCountQueryVariables>;
export const MeDocument = gql`
    query ME($id: uuid!) {
  users_by_pk(id: $id) {
    id
    name
    role
    is_invited_to_all_projects
    profile_picture
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMeQuery(baseOptions: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;